export const howToData = {
  "manual-testing": {
    title: "Manual Testing Essentials",
    qa: [
      {
        "q": "1. What is Software Testing?",
        "a": [
          "Software testing is the process of evaluating a system to find defects.",
          "It ensures the application meets requirements and works as expected.",
          "Helps improve quality, reliability, and performance.",
          "Identifies gaps between expected and actual results.",
          "Done manually or using automation tools."
        ]
      },
      {
        "q": "2. What is Manual Testing?",
        "a": [
          "Manual testing is testing software without automation tools.",
          "Testers execute test cases manually.",
          "Focuses on user behavior and UI validation.",
          "Useful for exploratory, usability, and ad-hoc testing.",
          "Requires strong domain and analytical skills."
        ]
      },
      {
        "q": "3. What is SDLC?",
        "a": [
          "Software Development Life Cycle is a process for building software.",
          "Phases: Requirement → Design → Development → Testing → Deployment → Maintenance.",
          "Ensures structured and quality-driven development.",
          "Testing phase validates developed features.",
          "Different models include Agile, Waterfall, etc."
        ]
      },
      {
        "q": "4. What is STLC?",
        "a": [
          "Software Testing Life Cycle defines testing activities.",
          "Phases: Requirement Analysis → Test Planning → Test Design → Execution → Reporting → Closure.",
          "Ensures systematic testing process.",
          "Helps track quality metrics.",
          "Improves test coverage and efficiency."
        ]
      },
      {
        "q": "5. What is Test Case?",
        "a": [
          "A test case is a set of steps to verify a feature.",
          "Includes inputs, expected results, and conditions.",
          "Helps ensure functionality works correctly.",
          "Used for regression and validation.",
          "Written based on requirements."
        ]
      },
      {
        "q": "6. What is Test Scenario?",
        "a": [
          "A high-level description of what to test.",
          "Covers end-to-end functionality.",
          "Helps identify test cases."
        ]
      },
      {
        "q": "Example: “Login functionality validation.”",
        "a": [
          "Focuses on user actions."
        ]
      },
      {
        "q": "7. Difference between Test Case and Test Scenario?",
        "a": [
          "Scenario → High-level (what to test).",
          "Test Case → Detailed (how to test).",
          "Scenario covers multiple test cases.",
          "Test case includes steps and expected results.",
          "Scenario is broader, test case is specific."
        ]
      },
      {
        "q": "8. What is Bug/Defect?",
        "a": [
          "A bug is a deviation from expected behavior.",
          "Occurs due to coding or requirement issues.",
          "Identified during testing.",
          "Logged in defect tracking tools.",
          "Needs to be fixed before release."
        ]
      },
      {
        "q": "9. What is Defect Life Cycle?",
        "a": [
          "New → Assigned → Open → Fixed → Retest → Closed.",
          "If not fixed → Reopened.",
          "Tracks defect progress.",
          "Helps manage bug resolution.",
          "Ensures quality control."
        ]
      },
      {
        "q": "10. Severity vs Priority?",
        "a": [
          "Severity → Impact of defect.",
          "Priority → Urgency to fix.",
          "High severity may not always be high priority."
        ]
      },
      {
        "q": "Example: UI issue = low severity but high priority.",
        "a": [
          "Decided by testers and business teams."
        ]
      },
      {
        "q": "11. What is Regression Testing?",
        "a": [
          "Testing existing functionality after changes.",
          "Ensures new changes don’t break old features.",
          "Important in Agile and continuous delivery.",
          "Uses regression test suite.",
          "Can be manual or automated."
        ]
      },
      {
        "q": "12. What is Smoke Testing?",
        "a": [
          "Basic testing to check build stability.",
          "Ensures critical functionalities work.",
          "Done after new build deployment.",
          "Also called Build Verification Testing.",
          "If fails → build rejected."
        ]
      },
      {
        "q": "13. What is Sanity Testing?",
        "a": [
          "Quick testing after minor changes.",
          "Focuses on specific functionality.",
          "Ensures bug fixes work properly.",
          "Narrow and deep testing.",
          "Done before regression testing."
        ]
      },
      {
        "q": "14. What is Retesting?",
        "a": [
          "Testing a specific defect after fix.",
          "Ensures bug is resolved.",
          "Uses same test case.",
          "Done after developer fix.",
          "Different from regression testing."
        ]
      },
      {
        "q": "15. What is Exploratory Testing?",
        "a": [
          "Testing without predefined test cases.",
          "Tester explores application freely.",
          "Focuses on uncovering hidden bugs.",
          "Requires experience and creativity.",
          "Useful for complex systems."
        ]
      },
      {
        "q": "16. What is Ad-hoc Testing?",
        "a": [
          "Informal testing without planning.",
          "No documentation required.",
          "Done randomly to find defects.",
          "Quick and flexible approach.",
          "Depends on tester knowledge."
        ]
      },
      {
        "q": "17. What is Black Box Testing?",
        "a": [
          "Testing without knowledge of internal code.",
          "Focuses on inputs and outputs.",
          "Based on requirements.",
          "Used in functional testing.",
          "Common in manual testing."
        ]
      },
      {
        "q": "18. What is White Box Testing?",
        "a": [
          "Testing with knowledge of code structure.",
          "Focuses on logic and flow.",
          "Usually done by developers.",
          "Includes unit testing.",
          "Ensures code quality."
        ]
      },
      {
        "q": "19. What is Gray Box Testing?",
        "a": [
          "Combination of black and white box testing.",
          "Tester has partial knowledge of system.",
          "Used in integration testing.",
          "Improves coverage.",
          "Helps find hidden defects."
        ]
      },
      {
        "q": "20. What is Test Plan?",
        "a": [
          "Document describing testing strategy.",
          "Includes scope, objectives, and resources.",
          "Defines timelines and responsibilities.",
          "Helps manage testing activities.",
          "Prepared by test lead/manager."
        ]
      },
      {
        "q": "21. What is Test Strategy?",
        "a": [
          "High-level testing approach.",
          "Defines testing methods and standards.",
          "Part of test plan or separate document.",
          "Guides testing process.",
          "Ensures consistency."
        ]
      },
      {
        "q": "22. What is Use Case Testing?",
        "a": [
          "Testing based on user actions.",
          "Derived from use cases.",
          "Covers real-world scenarios.",
          "Focuses on end-user behavior.",
          "Ensures system usability."
        ]
      },
      {
        "q": "23. What is Boundary Value Analysis?",
        "a": [
          "Tests values at boundaries."
        ]
      },
      {
        "q": "Example: 1–100 → test 0,1,100,101.",
        "a": [
          "Finds edge-case defects.",
          "Reduces test cases.",
          "Effective for numeric inputs."
        ]
      },
      {
        "q": "24. What is Equivalence Partitioning?",
        "a": [
          "Divides input data into groups.",
          "Tests one value from each group.",
          "Reduces number of test cases.",
          "Improves efficiency.",
          "Ensures coverage."
        ]
      },
      {
        "q": "25. What is Test Data?",
        "a": [
          "Data used to execute test cases.",
          "Includes valid and invalid inputs.",
          "Helps validate functionality.",
          "Can be real or dummy data.",
          "Important for accuracy."
        ]
      },
      {
        "q": "26. What is UAT (User Acceptance Testing)?",
        "a": [
          "Final testing by end users.",
          "Validates business requirements.",
          "Ensures system is ready for release.",
          "Conducted in real environment.",
          "Approval needed for deployment."
        ]
      },
      {
        "q": "27. What is Acceptance Criteria?",
        "a": [
          "Conditions that must be met.",
          "Defines success of feature.",
          "Used in Agile user stories.",
          "Helps testers validate functionality.",
          "Clear and measurable."
        ]
      },
      {
        "q": "28. What is Test Coverage?",
        "a": [
          "Measure of testing completeness.",
          "Ensures all features are tested.",
          "Includes requirement coverage.",
          "Improves quality.",
          "Important metric."
        ]
      },
      {
        "q": "29. What is Risk-Based Testing?",
        "a": [
          "Focuses on high-risk areas.",
          "Prioritizes critical functionalities.",
          "Saves time and effort.",
          "Ensures important features are tested first.",
          "Used in tight deadlines."
        ]
      },
      {
        "q": "30. What is Traceability Matrix (RTM)?",
        "a": [
          "Maps requirements to test cases.",
          "Ensures full coverage.",
          "Tracks missing requirements.",
          "Helps in impact analysis.",
          "Important QA document."
        ]
      },
      {
        "q": "Q1. How do you test a feature without requirements?",
        "a": [
          "Start with exploratory testing based on UI and user flow",
          "Use past experience + similar applications",
          "Talk to stakeholders (PO, Dev) for clarification",
          "Identify happy path + edge cases",
          "Create mind map / test scenarios",
          "Focus on usability + business impact"
        ]
      },
      {
        "q": "Q2. How do you prioritize testing in tight deadlines?",
        "a": [
          "Use risk-based testing",
          "Prioritize:",
          "Critical business flows",
          "High-usage features",
          "Previously failed areas",
          "Skip low-impact scenarios initially",
          "Focus on smoke + sanity first",
          "Communicate coverage gaps clearly"
        ]
      },
      {
        "q": "Q3. How do you handle frequent requirement changes (Agile)?",
        "a": [
          "Keep test cases modular and reusable",
          "Focus on test scenarios instead of rigid cases",
          "Update RTM dynamically",
          "Do continuous regression testing",
          "Collaborate closely with dev & PO",
          "Use exploratory testing heavily"
        ]
      },
      {
        "q": "Q4. What would you do if developers say “bug not reproducible”?",
        "a": [
          "Re-test with exact steps + environment",
          "Provide:",
          "Logs",
          "Screenshots/videos",
          "Test data",
          "Try different scenarios",
          "Pair with developer if needed",
          "If still not reproducible → mark accordingly with evidence"
        ]
      },
      {
        "q": "Q5. How do you ensure complete test coverage?",
        "a": [
          "Use Requirement Traceability Matrix (RTM)",
          "Cover:",
          "Positive cases",
          "Negative cases",
          "Edge cases",
          "Include:",
          "UI + API + DB validations",
          "Perform exploratory testing",
          "Review with team"
        ]
      },
      {
        "q": "Q6. How do you test APIs manually?",
        "a": [
          "Use tools like Postman",
          "Validate:",
          "Status codes",
          "Response body",
          "Headers",
          "Check:",
          "Authentication",
          "Negative scenarios",
          "Compare with DB if needed",
          "Validate performance basics"
        ]
      },
      {
        "q": "Q7. What is your approach to test a complex system?",
        "a": [
          "Break system into modules",
          "Understand data flow",
          "Identify integration points",
          "Create high-level scenarios first",
          "Then deep dive into edge cases",
          "Focus on end-to-end flow"
        ]
      },
      {
        "q": "Scenario 1: Login Feature",
        "a": [
          "Test cases:",
          "Valid login",
          "Invalid credentials",
          "Empty fields",
          "SQL injection",
          "Password masking",
          "Edge cases:",
          "Max length",
          "Special characters",
          "Security:",
          "Lock after multiple attempts",
          "API validation:",
          "Check login API response"
        ]
      },
      {
        "q": "Scenario 2: E-commerce Checkout",
        "a": [
          "Validate:",
          "Add to cart",
          "Quantity update",
          "Price calculation",
          "Payment:",
          "Success/failure",
          "Edge cases:",
          "Network failure during payment",
          "Verify:",
          "Order created",
          "Email confirmation",
          "Backend:",
          "DB entry validation"
        ]
      },
      {
        "q": "Scenario 3: File Upload",
        "a": [
          "Test:",
          "Valid file types",
          "Invalid formats",
          "Large file size",
          "Edge cases:",
          "Cancel upload",
          "Slow network",
          "Security:",
          "Malware files",
          "Validate:",
          "File stored correctly",
          "UI feedback"
        ]
      },
      {
        "q": "Scenario 4: API Failure Handling",
        "a": [
          "Simulate:",
          "500 error",
          "Timeout",
          "Verify:",
          "UI error message",
          "Retry mechanism",
          "Check logs",
          "Ensure no crash"
        ]
      },
      {
        "q": "Example 1: Critical Bug",
        "a": [
          "Bug: Payment successful but order not created",
          "Steps to reproduce",
          "Expected vs actual",
          "Impact: Revenue loss (HIGH severity)",
          "Attach logs + screenshots",
          "Mention environment"
        ]
      },
      {
        "q": "Example 2: UI Bug",
        "a": [
          "Bug: Button misaligned",
          "Low severity",
          "High priority if user-facing",
          "Affects UX",
          "Easy fix"
        ]
      },
      {
        "q": "Example 3: Functional Bug",
        "a": [
          "Bug: Negative quantity accepted in cart",
          "Logic issue",
          "Affects calculations",
          "Medium severity",
          "Needs validation fix"
        ]
      },
      {
        "q": "Example 4: Performance Bug",
        "a": [
          "Bug: Page takes 10 seconds to load",
          "Impacts user experience",
          "Could be backend/API issue",
          "Needs performance optimization"
        ]
      },
      {
        "q": "Example: Login Page",
        "a": [
          "Test Case 1: Valid Login",
          "Steps:",
          "Enter valid username/password",
          "Click login",
          "Expected:",
          "User navigates to dashboard",
          "Test Case 2: Invalid Login",
          "Steps:",
          "Enter wrong credentials",
          "Expected:",
          "Error message displayed",
          "Test Case 3: Empty Fields",
          "Steps:",
          "Click login without input",
          "Expected:",
          "Validation message",
          "Test Case 4: Password Masking",
          "Steps:",
          "Enter password",
          "Expected:",
          "Password hidden",
          "Test Case 5: SQL Injection",
          "Input:",
          "' OR 1=1 --",
          "Expected:",
          "Login should fail"
        ]
      }
    ]
  },
  "automation-testing": {
    title: "Automation Testing",
    qa: [
      {
        q: "[Beginner] What is Test Automation and when should you automate testing?",
        a: [
          "Test Automation is the practice of running software tests automatically using tool scripts, managing test data, and analyzing execution results.",
          "When to automate:",
          "1. Regression Testing: Repeatedly running the same suite on every code change.",
          "2. Performance & Load Testing: Simulating hundreds of concurrent users.",
          "3. Repetitive/Time-Consuming Tasks: Large form submissions or multi-browser matrix checks.",
          "4. Smoke/Sanity Tests: Verifying build stability immediately upon deployment."
        ]
      },
      {
        q: "[Beginner] What is the difference between Manual Testing and Automation Testing?",
        a: [
          "Manual Testing is executed by human testers who manually click and interact with the application. Best for exploratory, usability, and ad-hoc checks. Higher human-effort cost over time.",
          "Automation Testing uses automated scripts to execute test steps. Best for high-volume, regression, and CI/CD validation. Higher initial setup time and cost, but faster execution and lower cost over repetitive runs."
        ]
      },
      {
        q: "[Beginner] What are the common types of testing that can be automated?",
        a: [
          "1. Unit Testing: Testing individual code modules (functions/methods).",
          "2. Integration Testing: Verifying correct communication between combined modules/APIs.",
          "3. Functional/UI Testing: Simulating user workflows through the front-end browser.",
          "4. API Testing: Direct validation of backend endpoints.",
          "5. Performance/Load Testing: Stress-testing application speed and memory scalability."
        ]
      },
      {
        q: "[Beginner] What are the major automation tools available in the industry?",
        a: [
          "1. Selenium: The industry standard for browser automation, supporting multiple languages (Java, Python, C#).",
          "2. Playwright: Modern, fast browser automation framework by Microsoft with native auto-waiting and network interception.",
          "3. Cypress: Developer-friendly, JS-based frontend testing framework running directly inside the browser execution loop.",
          "4. Appium: Open-source framework for automating native, hybrid, and mobile web applications.",
          "5. RestAssured: Popular Java library for REST API validation."
        ]
      },
      {
        q: "[Beginner] What are locators and why are they important in automation?",
        a: [
          "Locators are command parameters used by automation frameworks to identify and target specific HTML elements on a page.",
          "Common locator types:",
          "- ID: The fastest and most reliable locator (if unique).",
          "- Name/ClassName: Useful for forms and lists.",
          "- XPath: Navigates DOM trees bi-directionally.",
          "- CSS Selector: Sleek, high-performance selector strategy."
        ]
      },
      {
        q: "[Beginner] What is the difference between findElement() and findElements() in Selenium?",
        a: [
          "findElement(): Looks for a single element matching the locator and returns it. Throws a NoSuchElementException immediately if no match is found.",
          "findElements(): Looks for all elements matching the criteria and returns them inside a List. Returns an empty list if no match is found, without throwing exceptions."
        ]
      },
      {
        q: "[Beginner] What is the difference between close() and quit() in Selenium?",
        a: [
          "close(): Closes the single browser window or tab that currently has active focus.",
          "quit(): Closes all open windows/tabs, destroys the driver execution process, and releases background memory."
        ]
      },
      {
        q: "[Beginner] What is the purpose of assertions in automation?",
        a: [
          "Assertions are validation checkpoints. They compare the actual application state against the expected behavior.",
          "If the assertion evaluates to true, the test passes; if it evaluates to false, execution halts (or logs a failure) and the test fails."
        ]
      },
      {
        q: "[Beginner] What is a test runner?",
        a: [
          "A test runner is a framework component that reads, executes, and orchestrates test suites. It manages parallel threads, assertion reporting, setups, and teardowns.",
          "Examples: TestNG/JUnit (Java), PyTest (Python), Mocha/Jest (JavaScript)."
        ]
      },
      {
        q: "[Beginner] What is headless browser execution?",
        a: [
          "Headless execution is running web tests without opening the browser graphical user interface (GUI). Tests run in background memory, which is faster and consumes fewer resources, making it ideal for CI/CD containers."
        ]
      },
      {
        q: "[Intermediate] Explain the difference between Implicit, Explicit, and Fluent Waits.",
        a: [
          "Implicit Wait: A global timeout applied to the driver instance. The driver will wait up to this threshold for *every* element search before throwing NoSuchElementException.",
          "Explicit Wait: Applied to a specific element with defined ExpectedConditions (e.g. visibilityOf, elementToBeClickable). Best practice for handling dynamic load times.",
          "Fluent Wait: Similar to Explicit Wait but allows customization of the polling interval and specific exceptions to ignore (e.g., NoSuchElementException) while waiting."
        ]
      },
      {
        q: "[Intermediate] What is the Page Object Model (POM) and why is it used?",
        a: [
          "POM is a design pattern where each web page is represented as a separate class.",
          "Benefits:",
          "1. Maintainability: If a UI element changes, you only update its locator inside its Page Class, rather than updating multiple test files.",
          "2. Reusability: Reusable action methods can be called across multiple test cases.",
          "3. Code Readability: Separates element selectors and user actions from the actual test script assertions."
        ]
      },
      {
        q: "[Intermediate] Explain the difference between Page Object Model (POM) and Page Factory.",
        a: [
          "POM is a design pattern dividing page concerns into separate classes.",
          "Page Factory is a Selenium-specific class that implements POM with lazy-initialization using `@FindBy` annotations. Elements are located only when an action is performed, rather than on page instantiation."
        ]
      },
      {
        q: "[Intermediate] How do you handle dynamic web elements whose IDs change on refresh?",
        a: [
          "1. Relative XPath: Match static parts of attributes (e.g. `//button[contains(@id, 'submit')]` or `//button[starts-with(@id, 'btn_')]`).",
          "2. Dom Hierarchy: Navigate from a static parent element down to the dynamic child element.",
          "3. Text-Based locators: Match elements by stable user-facing texts (e.g. Playwright's `getByText()`)."
        ]
      },
      {
        q: "[Intermediate] How do you handle dropdown elements (select tag) in Selenium vs. Playwright?",
        a: [
          "Selenium: Use the Select wrapper class: `Select select = new Select(element); select.selectByVisibleText(\"US\");`",
          "Playwright: Use the selectOption locator action directly: `await page.locator('select').selectOption('US');`"
        ]
      },
      {
        q: "[Intermediate] How do you automate mouse actions like hover, double-click, and drag-and-drop in Selenium?",
        a: [
          "Use the Actions class helper to build and execute user interactions:",
          "Actions actions = new Actions(driver);",
          "actions.moveToElement(hoverElement).perform(); // Hover",
          "actions.doubleClick(targetElement).perform(); // Double Click",
          "actions.dragAndDrop(source, target).perform(); // Drag and Drop"
        ]
      },
      {
        q: "[Intermediate] How do you handle iframes and nested frames in automation?",
        a: [
          "You must switch the execution context into the frame before interacting with inner elements, and switch back to default content when finished:",
          "Selenium: `driver.switchTo().frame(\"frame-id\");` and switch back using `driver.switchTo().defaultContent();`",
          "Playwright: Auto-manages frame context using `page.frameLocator('iframe-selector')` which supports auto-waiting."
        ]
      },
      {
        q: "[Intermediate] How do you handle multiple window handles or tabs during execution?",
        a: [
          "Collect all open window handles, iterate and switch driver focus to the target window, perform actions, close it, and switch back:",
          "String parent = driver.getWindowHandle();",
          "Set<String> allWindows = driver.getWindowHandles();",
          "for(String handle : allWindows) {",
          "   if(!handle.equals(parent)) {",
          "       driver.switchTo().window(handle);",
          "       // actions...",
          "       driver.close();",
          "   }",
          "}",
          "driver.switchTo().window(parent);"
        ]
      },
      {
        q: "[Intermediate] What are hard assertions vs soft assertions?",
        a: [
          "Hard Assertion: Immediately halts test execution when it fails. Best for critical checks (e.g. verifying database connection or successful login).",
          "Soft Assertion: Logs the failure but continues executing subsequent test steps. Best for checking multiple non-blocking properties on a page (e.g. verifying headers, footers, logo alignments)."
        ]
      },
      {
        q: "[Intermediate] How do you configure and run tests in parallel?",
        a: [
          "Configure parallel thread counts inside test runner configurations:",
          "- TestNG: Set `parallel=\"methods\" thread-count=\"5\"` inside `testng.xml`.",
          "- Playwright: Enable `fullyParallel: true` in `playwright.config.js`.",
          "- Maven: Configure the Maven Surefire Plugin with thread counts."
        ]
      },
      {
        q: "[Intermediate] What is Data-Driven Testing and how is it implemented?",
        a: [
          "Data-Driven Testing is executing the same test steps repeatedly using different sets of input data retrieved from external sources.",
          "Implementation:",
          "- TestNG: Use `@DataProvider` annotations mapped to methods.",
          "- JUnit: Use parameterized tests `@ParameterizedTest`.",
          "- Data sources: Excel files (.xlsx), CSV, JSON payloads, or databases."
        ]
      },
      {
        q: "[Intermediate] How do you handle alert popups (alerts, confirms, prompts)?",
        a: [
          "Selenium: Switch to the alert context: `Alert alert = driver.switchTo().alert(); alert.accept();` or `alert.dismiss();`",
          "Playwright: Dialogs are auto-dismissed by default. Handle them explicitly by registering listeners: `page.on('dialog', dialog => dialog.accept());`"
        ]
      },
      {
        q: "[Intermediate] How do you capture screenshots during test failures dynamically?",
        a: [
          "Implement test listeners (e.g., TestNG's `ITestListener` or Playwright's default runner reporter). On test failure event hook, capture the browser screenshot and attach it to the report:",
          "File srcFile = ((TakesScreenshot)driver).getScreenshotAs(OutputType.FILE);",
          "FileUtils.copyFile(srcFile, new File(\"screenshots/fail.png\"));"
        ]
      },
      {
        q: "[Intermediate] Explain the difference between XPath and CSS Selectors.",
        a: [
          "XPath: Navigates both ways (parent-to-child and child-to-parent). Supports text-matching functions (text(), contains()). Can be slightly slower in older browser engines.",
          "CSS Selector: Fast performance, supported natively by all browsers. Cannot navigate backward to parent elements and does not support text-matching checks natively."
        ]
      },
      {
        q: "[Intermediate] How do you upload files in automation?",
        a: [
          "Avoid clicking the 'Browse' buttons which open OS file explorer dialogs. Instead, send the absolute file path directly to the input element:",
          "Selenium: `driver.findElement(By.cssSelector(\"input[type='file']\")).sendKeys(\"/path/to/file.pdf\");`",
          "Playwright: `await page.locator('input[type=\"file\"]').setInputFiles('file.pdf');`"
        ]
      },
      {
        q: "[Intermediate] What are dynamic web tables and how do you parse them?",
        a: [
          "Web tables with variable row/column sizes are parsed by capturing the rows collection and looping cells using relative child traversals:",
          "List<WebElement> rows = driver.findElements(By.xpath(\"//table[@id='employees']/tbody/tr\"));",
          "for (WebElement row : rows) {",
          "    String cellText = row.findElement(By.xpath(\"./td[1]\")).getText();",
          "}"
        ]
      },
      {
        q: "[Intermediate] What is the purpose of a build tool (e.g. Maven, Gradle, npm) in automation?",
        a: [
          "Build tools manage project dependencies (downloading Selenium, Playwright, TestNG libraries automatically), compile code, execute tests via command line tasks, and integrate with CI/CD platforms."
        ]
      },
      {
        q: "[Intermediate] How do you configure environment-specific configurations (Dev, QA, Staging)?",
        a: [
          "Store environment URLs, credentials, and parameters inside configuration files (e.g., config.properties, settings.json, or .env files). Load them dynamically based on variables passed during execution (e.g. `mvn test -Denv=QA`)."
        ]
      },
      {
        q: "[Intermediate] What is REST API testing and how is it automated?",
        a: [
          "REST API testing validates backend web services directly by sending HTTP requests (GET, POST, PUT, DELETE) and asserting response payloads, status codes, headers, and schemas.",
          "Tools: RestAssured (Java), request fixture (Playwright), Postman, Supertest (JS)."
        ]
      },
      {
        q: "[Intermediate] How do you handle hover operations in Selenium vs. Playwright?",
        a: [
          "Selenium: Use Actions: `new Actions(driver).moveToElement(el).perform();`",
          "Playwright: Use locator.hover() directly: `await page.locator('el').hover();`"
        ]
      },
      {
        q: "[Advanced] Explain the difference between Page Object Model (POM) and Page Component Model.",
        a: [
          "Page Object Model: Represents full pages as classes. Scales well for small/medium sites.",
          "Page Component Model: Breaks pages down into reusable components (e.g. navigation bar, sidebar menu, footer card) that exist across pages. Improves maintainability on large applications by composing pages from modular component classes."
        ]
      },
      {
        q: "[Advanced] How do you handle Stale Element Reference Exceptions in Selenium?",
        a: [
          "A stale exception occurs when an element is no longer attached to the DOM (due to re-rendering, navigation, or AJAX updates).",
          "Solutions:",
          "1. Re-initialize the element reference using `driver.findElement()` again before interaction.",
          "2. Implement custom explicit waits (e.g. wait for element to become attached or visible).",
          "3. Avoid using `@CacheLookup` on elements that update dynamically in PageFactory."
        ]
      },
      {
        q: "[Advanced] What is a test automation framework? Describe its key components.",
        a: [
          "A framework is a set of rules, standards, and utilities designed to organize test code.",
          "Key Components:",
          "1. Design Patterns (POM, Page Components).",
          "2. Build & Dependency Manager (Maven, Gradle, npm).",
          "3. Configuration Manager (properties files, environment variables).",
          "4. Data Providers (Excel reader, CSV parsing, DB connectors).",
          "5. Custom Reporting (ExtentReports, Allure, default HTML).",
          "6. Continuous Integration setup (Jenkinsfile, GitHub workflows)."
        ]
      },
      {
        q: "[Advanced] What is Selenium Grid and how does it support distributed testing?",
        a: [
          "Selenium Grid executes tests in parallel across different physical or virtual machines running different browsers and OS environments.",
          "Components:",
          "- Router: Single entry point that maps requests to nodes.",
          "- Distributor: Dispatches test capabilities to matching nodes.",
          "- Node: The actual browser host machines where execution occurs."
        ]
      },
      {
        q: "[Advanced] How do you execute JavaScript code directly in Selenium WebDriver?",
        a: [
          "Cast the WebDriver instance to JavascriptExecutor:",
          "JavascriptExecutor js = (JavascriptExecutor) driver;",
          "// Click element via JS",
          "js.executeScript(\"arguments[0].click();\", element);",
          "// Return value",
          "String url = (String) js.executeScript(\"return document.URL;\");"
        ]
      },
      {
        q: "[Advanced] What is Visual Regression Testing and how is it automated?",
        a: [
          "Visual Regression testing captures screenshots of pages or components and compares them pixel-by-pixel against reference golden images to detect unintended visual modifications.",
          "Tools: Applitools, Percy, or Playwright's built-in `toHaveScreenshot()` matcher."
        ]
      },
      {
        q: "[Advanced] How do you implement retry logic on test failures automatically?",
        a: [
          "TestNG: Implement the `IRetryAnalyzer` interface and override the `retry()` method to return true until a maximum count is reached, then bind it to tests via listeners.",
          "Playwright: Define the `retries` parameter inside `playwright.config.js` (e.g. `retries: 2`)."
        ]
      },
      {
        q: "[Advanced] How do you automate CAPTCHA or Two-Factor Authentication (2FA)?",
        a: [
          "Captchas are designed to block automation. Avoid automating them directly by:",
          "1. Disabling CAPTCHA on test environments via configurations.",
          "2. Using APIs/backdoors to bypass CAPTCHA login flow.",
          "3. Generating 2FA TOTP codes programmatically using OTP generator libraries (like Speakeasy or Java TOTP libraries) if secret seeds are available."
        ]
      },
      {
        q: "[Advanced] How do you handle Shadow DOM elements in Selenium vs. Playwright?",
        a: [
          "Selenium: Traverse host elements explicitly using shadow root interfaces (Selenium 4): `WebElement host = driver.findElement(By.id(\"host\")); SearchContext root = host.getShadowRoot();`",
          "Playwright: Natively traverses Shadow DOM selectors without any extra code steps."
        ]
      },
      {
        q: "[Advanced] How do you run automation tests inside Docker containers?",
        a: [
          "Run tests inside Docker containers using official browser driver images (e.g. selenium/node-chrome or mcr.microsoft.com/playwright). This ensures a consistent environment, eliminates local OS dependency flakiness, and supports easy scaling in Kubernetes clusters."
        ]
      },
      {
        q: "[Advanced] What is BDD and how does Cucumber work in test automation?",
        a: [
          "BDD (Behavior-Driven Development) is a collaboration framework using human-readable statements.",
          "Cucumber executes statement actions by mapping Gherkin features (`Given`, `When`, `Then`) to Step Definition methods in Java/JS using annotations or regular expressions."
        ]
      },
      {
        q: "[Advanced] How do you configure and run tests on multiple browsers concurrently?",
        a: [
          "Selenium Grid: Set desired capabilities dynamically and instantiate RemoteWebDriver mapped to the Grid hub.",
          "Playwright: Configure multiple projects (Chromium, Firefox, WebKit) in config, and run `npx playwright test` which executes concurrently by default."
        ]
      },
      {
        q: "[Advanced] What is a stale element and how is it resolved in Page Factory?",
        a: [
          "Page Factory elements are initialized on page load. If the DOM re-renders, they throw StaleElementReferenceException.",
          "Resolve it by avoiding `@CacheLookup` on dynamic elements (forcing Selenium to find the element again on every method invocation), or wrapping actions in helper methods with try-catch retry loops."
        ]
      },
      {
        q: "[Advanced] How do you intercept and mock HTTP network traffic in Cypress/Playwright?",
        a: [
          "Playwright: Use `page.route('**/api/users', route => route.fulfill({ json: mockData }));`",
          "Cypress: Use `cy.intercept('GET', '/api/users', { fixture: 'users.json' }).as('getUsers');`"
        ]
      },
      {
        q: "[Advanced] How do you configure browser options (incognito, ignore SSL, disable popups)?",
        a: [
          "Selenium: Set argument properties inside options subclasses: `ChromeOptions options = new ChromeOptions(); options.addArguments(\"--incognito\"); options.setAcceptInsecureCerts(true);`",
          "Playwright: Configure parameters within `use` block inside `playwright.config.js`."
        ]
      },
      {
        q: "[Advanced] What is the difference between client-side waits and server-side waits?",
        a: [
          "Client-side wait: Script execution waits in background memory (e.g., explicit wait polling elements).",
          "Server-side wait: The browser itself slows execution, or execution waits for the server response (e.g. page load timeout boundaries)."
        ]
      },
      {
        q: "[Advanced] How do you handle cookie authentication once and share it between tests?",
        a: [
          "Run a setup login test to fetch session cookies and localStorage, serialize them to a JSON file (e.g. storageState in Playwright), and inject the JSON state into subsequent test browser contexts, avoiding repeated login steps."
        ]
      },
      {
        q: "[Advanced] How do you automate databases checking in automation tests?",
        a: [
          "Establish a connection via JDBC (Java) or pg-promise (Node), execute queries (e.g. `SELECT * FROM orders WHERE id = ?`), and assert the values match the UI form inputs to ensure correct database writes."
        ]
      },
      {
        q: "[Advanced] What is the difference between continuous integration and continuous deployment in QA?",
        a: [
          "Continuous Integration (CI): Developers merge code changes, which triggers automated build compilation and regression tests immediately.",
          "Continuous Deployment (CD): Automatically deploys the validated code builds directly to staging/production environments once test suites pass."
        ]
      },
      {
        q: "[Advanced] How do you audit performance metrics during automation execution?",
        a: [
          "Leverage Chrome DevTools Protocol (CDP) commands inside Selenium/Playwright to capture performance metrics (e.g., CPU throttling, first contentful paint, heap sizes), or run Lighthouse audits programmatically during navigation steps."
        ]
      }
    ]
  },
  "api-testing": {
    title: "API & Web Services",
    qa: [
      {
        "q": "What is an API?",
        "a": [
          "API stands for Application Programming Interface.",
          "It is a set of rules and protocols that allows different software systems to communicate.",
          "APIs act as an intermediary between client and server.",
          "They enable integration between services without exposing internal logic.",
          "Commonly used in web, mobile, and cloud applications.",
          "Example: A weather app fetching data from a weather API."
        ]
      },
      {
        "q": "What are the types of APIs?",
        "a": [
          "Public APIs: Open for external developers with minimal restrictions.",
          "Private APIs: Used internally within an organization.",
          "Partner APIs: Shared with specific business partners.",
          "Composite APIs: Combine multiple API calls into a single request.",
          "These types help manage access control and scalability.",
          "Choice depends on business needs and security requirements."
        ]
      },
      {
        "q": "What is REST API?",
        "a": [
          "REST (Representational State Transfer) is an architectural style for APIs.",
          "It uses HTTP methods like GET, POST, PUT, DELETE.",
          "Resources are identified using URIs.",
          "REST is stateless, meaning each request is independent.",
          "It supports JSON and XML formats.",
          "Widely used due to simplicity and scalability."
        ]
      },
      {
        "q": "What are HTTP methods supported by REST?",
        "a": [
          "GET: Retrieves data from the server.",
          "POST: Creates a new resource.",
          "PUT: Updates or replaces an existing resource.",
          "DELETE: Removes a resource.",
          "PATCH: Partially updates a resource.",
          "These methods follow CRUD operations."
        ]
      },
      {
        "q": "What is the difference between PUT and POST?",
        "a": [
          "PUT is idempotent, meaning repeated requests give the same result.",
          "POST is not idempotent and creates new resources.",
          "PUT updates or replaces an existing resource completely.",
          "POST adds a new resource to the server.",
          "PUT usually requires a full payload, while POST can accept partial data.",
          "PUT is often used when resource ID is known."
        ]
      },
      {
        "q": "What is an endpoint in API?",
        "a": [
          "An endpoint is a specific URL where an API is accessed.",
          "It represents a resource or function in the system.",
          "Acts as a communication point between client and server.",
          "Example: /api/users/123 retrieves a user.",
          "Each endpoint performs a specific operation.",
          "Endpoints are defined in API documentation."
        ]
      },
      {
        "q": "What is JSON and XML in APIs?",
        "a": [
          "JSON is lightweight, easy to read, and widely used in modern APIs.",
          "XML is more verbose and used in older or enterprise systems.",
          "Both are data exchange formats between client and server.",
          "JSON is faster to parse compared to XML.",
          "XML supports schema validation and strict formatting.",
          "Most REST APIs prefer JSON due to performance."
        ]
      },
      {
        "q": "What are common HTTP status codes?",
        "a": [
          "200 OK: Request successful.",
          "201 Created: Resource created successfully.",
          "400 Bad Request: Invalid input from client.",
          "401 Unauthorized: Authentication required.",
          "404 Not Found: Resource not found.",
          "500 Internal Server Error: Server failure."
        ]
      },
      {
        "q": "What is API testing?",
        "a": [
          "API testing validates functionality, reliability, and performance.",
          "It focuses on business logic rather than UI.",
          "Ensures correct request and response handling.",
          "Tests authentication, authorization, and data validation.",
          "Performed using tools like Postman or automation frameworks.",
          "Helps detect issues early in development."
        ]
      },
      {
        "q": "What is Postman?",
        "a": [
          "Postman is a popular API testing tool.",
          "It allows sending requests and analyzing responses.",
          "Supports automation using scripts and collections.",
          "Provides environment variables for testing multiple setups.",
          "Used for documentation and collaboration.",
          "Widely used by developers and QA teams."
        ]
      },
      {
        "q": "What is Authentication and Authorization?",
        "a": [
          "Authentication verifies the identity of a user.",
          "Authorization determines what the user can access.",
          "Example: Login verifies identity, roles define permissions.",
          "Authentication methods include JWT, OAuth, API keys.",
          "Authorization is enforced using roles and policies.",
          "Both are critical for API security."
        ]
      },
      {
        "q": "What are Headers in API?",
        "a": [
          "Headers provide metadata about requests and responses.",
          "Common headers include Content-Type, Authorization, Accept.",
          "They define data format and authentication details.",
          "Used for caching, compression, and security.",
          "Headers help the server understand client requirements.",
          "Essential for proper API communication."
        ]
      },
      {
        "q": "What is Payload in API?",
        "a": [
          "Payload is the body of an HTTP request or response.",
          "Contains the actual data sent between client and server.",
          "Usually in JSON or XML format.",
          "Used in POST, PUT, and PATCH requests.",
          "Can include user data, parameters, or configurations.",
          "Important for data processing."
        ]
      },
      {
        "q": "What is OAuth 2.0?",
        "a": [
          "OAuth 2.0 is an authorization framework.",
          "Allows third-party apps to access user data securely.",
          "Uses access tokens instead of sharing credentials.",
          "Supports flows like authorization code and client credentials.",
          "Widely used in modern applications.",
          "Enhances security and scalability."
        ]
      },
      {
        "q": "What is rate limiting?",
        "a": [
          "Rate limiting restricts the number of API requests.",
          "Prevents abuse and server overload.",
          "Implemented using quotas or time windows.",
          "Example: 1000 requests per hour per user.",
          "Helps ensure fair usage among users.",
          "Often enforced by API gateways."
        ]
      },
      {
        "q": "What is CORS?",
        "a": [
          "CORS stands for Cross-Origin Resource Sharing.",
          "It controls access between different domains.",
          "Browsers restrict cross-origin requests by default.",
          "CORS headers allow or block such requests.",
          "Improves security in web applications.",
          "Essential for frontend-backend communication."
        ]
      },
      {
        "q": "What is Swagger?",
        "a": [
          "Swagger is a tool for API documentation.",
          "Now part of OpenAPI Specification (OAS).",
          "Helps design, build, and document APIs.",
          "Allows interactive API testing.",
          "Generates client SDKs automatically.",
          "Improves developer experience."
        ]
      },
      {
        "q": "REST vs SOAP?",
        "a": [
          "REST is lightweight and uses HTTP methods.",
          "SOAP is protocol-based and uses XML only.",
          "REST supports JSON and is faster.",
          "SOAP has strict standards and security features.",
          "REST is widely used in web/mobile apps.",
          "SOAP is used in enterprise systems."
        ]
      },
      {
        "q": "What is an API key?",
        "a": [
          "API key is a unique identifier for authentication.",
          "Passed in headers or query parameters.",
          "Used to track and control API usage.",
          "Helps in monitoring and rate limiting.",
          "Less secure than OAuth or JWT.",
          "Common in public APIs."
        ]
      },
      {
        "q": "What is a mock API?",
        "a": [
          "A mock API simulates real API behavior.",
          "Used when backend is not ready.",
          "Helps frontend development and testing.",
          "Returns predefined responses.",
          "Useful in early development stages.",
          "Reduces dependency on actual services."
        ]
      },
      {
        "q": "What is API Versioning?",
        "a": [
          "API versioning helps manage changes without breaking existing clients.",
          "It ensures backward compatibility for older applications.",
          "Common strategies include URI (/v1/users), headers, and query parameters.",
          "It allows gradual migration to new features.",
          "Helps maintain stability in production systems.",
          "Essential for long-term API lifecycle management."
        ]
      },
      {
        "q": "What is Latency in API? (Corrected)",
        "a": [
          "Latency is the time taken between sending a request and receiving a response.",
          "It is usually measured in milliseconds.",
          "Lower latency improves user experience and system performance.",
          "It depends on network speed, server processing, and data size.",
          "High latency can cause delays in applications.",
          "Optimizing latency is critical in real-time systems."
        ]
      },
      {
        "q": "What is API Gateway?",
        "a": [
          "API Gateway acts as a single entry point for all API requests.",
          "It handles routing, authentication, and rate limiting.",
          "It can aggregate multiple services into one response.",
          "Provides security and monitoring features.",
          "Helps manage microservices architecture.",
          "Examples include AWS API Gateway, Kong, and Apigee."
        ]
      },
      {
        "q": "What are API testing tools?",
        "a": [
          "Postman is used for manual and automated API testing.",
          "SoapUI supports both REST and SOAP APIs.",
          "JMeter is used for performance and load testing.",
          "Rest Assured is used for automation in Java.",
          "Swagger allows testing directly from documentation.",
          "These tools help validate API functionality and performance."
        ]
      },
      {
        "q": "What are Idempotent methods?",
        "a": [
          "Idempotent methods return the same result when called multiple times.",
          "GET, PUT, and DELETE are idempotent.",
          "POST is not idempotent because it creates new resources.",
          "Important for retry mechanisms in distributed systems.",
          "Helps maintain consistency during failures.",
          "Ensures predictable API behavior."
        ]
      },
      {
        "q": "Synchronous vs Asynchronous APIs?",
        "a": [
          "Synchronous APIs wait for the response before proceeding.",
          "Asynchronous APIs process requests in the background.",
          "Sync APIs are blocking, while async APIs are non-blocking.",
          "Async APIs improve scalability and performance.",
          "Examples include webhooks and message queues.",
          "Used based on system requirements."
        ]
      },
      {
        "q": "What is a REST resource?",
        "a": [
          "A resource is any object or data exposed by an API.",
          "It is identified by a unique URI.",
          "Example: /users/123 represents a user resource.",
          "Resources are manipulated using HTTP methods.",
          "Core concept of REST architecture.",
          "Stateless interaction with resources."
        ]
      },
      {
        "q": "What is HATEOAS?",
        "a": [
          "HATEOAS stands for Hypermedia As The Engine Of Application State.",
          "It provides links in API responses for navigation.",
          "Helps clients discover actions dynamically.",
          "Improves API usability and flexibility.",
          "Reduces dependency on documentation.",
          "Part of REST maturity model."
        ]
      },
      {
        "q": "Query Params vs Path Params?",
        "a": [
          "Path parameters identify a specific resource (/users/1).",
          "Query parameters filter or modify data (/users?id=1).",
          "Path params are mandatory, query params are optional.",
          "Query params support pagination and sorting.",
          "Used mainly in GET requests.",
          "Helps build flexible APIs."
        ]
      },
      {
        "q": "Difference between 401 and 403?",
        "a": [
          "401 means authentication is required or failed.",
          "403 means access is forbidden even after authentication.",
          "401 requires login credentials.",
          "403 indicates insufficient permissions.",
          "Both are related to security.",
          "Used in access control mechanisms."
        ]
      },
      {
        "q": "What is a Token in API?",
        "a": [
          "A token is used for authentication and authorization.",
          "It is generated after successful login.",
          "Common types include JWT and OAuth tokens.",
          "Tokens are passed in headers.",
          "They expire after a certain time.",
          "More secure than session-based authentication."
        ]
      },
      {
        "q": "What is RESTful routing?",
        "a": [
          "RESTful routing defines standard URL patterns.",
          "Uses HTTP methods for operations.",
          "Example: GET /users, POST /users, PUT /users/1.",
          "Helps maintain consistency in APIs.",
          "Improves readability and scalability.",
          "Follows REST principles."
        ]
      },
      {
        "q": "What is OPTIONS method?",
        "a": [
          "OPTIONS method returns supported HTTP methods.",
          "Used in CORS preflight requests.",
          "Helps browsers check permissions.",
          "Does not return resource data.",
          "Improves security and compatibility.",
          "Important for cross-origin requests."
        ]
      },
      {
        "q": "What are environment variables in Postman?",
        "a": [
          "Used to store reusable values like URLs and tokens.",
          "Helps switch between environments (dev, test, prod).",
          "Improves test reusability.",
          "Reduces duplication in requests.",
          "Managed within Postman environments.",
          "Useful for automation."
        ]
      },
      {
        "q": "What is API Documentation?",
        "a": [
          "Provides details about API usage.",
          "Includes endpoints, parameters, and examples.",
          "Helps developers understand APIs.",
          "Tools include Swagger and Redoc.",
          "Essential for integration.",
          "Improves collaboration."
        ]
      },
      {
        "q": "What is API Throttling?",
        "a": [
          "Limits the number of requests per user.",
          "Prevents system overload.",
          "Implemented using API gateways.",
          "Works with rate limiting policies.",
          "Ensures fair usage.",
          "Protects backend systems."
        ]
      },
      {
        "q": "What is a Webhook?",
        "a": [
          "A webhook is an event-driven API callback.",
          "Sends data automatically when an event occurs.",
          "Eliminates need for polling.",
          "Used in real-time systems.",
          "Example: payment notifications.",
          "Improves efficiency."
        ]
      },
      {
        "q": "REST Best Practices?",
        "a": [
          "Use proper HTTP methods.",
          "Maintain consistent naming conventions.",
          "Use proper status codes.",
          "Implement versioning.",
          "Secure APIs with authentication.",
          "Optimize performance."
        ]
      },
      {
        "q": "How to secure APIs?",
        "a": [
          "Use HTTPS encryption.",
          "Implement authentication (JWT, OAuth).",
          "Validate inputs.",
          "Apply rate limiting.",
          "Use API gateways.",
          "Monitor and log activity."
        ]
      },
      {
        "q": "What is Pagination?",
        "a": [
          "Splits large data into smaller chunks.",
          "Improves performance.",
          "Reduces load on server.",
          "Implemented using limit and offset.",
          "Enhances user experience.",
          "Common in APIs."
        ]
      },
      {
        "q": "What is Content-Type header?",
        "a": [
          "Content-Type specifies the format of request/response data.",
          "Common values include application/json, application/xml.",
          "Helps server understand how to process the payload.",
          "Ensures proper data parsing.",
          "Used in request headers and responses.",
          "Essential for correct communication."
        ]
      },
      {
        "q": "What is Error Handling in APIs?",
        "a": [
          "Error handling ensures proper response for failures.",
          "Uses HTTP status codes like 400, 404, 500.",
          "Includes meaningful error messages.",
          "Helps debugging and troubleshooting.",
          "Improves user experience.",
          "Important for robust API design."
        ]
      },
      {
        "q": "SOAP vs REST (Detailed)?",
        "a": [
          "SOAP is protocol-based and uses XML.",
          "REST is architectural style and supports JSON/XML.",
          "SOAP is strict and secure but heavier.",
          "REST is lightweight and faster.",
          "SOAP used in enterprise apps.",
          "REST widely used in modern web services."
        ]
      },
      {
        "q": "What is Schema in API?",
        "a": [
          "Schema defines structure of request/response data.",
          "Specifies fields, data types, and validation rules.",
          "Used for data consistency.",
          "Helps in API documentation.",
          "JSON Schema is commonly used.",
          "Ensures correct data exchange."
        ]
      },
      {
        "q": "What is Idempotency?",
        "a": [
          "Idempotency means same result for repeated requests.",
          "Ensures reliability in distributed systems.",
          "GET, PUT, DELETE are idempotent.",
          "POST is not idempotent.",
          "Important for retries.",
          "Prevents duplicate operations."
        ]
      },
      {
        "q": "REST vs GraphQL?",
        "a": [
          "REST uses multiple endpoints.",
          "GraphQL uses a single endpoint.",
          "REST returns fixed data.",
          "GraphQL allows flexible queries.",
          "Reduces over-fetching/under-fetching.",
          "Used in modern applications."
        ]
      },
      {
        "q": "What is Postman Collection?",
        "a": [
          "A collection is a group of API requests.",
          "Helps organize test cases.",
          "Supports automation and scripting.",
          "Can be shared across teams.",
          "Used for regression testing.",
          "Improves productivity."
        ]
      },
      {
        "q": "What is Integration Testing in API?",
        "a": [
          "Tests interaction between multiple systems.",
          "Ensures APIs work with databases/services.",
          "Validates end-to-end workflows.",
          "Detects integration issues.",
          "Done after unit testing.",
          "Important for system stability."
        ]
      },
      {
        "q": "What are Response formats?",
        "a": [
          "Common formats include JSON and XML.",
          "JSON is lightweight and widely used.",
          "XML used in legacy systems.",
          "Format defined using Content-Type header.",
          "Must match client expectations.",
          "Ensures proper data exchange."
        ]
      },
      {
        "q": "What are Custom Headers?",
        "a": [
          "Headers defined by developers.",
          "Used to pass additional information.",
          "Example: X-Request-ID.",
          "Helps tracking and debugging.",
          "Used in security and logging.",
          "Enhances flexibility."
        ]
      },
      {
        "q": "What is API Contract?",
        "a": [
          "Defines request and response structure.",
          "Agreement between client and server.",
          "Includes endpoints, methods, schemas.",
          "Helps avoid miscommunication.",
          "Used in contract testing.",
          "Important in microservices."
        ]
      },
      {
        "q": "API Gateway role?",
        "a": [
          "Acts as reverse proxy.",
          "Routes requests to services.",
          "Handles authentication.",
          "Applies rate limiting.",
          "Provides monitoring.",
          "Simplifies client interaction."
        ]
      },
      {
        "q": "What is JSON Schema?",
        "a": [
          "Defines structure of JSON data.",
          "Specifies required fields and types.",
          "Used for validation.",
          "Helps ensure data consistency.",
          "Used in API testing.",
          "Improves reliability."
        ]
      },
      {
        "q": "Monolithic vs Microservices?",
        "a": [
          "Monolithic is single large application.",
          "Microservices are small independent services.",
          "Microservices improve scalability.",
          "Monolithic easier to develop initially.",
          "Microservices support distributed systems.",
          "Common in modern architectures."
        ]
      },
      {
        "q": "What is JWT?",
        "a": [
          "JSON Web Token for authentication.",
          "Contains header, payload, signature.",
          "Used for secure data exchange.",
          "Passed in Authorization header.",
          "Stateless authentication method.",
          "Widely used in APIs."
        ]
      },
      {
        "q": "API Versioning strategies?",
        "a": [
          "URI versioning (/v1).",
          "Header versioning.",
          "Query parameter versioning.",
          "Ensures backward compatibility.",
          "Helps API evolution.",
          "Avoids breaking clients."
        ]
      },
      {
        "q": "More HTTP Status Codes?",
        "a": [
          "204 No Content (success without body).",
          "403 Forbidden (no permission).",
          "429 Too Many Requests.",
          "502 Bad Gateway.",
          "503 Service Unavailable.",
          "Used for better error handling."
        ]
      },
      {
        "q": "API Monitoring?",
        "a": [
          "Tracks API performance and usage.",
          "Uses logs and metrics.",
          "Tools: Prometheus, Datadog.",
          "Helps detect issues early.",
          "Improves reliability.",
          "Important in production systems."
        ]
      },
      {
        "q": "Mocking vs Stubbing?",
        "a": [
          "Mock simulates behavior dynamically.",
          "Stub returns predefined responses.",
          "Used in testing.",
          "Helps isolate components.",
          "Reduces dependency on services.",
          "Improves test speed."
        ]
      },
      {
        "q": "GET vs HEAD?",
        "a": [
          "GET returns headers and body.",
          "HEAD returns only headers.",
          "Used to check resource availability.",
          "Faster than GET.",
          "Useful for metadata checks.",
          "Saves bandwidth."
        ]
      },
      {
        "q": "What is GraphQL?",
        "a": [
          "Query language for APIs.",
          "Allows fetching specific data.",
          "Uses single endpoint.",
          "Reduces over-fetching.",
          "Flexible and efficient.",
          "Popular in modern apps."
        ]
      },
      {
        "q": "What is API Automation?",
        "a": [
          "Automates API test cases.",
          "Tools: Rest Assured, Postman.",
          "Reduces manual effort.",
          "Used in CI/CD pipelines.",
          "Improves test coverage.",
          "Speeds up testing."
        ]
      },
      {
        "q": "What is Dependency Injection?",
        "a": [
          "Design pattern for injecting dependencies.",
          "Reduces tight coupling.",
          "Improves testability.",
          "Used in frameworks like Spring.",
          "Enhances flexibility.",
          "Common in backend systems."
        ]
      },
      {
        "q": "What is OpenAPI (OAS)?",
        "a": [
          "Standard for API documentation.",
          "Defines endpoints and schemas.",
          "Used with Swagger.",
          "Helps generate docs and SDKs.",
          "Improves collaboration.",
          "Widely adopted."
        ]
      },
      {
        "q": "What is API Proxy?",
        "a": [
          "Intermediate layer between client and server.",
          "Handles security and logging.",
          "Can modify requests/responses.",
          "Used for monitoring.",
          "Improves control.",
          "Used in API gateways."
        ]
      },
      {
        "q": "What is Caching in APIs?",
        "a": [
          "Stores responses for reuse.",
          "Reduces server load.",
          "Improves performance.",
          "Uses Redis, CDN.",
          "Controlled using cache headers.",
          "Important for scalability."
        ]
      },
      {
        "q": "Client vs Server APIs?",
        "a": [
          "Client APIs run in browsers (Fetch API).",
          "Server APIs run on backend.",
          "Client interacts with UI.",
          "Server handles logic/data.",
          "Both work together.",
          "Essential for applications."
        ]
      },
      {
        "q": "API Security vulnerabilities?",
        "a": [
          "Injection attacks.",
          "Broken authentication.",
          "Data exposure.",
          "Improper validation.",
          "Lack of encryption.",
          "Must be mitigated properly."
        ]
      },
      {
        "q": "API Orchestration?",
        "a": [
          "Combines multiple APIs into one flow.",
          "Used in microservices.",
          "Reduces complexity for client.",
          "Improves efficiency.",
          "Managed via orchestration tools.",
          "Used in workflows."
        ]
      },
      {
        "q": "What is ETag?",
        "a": [
          "Entity tag for resource versioning.",
          "Used in caching.",
          "Helps avoid unnecessary updates.",
          "Improves performance.",
          "Used with HTTP headers.",
          "Supports conditional requests."
        ]
      },
      {
        "q": "API Challenges?",
        "a": [
          "Security risks.",
          "Versioning issues.",
          "Performance problems.",
          "Monitoring difficulties.",
          "Scalability concerns.",
          "Requires proper design."
        ]
      },
      {
        "q": "SOAP Envelope?",
        "a": [
          "XML structure for SOAP messages.",
          "Contains header and body.",
          "Defines message format.",
          "Used in SOAP APIs.",
          "Strict structure.",
          "Required for communication."
        ]
      },
      {
        "q": "REST vs RPC?",
        "a": [
          "REST is resource-based.",
          "RPC is function-based.",
          "REST uses HTTP.",
          "RPC calls methods directly.",
          "REST is more scalable.",
          "RPC simpler for small systems."
        ]
      },
      {
        "q": "Secure internal APIs?",
        "a": [
          "Use VPN or private networks.",
          "Implement authentication.",
          "Use HTTPS encryption.",
          "Apply access control.",
          "Monitor traffic.",
          "Protect internal services."
        ]
      },
      {
        "q": "Async callbacks?",
        "a": [
          "Server sends response later.",
          "Used in async processing.",
          "Example: webhook callback.",
          "Improves performance.",
          "Non-blocking execution.",
          "Used in event-driven systems."
        ]
      },
      {
        "q": "Sync vs Async messaging?",
        "a": [
          "Sync waits for response.",
          "Async uses queues.",
          "Async improves scalability.",
          "Sync simpler but slower.",
          "Used based on use case.",
          "Important in distributed systems."
        ]
      },
      {
        "q": "What is 429 status code?",
        "a": [
          "Too many requests.",
          "Indicates rate limit exceeded.",
          "Used in throttling.",
          "Client should retry later.",
          "Helps prevent overload.",
          "Important for API control."
        ]
      },
      {
        "q": "Soft vs Hard delete?",
        "a": [
          "Soft delete marks data as deleted.",
          "Hard delete removes permanently.",
          "Soft delete allows recovery.",
          "Used for auditing.",
          "Hard delete frees storage.",
          "Used based on requirement."
        ]
      },
      {
        "q": "Service Mesh?",
        "a": [
          "Manages service-to-service communication.",
          "Used in microservices.",
          "Provides security and monitoring.",
          "Examples: Istio, Linkerd.",
          "Improves reliability.",
          "Handles traffic management."
        ]
      },
      {
        "q": "Circuit Breaker?",
        "a": [
          "Prevents repeated failures.",
          "Stops calls to failing service.",
          "Allows recovery after timeout.",
          "Improves system stability.",
          "Used in microservices.",
          "Example: Hystrix."
        ]
      },
      {
        "q": "API Rate Limiting Purpose?",
        "a": [
          "Controls request traffic.",
          "Prevents abuse.",
          "Protects server.",
          "Ensures fair usage.",
          "Improves performance.",
          "Used with throttling."
        ]
      },
      {
        "q": "API-first design?",
        "a": [
          "Design API before implementation.",
          "Improves consistency.",
          "Helps parallel development.",
          "Ensures better architecture.",
          "Used in modern development.",
          "Supports scalability."
        ]
      },
      {
        "q": "Improve API performance?",
        "a": [
          "Use caching.",
          "Optimize queries.",
          "Use async processing.",
          "Reduce payload size.",
          "Use load balancing.",
          "Monitor performance."
        ]
      },
      {
        "q": "API Testing vs Unit Testing?",
        "a": [
          "API testing checks integration.",
          "Unit testing checks individual code.",
          "API tests business logic.",
          "Unit tests internal functions.",
          "Both are important.",
          "Used in different stages."
        ]
      },
      {
        "q": "SDK in APIs?",
        "a": [
          "Software Development Kit.",
          "Provides tools for API usage.",
          "Includes libraries and docs.",
          "Simplifies integration.",
          "Improves developer experience.",
          "Used in many platforms."
        ]
      },
      {
        "q": "Base URL?",
        "a": [
          "Root URL of API.",
          "Example: https://api.example.com.",
          "All endpoints extend from it.",
          "Used in configuration.",
          "Helps manage environments.",
          "Important in API design."
        ]
      },
      {
        "q": "API Sprawl?",
        "a": [
          "Uncontrolled growth of APIs.",
          "Leads to duplication.",
          "Causes maintenance issues.",
          "Requires governance.",
          "Managed using documentation.",
          "Important for large systems."
        ]
      },
      {
        "q": "PUT vs PATCH vs POST?",
        "a": [
          "PUT updates full resource.",
          "PATCH updates partial resource.",
          "POST creates new resource.",
          "PUT/PATCH idempotent.",
          "POST not idempotent.",
          "Used based on use case."
        ]
      },
      {
        "q": "API Throttling?",
        "a": [
          "Limits request rate.",
          "Prevents overload.",
          "Works with rate limiting.",
          "Ensures stability.",
          "Controlled via gateway.",
          "Protects backend."
        ]
      },
      {
        "q": "Location Header?",
        "a": [
          "Used in 201 response.",
          "Contains URL of created resource.",
          "Helps client access new resource.",
          "Example: /users/123.",
          "Improves usability.",
          "Standard HTTP header."
        ]
      },
      {
        "q": "Hypermedia API?",
        "a": [
          "Includes links in responses.",
          "Guides client actions.",
          "Related to HATEOAS.",
          "Improves navigation.",
          "Reduces dependency.",
          "Used in REST."
        ]
      },
      {
        "q": "OPTIONS Preflight?",
        "a": [
          "Sent before actual request.",
          "Used in CORS.",
          "Checks allowed methods.",
          "Ensures security.",
          "Prevents unauthorized access.",
          "Important for browsers."
        ]
      },
      {
        "q": "API Registry?",
        "a": [
          "Central repository of APIs.",
          "Stores metadata and docs.",
          "Helps discover APIs.",
          "Used in enterprises.",
          "Improves governance.",
          "Supports API lifecycle."
        ]
      },
      {
        "q": "API Gateway vs Load Balancer?",
        "a": [
          "Gateway handles API logic.",
          "Load balancer distributes traffic.",
          "Gateway manages security.",
          "Load balancer improves performance.",
          "Both work together.",
          "Used in scalable systems."
        ]
      },
      {
        "q": "Secure API logging?",
        "a": [
          "Avoid logging sensitive data.",
          "Mask credentials.",
          "Use secure storage.",
          "Track request IDs.",
          "Monitor logs regularly.",
          "Helps in debugging and security."
        ]
      }
    ]
  },
  "performance-testing": {
    title: "Performance Testing",
    qa: [
      {
        q: "[Beginner] What is Performance Testing and why is it important?",
        a: [
          "Performance Testing is a non-functional software testing technique used to evaluate speed, responsiveness, stability, reliability, and scalability of an application under a specific workload.",
          "Why it is important:",
          "- Eliminates performance bottlenecks before product launch.",
          "- Validates system stability during high peak traffic loads.",
          "- Prevents revenue loss caused by slow load times or application crashes.",
          "- Ensures server resource utilization (CPU, memory) remains within acceptable limits."
        ]
      },
      {
        q: "[Beginner] Explain the difference between Response Time, Latency, and Throughput.",
        a: [
          "Response Time: The total time taken from the moment a user sends a request to when the browser receives the final response payload.",
          "Latency (TTFB): The time taken for the first byte of data to reach the client after a request is sent (measures network delay).",
          "Throughput: The number of transactions or requests the server can process per unit of time (e.g. Requests Per Second - RPS, or Transactions Per Second - TPS)."
        ]
      },
      {
        q: "[Beginner] What are the different types of Performance Testing?",
        a: [
          "1. Load Testing: Verifying system behavior under expected normal and peak user loads.",
          "2. Stress Testing: Testing application limits by driving load past expected capacity to see how it fails and recovers.",
          "3. Endurance/Soak Testing: Running expected loads for extended periods (e.g. 12-24 hours) to detect memory leaks or resource exhaustions.",
          "4. Spike Testing: Simulating sudden, massive surges in traffic (e.g., flash sales) and observing how the system handles the burst.",
          "5. Volume/Flood Testing: Testing database capacity by feeding large quantities of records.",
          "6. Scalability Testing: Evaluating the system's ability to scale up or out as load increases."
        ]
      },
      {
        q: "[Beginner] What are performance bottlenecks? Give common examples.",
        a: [
          "Bottlenecks are resource constraints that limit the throughput and responsiveness of the application.",
          "Examples:",
          "- CPU / Memory saturation on the application server.",
          "- Database issues (missing indexes, unoptimized queries, lock contentions).",
          "- Network bandwidth limitations.",
          "- Unoptimized client-side rendering (large JS bundles, blocking scripts).",
          "- Thread pool or connection pool exhaustion."
        ]
      },
      {
        q: "[Beginner] What is the difference between client-side and server-side performance?",
        a: [
          "Client-Side Performance: Evaluates how fast the page renders inside the user's browser. Measured by metrics like First Contentful Paint (FCP) and Largest Contentful Paint (LCP). Tools: Lighthouse, WebPageTest.",
          "Server-Side Performance: Evaluates how fast the backend processes requests and queries. Measured by Response Time, Throughput, and CPU usage. Tools: JMeter, k6, Datadog."
        ]
      },
      {
        q: "[Beginner] What is the purpose of JMeter?",
        a: [
          "Apache JMeter is an open-source Java-based load testing application designed to measure performance, load test functional behaviors, and analyze throughput under different load conditions on Web, API, Database, and FTP servers."
        ]
      },
      {
        q: "[Beginner] Explain the terms Virtual Users (VUs) and Hits.",
        a: [
          "Virtual Users (VUs): Simulated user threads executing test script flows concurrently.",
          "Hits: The number of HTTP requests sent to the server. A single Virtual User executing a scenario can generate multiple hits (requests for page HTML, CSS, images, APIs) per second."
        ]
      },
      {
        q: "[Beginner] What is the difference between performance testing and functional testing?",
        a: [
          "Functional Testing: Validates *what* the application does (checking features, button clicks, login behaviors match specifications).",
          "Performance Testing: Validates *how fast and stable* the application does it under workload."
        ]
      },
      {
        q: "[Beginner] What is think time in performance testing?",
        a: [
          "Think time is a simulated delay between user actions on the browser (e.g., waiting 3 seconds after loading the home page before clicking checkout) to mimic realistic human interaction speed."
        ]
      },
      {
        q: "[Beginner] What is pacing in performance testing?",
        a: [
          "Pacing is a simulated delay between the completion of one test iteration and the start of the next iteration for a virtual user thread, allowing testers to control the rate of requests (RPS) sent to the target server."
        ]
      },
      {
        q: "[Intermediate] What is Correlation in performance script scripting and why is it needed?",
        a: [
          "Correlation is the process of capturing dynamic values returned in a server response (e.g. Session IDs, CSRF tokens, authentication tokens) and injecting them into subsequent requests in the script flow.",
          "Why it is needed: Static recorded session tokens expire. Without correlation, subsequent requests containing expired IDs will be rejected by the server, causing test failures."
        ]
      },
      {
        q: "[Intermediate] What is Parameterization and how does it differ from Correlation?",
        a: [
          "Parameterization: Passing different user test input data (e.g. usernames, passwords, search keys) from external files (like CSVs) into test scripts to simulate distinct virtual user behaviors.",
          "Correlation: Capturing dynamic values generated *by the server during execution* and passing them forward. (Parameterization uses client data; Correlation uses server data)."
        ]
      },
      {
        q: "[Intermediate] Explain the major components of a JMeter Test Plan.",
        a: [
          "1. Thread Group: Defines the number of virtual users, ramp-up time, and loop counts.",
          "2. Samplers: Send requests to the server (e.g. HTTP Request, JDBC Request).",
          "3. Listeners: Collect and visualize test results (e.g. View Results Tree, Summary Report).",
          "4. Assertions: Validate response properties (e.g. checking status code = 200 or checking text patterns).",
          "5. Config Elements: Add configuration data (e.g. HTTP Cookie Manager, CSV Data Set Config).",
          "6. Pre/Post Processors: Execute logic before/after samplers (e.g. Regular Expression Extractor)."
        ]
      },
      {
        q: "[Intermediate] How do you perform correlation in JMeter?",
        a: [
          "Use Post-Processors to extract dynamic response data:",
          "1. Add a 'Boundary Extractor', 'JSON Extractor', or 'Regular Expression Extractor' as a child to the sampler returning the token.",
          "2. Define the Variable Name (e.g., `jwtToken`), the Expression, or boundaries.",
          "3. Reference the variable in subsequent requests using the syntax `${jwtToken}`."
        ]
      },
      {
        q: "[Intermediate] What is Ramp-Up and Ramp-Down time in a load test?",
        a: [
          "Ramp-Up: The period during which virtual users are gradually added to the test (e.g., ramping up 100 users over 5 minutes) to avoid overloading the server instantly on start.",
          "Ramp-Down: The period during which virtual users are gradually stopped at the end of the test to allow pending transactions to complete and observe server recovery behaviors."
        ]
      },
      {
        q: "[Intermediate] Explain the difference between JMeter, k6, and Gatling.",
        a: [
          "JMeter: GUI-based, Java-oriented, widely supported, but consumes higher memory due to thread-per-user design.",
          "k6: Developer-centric, JS-based execution engine, extremely lightweight (uses Go routines), command-line first, ideal for CI/CD pipelines.",
          "Gatling: Scala/Java-based, uses Netty/Akka actor model for non-blocking asynchronous execution, supports code-as-config."
        ]
      },
      {
        q: "[Intermediate] What is distributed load testing and when is it required?",
        a: [
          "Distributed testing uses a master-slave configuration where a controller machine orchestrates multiple generator machines (slaves) to execute tests concurrently.",
          "When it is required: When simulating very large user loads (e.g., 10,000+ VUs) that exceed the CPU, memory, and network card bandwidth limits of a single generator machine."
        ]
      },
      {
        q: "[Intermediate] Explain the difference between standard thread groups and concurrency thread groups.",
        a: [
          "Standard Thread Group: Defines VUs and ramp-up directly. Harder to maintain constant target transaction rates.",
          "Concurrency Thread Group: Focuses on maintaining a target level of concurrency dynamically. Allows stepping ramp-up and connects easily with Feedback Loop Timers to control throughput rates dynamically."
        ]
      },
      {
        q: "[Intermediate] What are the key performance metrics you monitor on the server side?",
        a: [
          "Using APM/monitoring tools (Datadog, Prometheus/Grafana, PerfMon), monitor:",
          "- CPU Utilization (% usage and load average).",
          "- Memory/RAM Utilization (used, free, swap space).",
          "- Disk I/O: Read/Write speeds and queue lengths.",
          "- Network I/O: Bytes sent/received, packet drops, bandwidth limits.",
          "- Database connection pool utilization and slow query logs."
        ]
      },
      {
        q: "[Intermediate] What are HTTP status codes that indicate performance issues during load tests?",
        a: [
          "1. 504 Gateway Timeout: Server took too long to respond, causing the proxy/gateway to time out.",
          "2. 503 Service Unavailable: Server is overloaded or down for maintenance.",
          "3. 500 Internal Server Error: Application code crashed under load (e.g., NullPointerException or DB connection failure)."
        ]
      },
      {
        q: "[Intermediate] How does JVM Garbage Collection (GC) affect performance testing?",
        a: [
          "During Garbage Collection (especially Full GC), the JVM freezes application execution threads (known as 'Stop-the-World' pauses) to clean up memory. Long GC pauses cause sudden, sharp spikes in transaction response times and decrease throughput."
        ]
      },
      {
        q: "[Intermediate] How do you analyze load test reports to identify bottlenecks?",
        a: [
          "1. Review Response Time vs. Users: If response times increase linearily while user load increases, but throughput (RPS) flatlines, the server has hit its capacity limit.",
          "2. Check Error Rates: Ensure errors (timeouts, 500 errors) are below acceptable thresholds (usually < 1%).",
          "3. Monitor Resource Usage: Check if CPU or memory utilization on app/DB servers reached 90-100% during execution."
        ]
      },
      {
        q: "[Intermediate] What is a memory leak and how do soak tests help identify them?",
        a: [
          "A memory leak occurs when an application allocates memory but fails to release it back to the system after use.",
          "Soak tests run expected load for 12-24 hours. By monitoring memory consumption over this duration, if memory usage shows a continuous upward slope without ever flattening or dropping (even after garbage collection), it indicates a memory leak."
        ]
      },
      {
        q: "[Intermediate] What is the difference between horizontal and vertical scaling?",
        a: [
          "Vertical Scaling (Scaling Up): Adding more resources (CPU, RAM, SSD capacity) to a single existing server.",
          "Horizontal Scaling (Scaling Out): Adding more server instances to the architecture (e.g., adding 3 app servers behind a load balancer)."
        ]
      },
      {
        q: "[Intermediate] Explain the use of Timers in JMeter.",
        a: [
          "Timers insert delays between request executions to prevent JMeter from hitting the server too fast without delays.",
          "Common Timers:",
          "- Constant Timer: Delays request by a fixed number of milliseconds.",
          "- Uniform Random Timer: Delays request by a random time within a defined range.",
          "- Constant Throughput Timer: Dynamically adjusts delays to maintain a target number of requests per minute."
        ]
      },
      {
        q: "[Intermediate] What is a connection pool and how does it optimize database performance?",
        a: [
          "A connection pool maintains a cache of active database connections. Instead of opening and closing a heavy database connection for every incoming API request, requests reuse connections from the pool, eliminating connection handshake overheads and speeding up DB processing."
        ]
      },
      {
        q: "[Intermediate] What is the difference between hits per second and transactions per second?",
        a: [
          "Hits per Second: The number of raw HTTP requests sent to the server per second.",
          "Transactions per Second (TPS): The number of complete end-to-end user transactions processed successfully per second."
        ]
      },
      {
        q: "[Intermediate] What is client-side caching and how does it affect load tests?",
        a: [
          "Browsers cache static assets (images, CSS, JS) locally so they don't request them again on page reload.",
          "In load tests, configure cache handlers (e.g. JMeter's HTTP Cache Manager) so virtual users simulate realistic browser caching behaviors. Overloading servers with redundant requests for static assets results in unrealistic, inflated load profiles."
        ]
      },
      {
        q: "[Intermediate] What is a thread dump and when is it collected?",
        a: [
          "A thread dump is a snapshot of all active threads running in a JVM process, showing their current states (Running, Waiting, Blocked) and call stacks.",
          "When collected: During performance execution when the application hangs, freeze blocks, or experiences thread deadlocks, to identify which threads are blocked and waiting for resources."
        ]
      },
      {
        q: "[Intermediate] What is a heap dump and when is it analyzed?",
        a: [
          "A heap dump is a binary snapshot of all objects residing in JVM memory at a specific moment.",
          "When analyzed: After an OutOfMemoryError (OOM) crash or when soak testing indicates a memory leak, to identify which objects are occupying the most memory space."
        ]
      },
      {
        q: "[Advanced] How do you design a workload model for a peak load performance test?",
        a: [
          "Workload modeling is designing the user load profiles based on real production analytics:",
          "1. Gather Production Data: Retrieve metrics from APM or server logs (e.g., Google Analytics, Datadog) showing peak hourly traffic and transaction volumes.",
          "2. Identify Core Scenarios: Determine the top 80% user flows (e.g. login, search, add to cart, checkout).",
          "3. Calculate Transaction Rates (TPS): Target TPS = Peak Volume / Time Period.",
          "4. Map VUs and Timings: Configure VUs, ramp-up schedules, think times, and pacing in test scripts to match target TPS."
        ]
      },
      {
        q: "[Advanced] Explain the difference between B-Tree indexes and Hash indexes in database tuning.",
        a: [
          "B-Tree Index: Organizes data in a balanced tree structure. Supports equality (=) and range queries (<, >, BETWEEN) because keys are sorted. Used by default in databases.",
          "Hash Index: Organizes data using hash tables. Extremely fast for equality (=) checks, but does not support range queries or partial matching."
        ]
      },
      {
        q: "[Advanced] How do you troubleshoot high CPU utilization on an application server during a load test?",
        a: [
          "1. Profiling: Run CPU profiling tools (e.g. JProfiler, VisualVM, async-profiler) to identify hot methods executing the most CPU cycles.",
          "2. Check Thread Pools: Review thread dump logs to identify if threads are spending cycles waiting for locks or in infinite loops.",
          "3. Review Garbage Collection: If JVM is low on heap memory, GC will run continuously, consuming high CPU. Analyze GC logs.",
          "4. Optimize Code: Review expensive loops, heavy serialization operations, or recursive functions."
        ]
      },
      {
        q: "[Advanced] How do you tune database queries to resolve database bottlenecks?",
        a: [
          "1. Analyze Execution Plan: Run EXPLAIN / EXPLAIN ANALYZE on slow queries to identify table scans.",
          "2. Create Indexes: Ensure columns inside WHERE clauses, JOIN conditions, and ORDER BY clauses have appropriate indexes.",
          "3. Remove SELECT *: Retrieve only needed columns.",
          "4. Optimize Joins: Use joins instead of subqueries where possible, and join on indexed keys.",
          "5. Partitioning: Split very large tables horizontally by range/date."
        ]
      },
      {
        q: "[Advanced] Explain connection pool tuning parameters and their impacts.",
        a: [
          "- MaxActive / MaxConnections: Max connections that can be allocated from the pool. Too low causes threads to wait for connections; too high consumes DB memory and can overload the DB server.",
          "- MaxIdle: Max connections that can sit idle in the pool without being closed.",
          "- MaxWait: Max time a thread waits for a connection before throwing a timeout error."
        ]
      },
      {
        q: "[Advanced] How do you run load tests programmatically inside CI/CD pipelines?",
        a: [
          "1. Run CLI-first tools (like k6, Gatling, or JMeter in non-GUI mode: `jmeter -n -t test.jmx -l results.jtl`).",
          "2. Define threshold SLA criteria (e.g., abort build if error rate > 1% or response time 95th percentile > 500ms).",
          "3. Execute test task in CI container, parse results file, and upload HTML performance dashboard as artifacts."
        ]
      },
      {
        q: "[Advanced] What is the difference between 90th, 95th, and 99th percentile response times?",
        a: [
          "Percentiles represent the distribution of response times:",
          "- 90th Percentile: 90% of requests completed within this time; 10% took longer.",
          "- 95th Percentile: 95% of requests completed within this time; 5% took longer. (Standard metric for SLAs).",
          "- 99th Percentile: 99% of requests completed within this time; 1% took longer (useful for identifying worst-case performance outliers)."
        ]
      },
      {
        q: "[Advanced] How do you handle and resolve thread deadlocks?",
        a: [
          "A deadlock occurs when Thread 1 holds Lock A and waits for Lock B, while Thread 2 holds Lock B and waits for Lock A.",
          "Resolution:",
          "1. Capture JVM Thread Dump (`jstack <pid>`). The dump will explicitly flag deadlocked threads and stack traces.",
          "2. Refactor code logic to acquire locks in a consistent, predefined global order.",
          "3. Use timed locks (`tryLock()` in Java) to release resources if locks aren't acquired within a timeout."
        ]
      },
      {
        q: "[Advanced] Explain how thread stack sizing and heap memory settings impact JVM performance.",
        a: [
          "Heap Memory (-Xms, -Xmx): Defines the object storage area. Too low causes OutOfMemoryErrors and frequent GC runs; too high causes long Stop-the-World GC pause times.",
          "Stack Size (-Xss): Defines memory allocated per thread. Too low causes StackOverflowErrors; too high limits the total number of thread instances that can be created in system memory."
        ]
      },
      {
        q: "[Advanced] How do you test CDN (Content Delivery Network) caching performance?",
        a: [
          "Analyze HTTP response headers returned from the CDN cache edge servers:",
          "- `X-Cache: HIT` indicates the resource was served from the CDN edge server.",
          "- `X-Cache: MISS` indicates the CDN had to retrieve the resource from the origin app server.",
          "Verify Cache-Control headers (max-age, public) are configured correctly on static assets."
        ]
      },
      {
        q: "[Advanced] How do you simulate high load on WebSocket-based applications?",
        a: [
          "WebSockets maintain persistent bi-directional TCP connections. Use specialized load testing tools (like k6 websockets module or JMeter websocket samplers) to establish thousands of concurrent open websocket connections, send frame payloads, and monitor message round-trip times and connection drop rates."
        ]
      },
      {
        q: "[Advanced] What is spike testing and how do you configure the workload model for it?",
        a: [
          "Spike testing evaluates system behavior under sudden surges in traffic.",
          "Workload Model Configuration:",
          "- Phase 1 (Baseline): Run expected load (e.g. 50 VUs) for 5 minutes.",
          "- Phase 2 (Spike): Rapidly ramp up users (e.g. 1000 VUs) over 10 seconds, maintain for 1 minute.",
          "- Phase 3 (Recovery): Rapidly ramp down back to baseline (50 VUs) and monitor server recovery states."
        ]
      },
      {
        q: "[Advanced] Explain the difference between thread-based concurrency and event-loop concurrency in load generators.",
        a: [
          "Thread-Based (JMeter): Each virtual user is a separate OS thread. High memory footprint (requires 1-2MB stack per user), limiting concurrency on a single machine.",
          "Event-Loop (k6, Gatling): Uses non-blocking asynchronous event loops to manage virtual users. Extremely resource-efficient, allowing a single machine to launch 10x more concurrent users."
        ]
      },
      {
        q: "[Advanced] How do you test database locking anomalies (Dirty Reads, Phantom Reads) under load?",
        a: [
          "Run concurrent transaction scripts that execute inserts and updates while reading data from the same rows. Modify database Transaction Isolation Levels (Read Uncommitted, Repeatable Read) and verify if the database maintains data consistency rules under concurrent lock pressures."
        ]
      },
      {
        q: "[Advanced] What is a circuit breaker pattern and how does it prevent cascading server failures?",
        a: [
          "A circuit breaker is a proxy pattern that monitors failures of downstream services. If a service starts failing repeatedly, the circuit breaker trips (opens), immediately returning error responses to incoming calls without hitting the downstream service. This prevents backend thread pool exhaustion and allows the downstream service to recover."
        ]
      },
      {
        q: "[Advanced] How do you configure load generators to bypass local OS network port exhaustion?",
        a: [
          "During high load, local TCP connection ports can run out (port exhaustion).",
          "Solutions:",
          "1. Optimize OS parameters: Reduce TIME_WAIT timeout boundaries and enable TCP port reuse.",
          "2. Distribute load across multiple load generator IP addresses or machines.",
          "3. Reuse TCP connections (HTTP Keep-Alive) within test script configurations."
        ]
      },
      {
        q: "[Advanced] Explain performance metrics for message queues (RabbitMQ, Kafka) under load.",
        a: [
          "Monitor:",
          "- Message Publish Rate (incoming messages/sec).",
          "- Message Consume Rate (processed messages/sec).",
          "- Consumer Lag (the queue depth or backlog size). High lag indicates consumers cannot keep up with publish rates, causing processing delays."
        ]
      },
      {
        q: "[Advanced] How do you perform performance testing on microservices using service meshes (Istio, Linkerd)?",
        a: [
          "Service meshes introduce proxy sidecars to route traffic. When load testing:",
          "1. Monitor proxy resource usage (CPU/memory overhead of sidecars).",
          "2. Track network hops latency introduced by proxy handshakes.",
          "3. Test distributed tracing (Zipkin, Jaeger) to identify bottleneck services."
        ]
      },
      {
        q: "[Advanced] How do you identify thread contention bottlenecks?",
        a: [
          "Thread contention occurs when multiple threads wait to acquire a lock on the same resource/object.",
          "Identify via Thread Dumps: Search for threads in blocked status (`BLOCKED (on object monitor)`). Trace the stack to find the synchronized code block causing the queue."
        ]
      },
      {
        q: "[Advanced] Explain auto-scaling policies tuning during spike testing.",
        a: [
          "Auto-scaling policies add instances based on triggers (e.g. CPU > 70%).",
          "During spikes, instances take time to spin up (cooldown/warmup delay). Test spike workloads to tune policies: reduce cool-down boundaries, use predictive scaling, or pre-warm instances before anticipated traffic surges."
        ]
      }
    ]
  },
  "agile-qa": {
    title: "Agile & DevOps for QA",
    qa: [
      {
        q: "[Beginner] What is Agile and how does it differ from the Waterfall model?",
        a: [
          "Agile: An iterative and incremental software development methodology focusing on collaboration, customer feedback, and rapid small releases. Highly adaptable to requirement changes.",
          "Waterfall: A sequential, linear model where each phase (Requirements, Design, Coding, Testing, Deployment) must complete before the next starts. Very difficult and costly to adapt to requirement changes mid-way."
        ]
      },
      {
        q: "[Beginner] What is Scrum and what are the three key roles in it?",
        a: [
          "Scrum is the most popular framework implementing Agile principles.",
          "Key Roles:",
          "1. Product Owner (PO): Defines business requirements, manages the Product Backlog, and prioritizes stories based on value.",
          "2. Scrum Master: Facilitates ceremonies, coaches the team, and removes roadblocks/impediments.",
          "3. Development Team: Cross-functional group (developers, QA, designers) responsible for delivering the usable product increment."
        ]
      },
      {
        q: "[Beginner] List the standard Scrum ceremonies (events) and their purposes.",
        a: [
          "1. Sprint Planning: The team defines the sprint goal and selects stories from the backlog to complete in the upcoming sprint.",
          "2. Daily Standup (Daily Scrum): A 15-minute sync where team members discuss what they did yesterday, what they will do today, and any blockers.",
          "3. Sprint Review: Demoing the completed increment to stakeholders for feedback.",
          "4. Sprint Retrospective: Refusal meeting at the end of the sprint where the team reviews what went well, what failed, and how to improve processes."
        ]
      },
      {
        q: "[Beginner] What is a User Story?",
        a: [
          "A User Story is an informal, general explanation of a software feature written from the perspective of the end user.",
          "Format: As a [User Type], I want to [Perform Action], So that [Goal/Value]."
        ]
      },
      {
        q: "[Beginner] What is Acceptance Criteria in a user story?",
        a: [
          "Acceptance Criteria is a set of predefined requirements/conditions that must be met for a user story to be marked as completed. It defines the boundaries of the feature and is used by QA to write test scenarios."
        ]
      },
      {
        q: "[Beginner] Explain the difference between Product Backlog and Sprint Backlog.",
        a: [
          "Product Backlog: A prioritized list of all features, enhancements, bug fixes, and requirements needed for the product. Managed by the Product Owner.",
          "Sprint Backlog: A subset of stories selected from the product backlog to be completed during the active sprint, managed by the development team."
        ]
      },
      {
        q: "[Beginner] What is a Sprint?",
        a: [
          "A Sprint is a time-boxed iteration (usually 1 to 4 weeks) during which the Scrum team builds and delivers a usable, potentially shippable product increment."
        ]
      },
      {
        q: "[Beginner] What is the difference between Kanban and Scrum?",
        a: [
          "Scrum: Time-boxed iterations (sprints), structured roles, defined ceremonies, and velocity tracking.",
          "Kanban: Continuous flow system without set roles or sprints. Focuses on visualizing work on a board and restricting Work-in-Progress (WIP) limits to prevent bottlenecks."
        ]
      },
      {
        q: "[Beginner] What is a Burn-Down Chart?",
        a: [
          "A Burn-Down Chart is a visual representation showing the amount of work remaining in the sprint vs. time. It helps the team track progress and see if they are on path to complete the sprint backlog."
        ]
      },
      {
        q: "[Beginner] What is a Burn-Up Chart?",
        a: [
          "A Burn-Up Chart shows the total amount of work completed over time alongside the total scope of the project, highlighting scope changes during execution."
        ]
      },
      {
        q: "[Intermediate] What is the difference between Definition of Ready (DoR) and Definition of Done (DoD)?",
        a: [
          "Definition of Ready (DoR): Criteria a user story must satisfy before it can be pulled into a sprint (e.g., clear requirements, mockups, acceptance criteria, estimated).",
          "Definition of Done (DoD): Criteria the product increment must satisfy to be marked complete and shippable (e.g. code reviewed, unit tested, QA validated in staging, documentation updated)."
        ]
      },
      {
        q: "[Intermediate] What are Story Points and how are they estimated?",
        a: [
          "Story Points measure the size, complexity, effort, and risk involved in implementing a user story, rather than hours.",
          "Estimation: Commonly uses the Fibonacci sequence (1, 2, 3, 5, 8, 13) via Planning Poker. Features are compared relatively against a baseline story."
        ]
      },
      {
        q: "[Intermediate] What is team Velocity in Agile?",
        a: [
          "Velocity is the average number of story points completed and marked as 'Done' by the Scrum team per sprint. It is used to forecast capacity for future sprints."
        ]
      },
      {
        q: "[Intermediate] What is CI/CD and why is it crucial for DevOps?",
        a: [
          "Continuous Integration (CI): Automates code compilation, merging, and testing whenever developers push code to the repository.",
          "Continuous Delivery (CD): Automates releasing the verified build artifacts to a repository, ready to be deployed to staging/production.",
          "Why it is crucial: Reduces integration delays, detects bugs early, and speeds up time-to-market."
        ]
      },
      {
        q: "[Intermediate] What is the difference between Continuous Delivery and Continuous Deployment?",
        a: [
          "Continuous Delivery: The build is automated and ready for release, but the final deployment to production requires manual approval.",
          "Continuous Deployment: Every code change that passes the automated testing pipeline is deployed directly to production environments without human intervention."
        ]
      },
      {
        q: "[Intermediate] Explain the concept of 'Shift Left' testing.",
        a: [
          "Shift Left testing is a practice where testing activities are performed earlier in the software development lifecycle (shifting left on the timeline).",
          "Includes involving QA in requirement reviews, writing unit tests, and executing API validation before the full frontend code is built. Detects bugs early when they are cheapest to fix."
        ]
      },
      {
        q: "[Intermediate] Explain the concept of 'Shift Right' testing.",
        a: [
          "Shift Right testing is testing in production environments under real-world scenarios.",
          "Includes activities like synthetic monitoring, A/B testing, feature flagging, canary deployments, log analysis, and feedback monitoring."
        ]
      },
      {
        q: "[Intermediate] How do you handle testing when requirements change mid-sprint?",
        a: [
          "1. Assess Impact: Discuss with the PO and developers to understand the scope and feasibility of the change.",
          "2. Review Backlog: If the change is significant, the PO should swap or pull out existing stories to maintain sprint scope boundaries.",
          "3. Dynamic adjustment: Update test scenarios, prioritize testing critical paths first, and flag any risks of not meeting the DoD."
        ]
      },
      {
        q: "[Intermediate] What is a spike story (spiking) in Agile?",
        a: [
          "A spike is a research or prototyping task aimed at resolving technical uncertainty, gathering requirements, or evaluating implementation options before estimating user stories."
        ]
      },
      {
        q: "[Intermediate] What is a bug triage meeting and who participates?",
        a: [
          "A bug triage meeting is a sync where new defects are evaluated and prioritized.",
          "Participants: Product Owner (PO), QA Lead/Tester, Development Lead.",
          "Goals: Verify bug reproducibility, assign severity/priority, and decide which sprint they must be fixed in."
        ]
      },
      {
        q: "[Intermediate] Explain the role of QA in DevOps.",
        a: [
          "QA acts as a quality gatekeeper. QA designs automated test pipelines, integrates smoke and regression checks into the CI/CD pipeline, analyzes automated reports, and monitors production health (shifting right) to ensure quality across code flows."
        ]
      },
      {
        q: "[Intermediate] What is a regression testing strategy in a fast-paced Agile environment?",
        a: [
          "In short sprints, manual regression is impossible. Strategy:",
          "- Automate critical smoke tests and run them on every commit.",
          "- Schedule full automated regression suites to run nightly.",
          "- Focus manual effort on exploratory testing of new features during the sprint."
        ]
      },
      {
        q: "[Intermediate] What is exploratory testing and why is it valuable in Agile?",
        a: [
          "Exploratory testing is simultaneous learning, test design, and test execution. The tester explores the application freely without scripted cases.",
          "Value: Uncovers edge cases, usability flaws, and hidden bugs that scripted automated tests miss."
        ]
      },
      {
        q: "[Intermediate] What is the Scrum Board (Task Board)?",
        a: [
          "A visual board showing the status of sprint items (e.g. To Do, In Progress, In Review, QA, Done) to maintain transparency and show sprint progress."
        ]
      },
      {
        q: "[Intermediate] What is a retrospective action item?",
        a: [
          "An actionable task identified during the Sprint Retrospective to improve team processes in the next sprint (e.g., 'Ensure all mockups are attached to stories before sprint planning')."
        ]
      },
      {
        q: "[Intermediate] Explain the difference between GitFlow and Trunk-Based development.",
        a: [
          "GitFlow: Uses multiple long-lived branches (master, develop, feature, release, hotfix). Code is merged via PRs. High overhead, slower releases.",
          "Trunk-Based: Developers merge code directly into a single central branch ('trunk') multiple times a day. Requires robust automation pipelines and feature flags."
        ]
      },
      {
        q: "[Intermediate] What is a Pull Request (PR) and why is QA concerned with it?",
        a: [
          "A PR is a request to merge code changes into a branch.",
          "QA concern: Merging code can break existing features. Automated CI pipelines should trigger build checks and test runs on every PR before code is allowed to merge."
        ]
      },
      {
        q: "[Intermediate] What is Epic in Agile?",
        a: [
          "An Epic is a large body of work that cannot be completed in a single sprint and is broken down into smaller user stories."
        ]
      },
      {
        q: "[Intermediate] What is the difference between Scrum and Agile?",
        a: [
          "Agile is the general philosophy and mindset defined by the Agile Manifesto.",
          "Scrum is a specific, structured framework that implements Agile principles using sprints, ceremonies, and roles."
        ]
      },
      {
        q: "[Intermediate] What is backlog grooming (refinement)?",
        a: [
          "A recurring meeting where the PO and team review, clarify, estimate, and prioritize stories in the product backlog to ensure they satisfy the DoR before sprint planning."
        ]
      },
      {
        q: "[Advanced] How do you integrate automated tests into a Jenkins CI/CD pipeline?",
        a: [
          "Use a Jenkinsfile to define pipeline stages:",
          "pipeline {",
          "    agent any",
          "    stages {",
          "        stage('Checkout') { steps { checkout scm } }",
          "        stage('Build') { steps { sh 'npm install' } }",
          "        stage('Test') { steps { sh 'npm run test:smoke' } }",
          "    }",
          "    post {",
          "        always { junit 'reports/*.xml' }",
          "    }",
          "}"
        ]
      },
      {
        q: "[Advanced] What are Quality Gates in a CI/CD pipeline?",
        a: [
          "Quality Gates are code quality checkpoints that a build must pass to proceed in the pipeline. Commonly measured using tools like SonarQube:",
          "- Code Coverage % (e.g. must be > 80%).",
          "- Technical Debt / Duplicated lines threshold.",
          "- Absence of high-severity security vulnerabilities."
        ]
      },
      {
        q: "[Advanced] Explain the Test Pyramid concept.",
        a: [
          "The Test Pyramid is a framework design guideline suggesting:",
          "1. Base (Largest): Unit Tests. Fast, cheap to write/run, highly selective.",
          "2. Middle: Integration/API Tests. Test system communication boundaries.",
          "3. Top (Smallest): UI/E2E Tests. Slow, expensive, fragile. Keep them limited to critical workflows."
        ]
      },
      {
        q: "[Advanced] What are feature flags (toggles) and how do they support DevOps?",
        a: [
          "Feature flags allow code to be deployed to production with a feature turned 'off' dynamically.",
          "How they support DevOps: Enables Trunk-Based Development, allows dark launching (deploying code without exposing features), and supports easy rollbacks by toggling the flag off if production bugs occur."
        ]
      },
      {
        q: "[Advanced] What is Canary Deployment and how is it tested?",
        a: [
          "Canary Deployment is releasing a new version to a small subset of real users (e.g. 5%) before rolling it out globally.",
          "Testing: Monitor error rates, latency, and logs on the canary server compared to production baselines. If metrics match, route 100% of traffic to the new version."
        ]
      },
      {
        q: "[Advanced] Explain the difference between Blue-Green Deployment and Rolling Deployment.",
        a: [
          "Blue-Green: Maintaining two identical production environments (Blue is active, Green is idle/staging). Deploy changes to Green, test, then switch load balancer traffic to Green instantly.",
          "Rolling: Gradually replacing old instances with new ones across a cluster, ensuring zero downtime, but multiple code versions exist simultaneously."
        ]
      },
      {
        q: "[Advanced] How do you handle flaky tests in a CI pipeline to prevent pipeline blockages?",
        a: [
          "1. Quarantine: Isolate flaky tests into a separate suite so they don't block release builds.",
          "2. Log Traces: Capture screenshots, HTML reports, and network traces on failure for analysis.",
          "3. Automated Retries: Configure test runners to retry failed tests twice before flagging a build failure."
        ]
      },
      {
        q: "[Advanced] What is Infrastructure as Code (IaC) and how does it benefit QA?",
        a: [
          "IaC (e.g. Terraform, Ansible) manages and provisions test environments programmatically via code files.",
          "Benefit: Allows QA to spin up identical, ephemeral test environments dynamically in containers, reducing 'it works on my machine' configuration flakiness."
        ]
      },
      {
        q: "[Advanced] Explain 'Shift Right' testing practices: Synthetic Monitoring vs Real User Monitoring.",
        a: [
          "Synthetic Monitoring: Simulating user scripts programmatically at regular intervals in production to detect server outages or performance degradations.",
          "Real User Monitoring (RUM): Capturing and analyzing the actual network, CPU, and page load experiences of real users loading the site dynamically."
        ]
      },
      {
        q: "[Advanced] What is Chaos Engineering and what is its role in QA?",
        a: [
          "Chaos Engineering is intentionally introducing failures (e.g. killing server nodes, disconnecting databases, introducing network delays) into a production system to test its resilience.",
          "Role in QA: Validates fallback systems, timeout limits, alert mechanisms, and recovery speeds under actual failure conditions."
        ]
      },
      {
        q: "[Advanced] What is containerization and how do Docker containers optimize testing?",
        a: [
          "Containerization wraps an application and its dependencies inside a single container image.",
          "How it optimizes testing: Eliminates environment configuration mismatches between developer machines, QA staging, and production servers, and supports highly scalable concurrent test execution grids."
        ]
      },
      {
        q: "[Advanced] How do you calculate Code Coverage vs Test Coverage?",
        a: [
          "Code Coverage: Percentage of source code lines, branches, or statements executed by automated unit/integration tests. Measured by tools (e.g. Jacoco, Istanbul).",
          "Test Coverage: Qualitative measure checking which software requirements/features are covered by the written test suite cases (mapped using an RTM)."
        ]
      },
      {
        q: "[Advanced] Explain Git branching strategies: Rebasing vs Merging.",
        a: [
          "Merge: Combines branch histories, creating a merge commit. Preserves exact history context but can result in messy commit trees.",
          "Rebase: Moves the entire branch commits to the tip of the target branch, creating a clean linear history, but rewriting history can be risky on shared branches."
        ]
      },
      {
        q: "[Advanced] What is virtual service virtualization (mocking APIs) in DevOps?",
        a: [
          "Service Virtualization mocks the behavior of dependent components (e.g., third-party APIs or databases) that are unavailable, slow, or expensive to use during automation execution, ensuring continuous test runs."
        ]
      },
      {
        q: "[Advanced] What is static code analysis and when is it executed?",
        a: [
          "Static Analysis inspects source code without running it to locate syntax bugs, styling violations, and security leaks. It runs early in the CI build step (Shift Left) using tools like ESLint, SonarQube, or Checkstyle."
        ]
      },
      {
        q: "[Advanced] Explain the term 'Technical Debt' and how it impacts QA.",
        a: [
          "Technical Debt is the cost of choosing quick, unoptimized code implementations today over cleaner, refactored code patterns.",
          "Impact: Makes code additions brittle, increases regression defects, and degrades automated test suite reliability."
        ]
      },
      {
        q: "[Advanced] What is GitOps?",
        a: [
          "GitOps is a DevOps practice where Git repositories act as the single source of truth for infrastructure and application deployment configurations, leveraging Git operations (MRs/PRs) to manage deployments."
        ]
      },
      {
        q: "[Advanced] How do you handle secrets (passwords, tokens) securely in CI pipelines?",
        a: [
          "Never hardcode credentials in code. Inject them as encrypted environment variables during the CI runtime process using secret vaults (e.g. GitHub Secrets, AWS Secrets Manager, HashiCorp Vault)."
        ]
      },
      {
        q: "[Advanced] Explain the difference between Unit, Integration, and Contract Testing.",
        a: [
          "Unit: Validates single functions/methods.",
          "Integration: Checks communication between combined modules.",
          "Contract: Validates boundary schemas (inputs/outputs) of service endpoints, ensuring microservices can interact successfully without integration breakdowns."
        ]
      },
      {
        q: "[Advanced] What is Gherkin syntax in BDD?",
        a: [
          "A structured natural language format used in BDD feature files using Keywords: `Feature`, `Scenario`, `Given` (setup), `When` (action), `Then` (validation), and `And`."
        ]
      }
    ]
  },
  "security-testing": {
    title: "Security Testing",
    qa: [
      {
        q: "[Beginner] What is Security Testing and why is it important?",
        a: [
          "Security Testing is a type of software testing that uncovers vulnerabilities, threats, and risks in a software application and prevents malicious attacks from intruders.",
          "Why it is important:",
          "- Protects sensitive user data (passwords, credit cards, health records).",
          "- Maintains client trust and brand reputation.",
          "- Ensures compliance with regulations (GDPR, PCI-DSS, HIPAA).",
          "- Prevents catastrophic financial loss from system downtime or ransom attacks."
        ]
      },
      {
        q: "[Beginner] Explain the CIA Triad in security.",
        a: [
          "The CIA Triad is a benchmark model designed to guide information security policies:",
          "1. Confidentiality: Ensuring only authorized users have access to specific data.",
          "2. Integrity: Ensuring data is accurate, complete, and has not been altered or tampered with in transit or storage.",
          "3. Availability: Ensuring authorized users have reliable, uninterrupted access to systems and data when needed."
        ]
      },
      {
        q: "[Beginner] What is the difference between Authentication and Authorization?",
        a: [
          "Authentication (AuthN): Verifying *who* a user is (e.g., logging in with a username and password, or face ID).",
          "Authorization (AuthZ): Verifying *what* permissions the authenticated user has (e.g. checking if a logged-in user can access the admin dashboard or delete a database record)."
        ]
      },
      {
        q: "[Beginner] What is a security vulnerability, threat, and risk?",
        a: [
          "Vulnerability: A weakness or loophole in the application code, design, or infrastructure (e.g. missing input sanitization).",
          "Threat: A potential negative event that can exploit a vulnerability (e.g., a hacker attempting SQL injection).",
          "Risk: The probability and financial/technical impact of a threat successfully exploiting a vulnerability."
        ]
      },
      {
        q: "[Beginner] What is the difference between Hashing, Encryption, and Encoding?",
        a: [
          "Hashing: A one-way function that converts input into a fixed-length string (hash). Cannot be decrypted. Used for password storage (e.g., bcrypt, SHA-256).",
          "Encryption: A two-way function that scrambles data using a key, allowing it to be decrypted back to plaintext with the correct key (e.g. AES, RSA).",
          "Encoding: Reformatting data structure for compatibility or transmission (e.g. Base64, URL encoding). Not meant for security as it requires no key to decode."
        ]
      },
      {
        q: "[Beginner] What is the OWASP organization?",
        a: [
          "OWASP (Open Web Application Security Project) is a non-profit foundation that works to improve web application security. It is best known for publishing the OWASP Top 10, a regularly updated report outlining the most critical security risks facing web applications."
        ]
      },
      {
        q: "[Beginner] What is SQL Injection (SQLi)?",
        a: [
          "SQL Injection is a vulnerability where an attacker inserts malicious SQL statements into input forms or API requests, tricking the backend database into executing unauthorized commands (e.g. bypassing login screens, deleting tables, or dumping sensitive user tables)."
        ]
      },
      {
        q: "[Beginner] What is Cross-Site Scripting (XSS)?",
        a: [
          "Cross-Site Scripting is a vulnerability where an attacker injects malicious client-side scripts (usually JavaScript) into web pages viewed by other users, allowing the attacker to steal session cookies, hijack accounts, or redirect users to phishing sites."
        ]
      },
      {
        q: "[Beginner] Explain the difference between Stored XSS and Reflected XSS.",
        a: [
          "Stored XSS (Persistent): The malicious script is permanently stored on the target server (e.g. in a database comment field) and executed whenever users load the page.",
          "Reflected XSS (Non-Persistent): The malicious script is part of a request (usually in URL query parameters) and gets immediately reflected back in the server response without being stored."
        ]
      },
      {
        q: "[Beginner] What is a Brute-Force attack?",
        a: [
          "A Brute-Force attack is a trial-and-error method where an attacker programmatically attempts thousands of password combinations or credentials sequentially to guess a user's password and compromise accounts."
        ]
      },
      {
        q: "[Intermediate] How do you prevent SQL Injection vulnerabilities in code?",
        a: [
          "1. Use Parameterized Queries (Prepared Statements): Separates SQL query structure from input parameters, ensuring inputs are treated strictly as literal values rather than executable code.",
          "2. Use ORM frameworks: Hibernate or Entity Framework naturally parameterize queries by default.",
          "3. Input Validation: Enforce strict whitelisting of input characters.",
          "4. Principle of Least Privilege: Ensure the database user used by the app has restricted privileges (e.g., cannot drop tables)."
        ]
      },
      {
        q: "[Intermediate] How do you prevent Cross-Site Scripting (XSS) vulnerabilities?",
        a: [
          "1. Context-Aware Output Encoding: Encode all user-supplied data before rendering it in the HTML, Javascript, or CSS context (e.g., converting `<` to `&lt;`).",
          "2. Content Security Policy (CSP): Configure HTTP headers to restrict which domains can load scripts.",
          "3. Use modern frameworks: React and Angular automatically sanitize and encode output variables by default."
        ]
      },
      {
        q: "[Intermediate] What is Cross-Site Request Forgery (CSRF) and how is it prevented?",
        a: [
          "CSRF is an attack that forces an authenticated user to execute unwanted actions (e.g. transferring funds, changing email) on a web application where they are currently logged in.",
          "Prevention:",
          "- Use Anti-CSRF Tokens: Unique, unpredictable tokens generated by the server and validated on every state-changing POST/PUT request.",
          "- SameSite Cookie Attribute: Configure session cookies with `SameSite=Strict` or `SameSite=Lax` to prevent browsers from sending cookies with cross-site requests."
        ]
      },
      {
        q: "[Intermediate] What are the differences between SAST and DAST tools?",
        a: [
          "SAST (Static Application Security Testing): Analyzes source code or binaries without executing the application (white-box testing). Finds issues early in development (Shift Left). Tools: SonarQube, Checkmarx.",
          "DAST (Dynamic Application Security Testing): Analyzes a running application from the outside (black-box testing) by injecting payloads and observing responses. Finds runtime configurations issues. Tools: OWASP ZAP, Burp Suite."
        ]
      },
      {
        q: "[Intermediate] Explain cookie flags that enhance session security.",
        a: [
          "- HttpOnly: Prevents client-side scripts (JavaScript) from accessing the cookie, mitigating cookie theft via XSS.",
          "- Secure: Restricts the cookie to be transmitted strictly over encrypted (HTTPS) connections, preventing network sniffing attacks.",
          "- SameSite: Restricts cookie transmissions on cross-site requests (Strict/Lax/None), preventing CSRF."
        ]
      },
      {
        q: "[Intermediate] What is Pen Testing (Penetration Testing)? Describe its stages.",
        a: [
          "Pen Testing is a simulated cyberattack against an application or network to locate exploit points.",
          "Stages:",
          "1. Reconnaissance: Gathering information about target systems.",
          "2. Scanning: Using tools (e.g., Nmap) to find open ports and running services.",
          "3. Exploitation: Attacking vulnerabilities to gain access.",
          "4. Maintaining Access: Establishing persistent backdoors.",
          "5. Reporting: Documenting findings, risk levels, and remediation steps."
        ]
      },
      {
        q: "[Intermediate] What is the difference between Symmetric and Asymmetric Encryption?",
        a: [
          "Symmetric: Uses the same secret key for both encryption and decryption (e.g. AES). Fast, but distributing the secret key securely is difficult.",
          "Asymmetric: Uses a public key to encrypt and a separate private key to decrypt (e.g. RSA). More secure key distribution model, but computationally slower."
        ]
      },
      {
        q: "[Intermediate] What is a man-in-the-middle (MITM) attack and how do you prevent it?",
        a: [
          "A MITM attack is where an attacker secretly relays and alters communication between a client and server (e.g. sniffing traffic on public Wi-Fi).",
          "Prevention:",
          "- Enforce HTTPS globally using SSL/TLS.",
          "- Implement HSTS (HTTP Strict Transport Security) headers to force HTTPS connection upgrades.",
          "- Implement Certificate Pinning on mobile applications."
        ]
      },
      {
        q: "[Intermediate] What is a Denial of Service (DoS) vs. Distributed Denial of Service (DDoS) attack?",
        a: [
          "DoS: A single source floods a target server with traffic to exhaust its resources (bandwidth, CPU), rendering it unavailable.",
          "DDoS: Multiple compromised systems (botnets) globally flood the target server simultaneously, making it extremely difficult to block based on a single IP address."
        ]
      },
      {
        q: "[Intermediate] Explain how rate limiting protects applications.",
        a: [
          "Rate limiting limits the number of requests a user (defined by IP, token, or API key) can make within a defined time frame (e.g., max 5 login attempts per minute). It protects against brute-force logins, credential stuffing, and application-layer DoS attacks."
        ]
      },
      {
        q: "[Intermediate] What is Broken Object Level Authorization (BOLA/IDOR)?",
        a: [
          "BOLA (formerly Insecure Direct Object Reference) is a vulnerability where an application uses user-supplied keys to access resources without checking permissions. E.g. changing request parameter `id=101` to `id=102` allows reading another user's private data."
        ]
      },
      {
        q: "[Intermediate] What is a Security Audit?",
        a: [
          "A Security Audit is a structured, systematic evaluation of an organization's security policies, system configurations, and application source code to ensure compliance with security standards."
        ]
      },
      {
        q: "[Intermediate] Explain the difference between Vulnerability Scanning and Penetration Testing.",
        a: [
          "Vulnerability Scanning: Automated process that scans systems for known signatures of vulnerabilities and lists them. Fast, broad scope, high false-positives.",
          "Penetration Testing: Manual, highly targeted execution by security professionals who validate vulnerabilities, attempt exploits, and assess actual business risk."
        ]
      },
      {
        q: "[Intermediate] What is the difference between Black-Box, Grey-Box, and White-Box security testing?",
        a: [
          "Black-Box: Tester has no prior knowledge of code structures or system architecture. Simulates external hacker.",
          "Grey-Box: Tester has limited knowledge (e.g., user credentials, architecture diagrams).",
          "White-Box: Tester has full access to source code, configs, and internal documentation."
        ]
      },
      {
        q: "[Intermediate] Explain what Salting is and why it is used in password hashing.",
        a: [
          "Salting is appending a random sequence of characters (a salt) to a password before hashing it.",
          "Why it is used: If two users have the same password ('12345'), they will produce identical hashes, allowing attackers using precomputed lookup tables (Rainbow Tables) to crack both. Salting ensures identical passwords produce completely unique hashes."
        ]
      },
      {
        q: "[Intermediate] What is an XML External Entity (XXE) vulnerability?",
        a: [
          "An XXE vulnerability occurs when an unconfigured XML parser processes input containing references to external XML entities. This can allow attackers to read local system files, perform SSRF attacks, or scan internal networks."
        ]
      },
      {
        q: "[Intermediate] What is a Session Hijacking attack?",
        a: [
          "Session Hijacking is where an attacker compromises a user's session identifier (session cookie/JWT token) and injects it into their own browser to gain unauthorized access to the user's account without credentials."
        ]
      },
      {
        q: "[Intermediate] What is Cross-Origin Resource Sharing (CORS) and why is its misconfiguration dangerous?",
        a: [
          "CORS is a browser mechanism restricting websites from making API requests to a different domain.",
          "Misconfiguration danger: Setting headers to `Access-Control-Allow-Origin: *` alongside `Allow-Credentials: true` allows malicious external sites to read response data from your authenticated API routes."
        ]
      },
      {
        q: "[Intermediate] Explain the purpose of security scanning tools: Nmap, Nessus, and OWASP ZAP.",
        a: [
          "Nmap: Network scanner used to discover hosts, open ports, and operating system versions.",
          "Nessus: Enterprise vulnerability scanner used to scan servers, databases, and networks for outdated software and configurations.",
          "OWASP ZAP: Web application security scanner used to automatically crawl and find vulnerabilities in web apps during dev/QA builds."
        ]
      },
      {
        q: "[Intermediate] What is credential stuffing?",
        a: [
          "Credential stuffing is an automated attack where lists of compromised username/password pairs (from previous database leaks of other companies) are programmatically tested on multiple other websites to locate matching accounts."
        ]
      },
      {
        q: "[Advanced] What is Server-Side Request Forgery (SSRF) and how do you test for it?",
        a: [
          "SSRF is a vulnerability where an attacker forces a server-side application to make HTTP requests to an arbitrary domain, often targeting internal metadata endpoints or private cloud APIs.",
          "How to test:",
          "- Input URL fields: Submit local loopback IPs (e.g. `http://127.0.0.1:80` or `http://169.254.169.254` for AWS metadata).",
          "- Verify if the server returns internal infrastructure metadata payloads in the response."
        ]
      },
      {
        q: "[Advanced] Explain Threat Modeling using the STRIDE methodology.",
        a: [
          "STRIDE is a security threat modeling framework developed by Microsoft:",
          "- Spoofing: Pretending to be someone else (violates Authenticity).",
          "- Tampering: Modifying data in transit/storage (violates Integrity).",
          "- Repudiation: Denying actions performed (violates Non-repudiation).",
          "- Information Disclosure: Leaking data to unauthorized users (violates Confidentiality).",
          "- Denial of Service: Overloading resources (violates Availability).",
          "- Elevation of Privilege: Gaining unauthorized administrative access (violates Authorization)."
        ]
      },
      {
        q: "[Advanced] Detail key HTTP security headers and what attacks they mitigate.",
        a: [
          "1. Content-Security-Policy (CSP): Restricts source domains for scripts, styles, and images. Mitigates XSS.",
          "2. Strict-Transport-Security (HSTS): Forces browsers to use HTTPS for all future requests. Mitigates MITM and SSL stripping.",
          "3. X-Frame-Options: Restricts if the page can be loaded inside an iframe (DENY / SAMEORIGIN). Mitigates Clickjacking.",
          "4. X-Content-Type-Options: Set to `nosniff`. Prevents browsers from MIME-sniffing files, mitigating drive-by downloads."
        ]
      },
      {
        q: "[Advanced] What is Clickjacking and how is it prevented?",
        a: [
          "Clickjacking is a visual exploit where an attacker overlays a transparent iframe of a target website (e.g. a bank transfer page) on top of an attractive decoy button, tricking users into clicking the hidden interface.",
          "Prevention: Set the `X-Frame-Options: DENY` header, or configure CSP directive `frame-ancestors 'none'`."
        ]
      },
      {
        q: "[Advanced] How does JWT (JSON Web Token) security work? Describe common vulnerabilities.",
        a: [
          "JWTs are stateless authorization tokens consisting of Header, Payload, and Signature, signed with a secret key.",
          "Vulnerabilities:",
          "1. Signature Bypass: Setting the alg header parameter to `none`. Weak parsers will skip validation.",
          "2. Weak Secret Keys: Attacking weak signature HMAC secrets offline using brute-force dictionaries.",
          "3. Replay Attacks: Lack of exp (expiration time) validation checks on the backend resource servers."
        ]
      },
      {
        q: "[Advanced] What is the difference between asymmetric cryptosystems RSA and Elliptic Curve Cryptography (ECC)?",
        a: [
          "RSA: Relies on the mathematical difficulty of factoring large prime integers. Requires large key sizes (e.g., 2048 or 4096 bits) to be secure.",
          "ECC: Relies on algebraic structures of elliptic curves. ECC provides equivalent security to RSA at much smaller key sizes (e.g. 256 bits vs 3072 bits RSA), consuming significantly less CPU, memory, and network overhead, making it ideal for mobile/IoT devices."
        ]
      },
      {
        q: "[Advanced] What is Insecure Deserialization and how is it exploited?",
        a: [
          "Insecure Deserialization occurs when untrusted user-supplied serialized object strings are parsed back into memory objects by the application.",
          "Exploitation: Attackers manipulate serialized object values to inject malicious commands or logic payloads. When deserialized, the app executes the injected payload, leading to Remote Code Execution (RCE) or privilege elevations."
        ]
      },
      {
        q: "[Advanced] Explain the difference between DAST, SAST, IAST, and RASP.",
        a: [
          "SAST: Scans source code during build. Zero environment dependency.",
          "DAST: Scans running application via external HTTP attacks.",
          "IAST (Interactive Application Security Testing): Combines SAST and DAST by placing an agent inside the application runtime server, monitoring execution lines during dynamic tests.",
          "RASP (Runtime Application Self-Protection): Security agent embedded within the app server that active-monitors requests and blocks attacks in production dynamically."
        ]
      },
      {
        q: "[Advanced] How do you test for SQL Injection using time-based blind SQL Injection techniques?",
        a: [
          "Time-Based Blind SQLi is used when the server does not display database errors or query results in HTTP responses.",
          "Test technique: Inject a command that forces the database to pause (sleep) if a condition evaluates to true. E.g. `id=1 AND IF(1=1, SLEEP(5), 0)`. If the server response takes 5 seconds longer than normal, it confirms SQL injection vulnerability."
        ]
      },
      {
        q: "[Advanced] What is DOM-based XSS and how does it differ from Stored/Reflected XSS?",
        a: [
          "Stored and Reflected XSS involve server-side responses rendering malicious payloads.",
          "DOM-based XSS exists completely in the client-side JavaScript execution environment. It occurs when client scripts execute source data (e.g., `location.search` query parameters) directly into sink functions (like `element.innerHTML` or `eval()`) without sanitization, never reaching the backend server."
        ]
      },
      {
        q: "[Advanced] What is a Directory Traversal attack and how do you test for it?",
        a: [
          "Directory Traversal allows attackers to read arbitrary files on the server running the application.",
          "Testing: Supply path traversal character sequences (e.g. `../../../../etc/passwd` or `..\..\..\..\windows\win.ini`) to file parameter inputs and check if server files are returned in the response."
        ]
      },
      {
        q: "[Advanced] What is SSL/TLS Handshake? Describe its phases.",
        a: [
          "The SSL/TLS handshake establishes an encrypted channel between client and server:",
          "1. ClientHello: Client sends supported cipher suites and SSL version.",
          "2. ServerHello & Certificate: Server responds with its SSL certificate containing its public key.",
          "3. Key Exchange: Client verifies certificate, generates a pre-master secret key, encrypts it with the server's public key, and sends it back.",
          "4. Symmetric Key derivation: Both compute a master session key to encrypt/decrypt all future communications."
        ]
      },
      {
        q: "[Advanced] Explain OAuth 2.0 grant types and their security considerations.",
        a: [
          "- Authorization Code: Best for server-side apps. Codes are exchanged for tokens backend, secure.",
          "- Implicit: Deprecated. Tokens returned directly in URL fragment on client, vulnerable to history sniffing.",
          "- Client Credentials: Used for machine-to-machine syncs, credentials must be stored securely.",
          "Security: Ensure strict matching of redirect_uri parameters to prevent token theft."
        ]
      },
      {
        q: "[Advanced] What is SQL Injection using union-based extraction?",
        a: [
          "Union-based SQLi utilizes the UNION operator to combine results of the application's query with a malicious query, allowing attackers to read metadata structures and retrieve values from other tables in the database.",
          "Payload example: `' UNION SELECT null, username, password FROM users --`"
        ]
      },
      {
        q: "[Advanced] Explain the difference between vulnerability disclosure programs and bug bounties.",
        a: [
          "Vulnerability Disclosure Program (VDP): A structured policy/framework allowing ethical hackers to report security vulnerabilities responsibly without legal fear, but without payouts.",
          "Bug Bounty: A program where organizations invite security researchers to find bugs and offer financial rewards (bounties) based on vulnerability severity levels."
        ]
      },
      {
        q: "[Advanced] What is zero-day vulnerability?",
        a: [
          "A zero-day vulnerability is a software security flaw that is known to the public/attacker but has not yet been patched or resolved by the vendor, leaving 'zero days' of protection."
        ]
      },
      {
        q: "[Advanced] Explain how to mitigate brute-force attacks securely beyond rate limiting.",
        a: [
          "- Implement CAPTCHA tasks after three failed login attempts.",
          "- Implement Account Lockout policies (temporarily lock accounts after 5 failed attempts).",
          "- Mandatory Multi-Factor Authentication (MFA).",
          "- Monitor and block suspicious IP clusters using Web Application Firewalls (WAF)."
        ]
      },
      {
        q: "[Advanced] What is buffer overflow and how does it happen?",
        a: [
          "A buffer overflow occurs when a program writes more data to a block of memory (buffer) than it was allocated to hold. The excess data spills over into adjacent memory spaces, overwriting call stacks and allowing attackers to inject shellcode commands."
        ]
      },
      {
        q: "[Advanced] Explain the difference between hashing algorithms MD5, SHA-1, and bcrypt for password storage.",
        a: [
          "MD5 & SHA-1: Extremely fast general-purpose hashing functions. Deprecated for passwords because GPUs can calculate billions of hashes per second, making them highly vulnerable to dictionary brute-force attacks.",
          "bcrypt: A slow, adaptive hashing algorithm that uses a configurable work factor (rounds). It slows down calculation speed, making brute-force cracking mathematically infeasible."
        ]
      },
      {
        q: "[Advanced] What is an API Gateway and how does it enhance security?",
        a: [
          "An API Gateway acts as a reverse proxy orchestrating traffic. It centralizes security policies like rate limiting, OAuth token validation, CORS management, request sanitization, and SSL termination before requests reach backend microservices."
        ]
      }
    ]
  },
  "sql-qa": {
    title: "SQL Database & Queries",
    qa: [
      {
        q: "[Real-Time] 1. Find duplicate records in a table",
        a: [
          "SELECT column1, column2, COUNT(*)",
          "FROM your_table",
          "GROUP BY column1, column2",
          "HAVING COUNT(*) > 1;"
        ]
      },
      {
        q: "[Real-Time] 2. Retrieve the second highest salary from the Employee table",
        a: [
          "SELECT MAX(salary) AS SecondHighestSalary",
          "FROM Employee",
          "WHERE salary < (SELECT MAX(salary) FROM Employee);"
        ]
      },
      {
        q: "[Real-Time] 3. Find employees without department (LEFT JOIN)",
        a: [
          "SELECT e.*",
          "FROM Employee e",
          "LEFT JOIN Department d",
          "ON e.department_id = d.department_id",
          "WHERE d.department_id IS NULL;"
        ]
      },
      {
        q: "[Real-Time] 4. Calculate the total revenue per product",
        a: [
          "SELECT product_id,",
          "SUM(quantity * price) AS total_revenue",
          "FROM Sales",
          "GROUP BY product_id;"
        ]
      },
      {
        q: "[Real-Time] 5. Get the top 3 highest-paid employees",
        a: [
          "SELECT TOP 3 *",
          "FROM Employee",
          "ORDER BY salary DESC;"
        ]
      },
      {
        q: "[Real-Time] 6. Customers who made purchases but never returned products",
        a: [
          "SELECT DISTINCT c.customer_id",
          "FROM Customers c",
          "JOIN Orders o ON c.customer_id = o.customer_id",
          "WHERE c.customer_id NOT IN (",
          "SELECT customer_id FROM Returns",
          ");"
        ]
      },
      {
        q: "[Real-Time] 7. Show the count of orders per customer",
        a: [
          "SELECT customer_id,",
          "COUNT(*) AS order_count",
          "FROM Orders",
          "GROUP BY customer_id;"
        ]
      },
      {
        q: "[Real-Time] 8. Retrieve all employees who joined in 2023",
        a: [
          "SELECT *",
          "FROM Employee",
          "WHERE YEAR(hire_date)=2023;"
        ]
      },
      {
        q: "[Real-Time] 9. Calculate the average order value per customer",
        a: [
          "SELECT customer_id,",
          "AVG(total_amount) AS avg_order_value",
          "FROM Orders",
          "GROUP BY customer_id;"
        ]
      },
      {
        q: "[Real-Time] 10. Get the latest order placed by each customer",
        a: [
          "SELECT customer_id,",
          "MAX(order_date) AS latest_order_date",
          "FROM Orders",
          "GROUP BY customer_id;"
        ]
      },
      {
        q: "[Real-Time] 11. Find products that were never sold",
        a: [
          "SELECT p.product_id",
          "FROM Products p",
          "LEFT JOIN Sales s",
          "ON p.product_id=s.product_id",
          "WHERE s.product_id IS NULL;"
        ]
      },
      {
        q: "[Real-Time] 12. Identify the most selling product",
        a: [
          "SELECT TOP 1 product_id,",
          "SUM(quantity) AS total_qty",
          "FROM Sales",
          "GROUP BY product_id",
          "ORDER BY total_qty DESC;"
        ]
      },
      {
        q: "[Real-Time] 13. Get the total revenue and the number of orders per region",
        a: [
          "SELECT region,",
          "SUM(total_amount) AS total_revenue,",
          "COUNT(*) AS order_count",
          "FROM Orders",
          "GROUP BY region;"
        ]
      },
      {
        q: "[Real-Time] 14. Count how many customers placed more than 5 orders",
        a: [
          "SELECT COUNT(*) AS customer_count",
          "FROM (",
          "SELECT customer_id",
          "FROM Orders",
          "GROUP BY customer_id",
          "HAVING COUNT(*) > 5",
          ") AS subquery;"
        ]
      },
      {
        q: "[Real-Time] 15. Retrieve orders above the average order value",
        a: [
          "SELECT *",
          "FROM Orders",
          "WHERE total_amount > (",
          "SELECT AVG(total_amount)",
          "FROM Orders",
          ");"
        ]
      },
      {
        q: "[Real-Time] 16. Find all employees hired on weekends",
        a: [
          "SELECT *",
          "FROM Employee",
          "WHERE DATENAME(WEEKDAY, hire_date)",
          "IN ('Saturday','Sunday');"
        ]
      },
      {
        q: "[Beginner] What is DBMS and how does it differ from RDBMS?",
        a: [
          "DBMS (Database Management System) is software used to store, manage, and retrieve data (e.g., in files or simple XML).",
          "RDBMS (Relational Database Management System) is a database management system based on the relational model introduced by E.F. Codd.",
          "In RDBMS, data is structured and stored in tables (relations) with rows and columns.",
          "RDBMS supports integrity constraints (Primary Key, Foreign Key) and enforces relationships between tables.",
          "RDBMS supports transactions with ACID properties, whereas standard DBMS might not."
        ]
      },
      {
        q: "[Beginner] What are the different types of SQL Commands?",
        a: [
          "DDL (Data Definition Language): Defines the database schema. E.g., CREATE, ALTER, DROP, TRUNCATE.",
          "DML (Data Manipulation Language): Manages data within objects. E.g., INSERT, UPDATE, DELETE, SELECT (sometimes classified as DQL).",
          "DQL (Data Query Language): Used to retrieve data. E.g., SELECT.",
          "DCL (Data Control Language): Controls privileges and access. E.g., GRANT, REVOKE.",
          "TCL (Transaction Control Language): Manages changes made by DML commands. E.g., COMMIT, ROLLBACK, SAVEPOINT."
        ]
      },
      {
        q: "[Beginner] What is the difference between Primary Key and Foreign Key?",
        a: [
          "Primary Key uniquely identifies each record in a table. It cannot contain NULL values and must be unique.",
          "Foreign Key is a field in one table that refers to the Primary Key of another table. It establishes a link/relationship between two tables.",
          "A table can have only one Primary Key, but it can have multiple Foreign Keys.",
          "Foreign keys can accept NULL values unless defined otherwise (e.g., NOT NULL)."
        ]
      },
      {
        q: "[Beginner] Write the queries to CREATE tables with relationships (Primary Key & Foreign Key).",
        a: [
          "-- Create a master departments table",
          "CREATE TABLE departments (",
          "  dept_id INT PRIMARY KEY,",
          "  dept_name VARCHAR(50) NOT NULL",
          ");",
          "",
          "-- Create employees table referencing departments",
          "CREATE TABLE employees (",
          "  emp_id INT PRIMARY KEY,",
          "  name VARCHAR(100) NOT NULL,",
          "  salary DECIMAL(10,2),",
          "  dept_id INT,",
          "  FOREIGN KEY (dept_id) REFERENCES departments(dept_id)",
          ");"
        ]
      },
      {
        q: "[Beginner] Write the queries to ADD/INSERT data into tables and MODIFY columns.",
        a: [
          "-- Inserting records into departments",
          "INSERT INTO departments (dept_id, dept_name) VALUES",
          "(1, 'Engineering'),",
          "(2, 'Marketing');",
          "",
          "-- Inserting records into employees",
          "INSERT INTO employees (emp_id, name, salary, dept_id) VALUES",
          "(101, 'Alice', 95000.00, 1),",
          "(102, 'Bob', 82000.00, 2),",
          "(103, 'Charlie', 75000.00, 1);",
          "",
          "-- Adding a new column to employees table",
          "ALTER TABLE employees ADD email VARCHAR(150);"
        ]
      },
      {
        q: "[Beginner] Write the queries to DELETE rows, truncate data, and DROP tables.",
        a: [
          "-- Deleting specific rows matching a condition",
          "DELETE FROM employees WHERE emp_id = 103;",
          "",
          "-- Emptying all data from table (resets indexes/counters)",
          "TRUNCATE TABLE employees;",
          "",
          "-- Deleting the entire table schema and data permanently",
          "DROP TABLE employees;",
          "DROP TABLE departments;"
        ]
      },
      {
        q: "[Intermediate] Explain the different types of Joins in SQL.",
        a: [
          "INNER JOIN: Returns records that have matching values in both tables.",
          "LEFT JOIN (LEFT OUTER JOIN): Returns all records from the left table, and the matched records from the right table. Fill with NULL if no match.",
          "RIGHT JOIN (RIGHT OUTER JOIN): Returns all records from the right table, and the matched records from the left table. Fill with NULL if no match.",
          "FULL JOIN (FULL OUTER JOIN): Returns all records when there is a match in either left or right table."
        ]
      },
      {
        q: "[Intermediate] Write the queries to JOIN tables (INNER, LEFT, RIGHT, and FULL joins).",
        a: [
          "-- INNER JOIN (Returns only matched records)",
          "SELECT e.name, d.dept_name FROM employees e INNER JOIN departments d ON e.dept_id = d.dept_id;",
          "",
          "-- LEFT JOIN (Returns all employees, matching dept_name if exists)",
          "SELECT e.name, d.dept_name FROM employees e LEFT JOIN departments d ON e.dept_id = d.dept_id;",
          "",
          "-- RIGHT JOIN (Returns all departments, matching employee names if exists)",
          "SELECT e.name, d.dept_name FROM employees e RIGHT JOIN departments d ON e.dept_id = d.dept_id;",
          "",
          "-- FULL OUTER JOIN (Returns all matching and non-matching records from both tables)",
          "SELECT e.name, d.dept_name FROM employees e FULL OUTER JOIN departments d ON e.dept_id = d.dept_id;"
        ]
      },
      {
        q: "[Intermediate] What is the difference between WHERE and HAVING clauses?",
        a: [
          "WHERE clause is used to filter records before any groupings are made.",
          "HAVING clause is used to filter records after grouping (used with GROUP BY).",
          "WHERE clause can be used with SELECT, UPDATE, and DELETE statements.",
          "HAVING clause can only be used with SELECT statements.",
          "Aggregate functions (like SUM, COUNT, AVG) cannot be used in a WHERE clause, but can be used in a HAVING clause."
        ]
      },
      {
        q: "[Intermediate] What is the difference between DELETE and TRUNCATE commands?",
        a: [
          "DELETE is a DML command used to remove specific rows based on a WHERE clause. It logs individual row deletions and is slower.",
          "TRUNCATE is a DDL command used to remove all rows from a table. It deallocates data pages directly, making it much faster.",
          "DELETE can be rolled back if used within a transaction block.",
          "TRUNCATE cannot be rolled back in some legacy databases (though standard transactional RDBMS like PostgreSQL support it), and it resets identity columns."
        ]
      },
      {
        q: "[Intermediate] What is a Subquery and what are the types?",
        a: [
          "A subquery is a query nested inside another query (e.g., inside SELECT, INSERT, UPDATE, or DELETE).",
          "Single-row subquery: Returns only one row. Uses operators like =, <, >.",
          "Multiple-row subquery: Returns multiple rows. Uses operators like IN, ANY, ALL.",
          "Correlated subquery: A subquery that references columns from the outer query, executing once for each row processed by the outer query."
        ]
      },
      {
        q: "[Intermediate] What is Database Normalization and its forms?",
        a: [
          "Normalization is the process of organizing data to reduce redundancy and improve data integrity.",
          "1NF (First Normal Form): Eliminate duplicate columns, ensure atomic (indivisible) values, and define a primary key.",
          "2NF (Second Normal Form): Must be in 1NF, and all non-key columns must fully depend on the primary key (eliminate partial dependencies).",
          "3NF (Third Normal Form): Must be in 2NF, and all columns must depend directly on the primary key (eliminate transitive dependencies)."
        ]
      },
      {
        q: "[Intermediate] How do you identify and delete duplicate rows in a table?",
        a: [
          "Step 1: Identify duplicates using GROUP BY and HAVING",
          "SELECT email, COUNT(*) FROM Users GROUP BY email HAVING COUNT(*) > 1;",
          "Step 2: Delete duplicates keeping the row with the lowest ID (using a CTE and ROW_NUMBER)",
          "WITH CTE AS (SELECT id, ROW_NUMBER() OVER (PARTITION BY email ORDER BY id) as rn FROM Users) DELETE FROM Users WHERE id IN (SELECT id FROM CTE WHERE rn > 1);"
        ]
      },
      {
        q: "[Intermediate] How do you write a query to fetch the maximum salary in each department along with the employee name?",
        a: [
          "Using a window function is the cleanest way:",
          "WITH RankedDeptEmployees AS (SELECT name, department, salary, ROW_NUMBER() OVER (PARTITION BY department ORDER BY salary DESC) as rn FROM Employee) SELECT name, department, salary FROM RankedDeptEmployees WHERE rn = 1;"
        ]
      },
      {
        q: "[Advanced] What are ACID properties in a database transaction?",
        a: [
          "Atomicity: Ensures that all operations within a transaction are completed successfully; otherwise, the transaction is aborted and rolled back.",
          "Consistency: Ensures the database changes state only upon a successfully committed transaction, maintaining all schema rules and constraints.",
          "Isolation: Ensures that concurrent transactions execute independently without interfering with each other.",
          "Durability: Ensures that the results of a committed transaction persist even in the event of a system crash or power failure."
        ]
      },
      {
        q: "[Advanced] What is an Index and what are the types?",
        a: [
          "An Index is a database structure used to speed up data retrieval operations on a table.",
          "Clustered Index: Determines the physical order of data storage in the table. There can only be one clustered index per table (usually the Primary Key).",
          "Non-Clustered Index: Creates a separate structure pointing to the physical data rows. A table can have multiple non-clustered indexes."
        ]
      },
      {
        q: "[Advanced] How do you find the Nth highest salary in an Employee table?",
        a: [
          "Method 1: Using a subquery (generic SQL)",
          "SELECT MIN(Salary) FROM (SELECT DISTINCT Salary FROM Employee ORDER BY Salary DESC LIMIT N) AS Temp;",
          "Method 2: Using the DENSE_RANK() window function (recommended for handling ties)",
          "WITH RankedSalaries AS (SELECT Salary, DENSE_RANK() OVER (ORDER BY Salary DESC) as rnk FROM Employee) SELECT DISTINCT Salary FROM RankedSalaries WHERE rnk = N;"
        ]
      },
      {
        q: "[Advanced] Explain the difference between ROW_NUMBER(), RANK(), and DENSE_RANK().",
        a: [
          "ROW_NUMBER(): Assigns a unique sequential integer starting from 1 to each row, regardless of ties. E.g., (1, 2, 3, 4).",
          "RANK(): Assigns a rank to each row. If there are ties, it assigns the same rank and skips subsequent ranks. E.g., (1, 2, 2, 4).",
          "DENSE_RANK(): Assigns a rank to each row. If there are ties, it assigns the same rank without skipping any subsequent ranks. E.g., (1, 2, 2, 3)."
        ]
      },
      {
        q: "[Advanced] How do you optimize a slow-running SQL query in production?",
        a: [
          "1. Run EXPLAIN or EXPLAIN ANALYZE on the query to view the execution plan and locate bottlenecks (e.g., Table Scans).",
          "2. Add Indexes on columns used frequently in WHERE clauses, JOIN conditions, and ORDER BY clauses.",
          "3. Avoid SELECT *; retrieve only required columns to reduce I/O and network payload.",
          "4. Avoid functions or wildcards at the beginning of index columns (e.g., use LIKE 'abc%' instead of LIKE '%abc%').",
          "5. Denormalize high-frequency read tables or use Materialized Views if real-time synchronization isn't strictly required.",
          "6. Partition very large tables by date or range to limit scan scope."
        ]
      },
      {
        q: "[Advanced] What are CTEs (Common Table Expressions) and what is a Recursive CTE?",
        a: [
          "A CTE is a temporary, named result set that you can reference within a SELECT, INSERT, UPDATE, or DELETE statement.",
          "Syntax: WITH MyCTE AS (SELECT col1 FROM Table) SELECT * FROM MyCTE;",
          "A Recursive CTE is a CTE that references itself. It is extremely useful for querying hierarchical data, such as organizational charts (manager-employee relationships) or folder directories."
        ]
      },
      {
        q: "[Advanced] What is a Deadlock and how can it be prevented?",
        a: [
          "A Deadlock occurs when two or more transactions are waiting for resource locks held by each other, causing all of them to stall.",
          "Prevention tips:",
          "1. Ensure all applications lock resources/tables in the exact same logical order.",
          "2. Keep database transactions as short and lightweight as possible.",
          "3. Use appropriate transaction isolation levels (e.g., Read Committed instead of Serializable if possible).",
          "4. Implement locking timeouts (e.g., SET LOCK_TIMEOUT in SQL Server) to abort waiting transactions and release locks."
        ]
      },
      {
        q: "[Advanced] Explain Transaction Isolation Levels and the concurrency anomalies they prevent.",
        a: [
          "1. Read Uncommitted: Allows dirty reads (reading uncommitted data changes from other transactions). Low isolation, high concurrency.",
          "2. Read Committed: Prevents dirty reads. Allows non-repeatable reads (data changes between reads in the same transaction).",
          "3. Repeatable Read: Prevents dirty and non-repeatable reads. In some systems, allows phantom reads (new rows inserted by other transactions).",
          "4. Serializable: Full isolation. Prevents all anomalies (Dirty reads, Non-repeatable reads, Phantom reads) by locking ranges of rows. Lowest concurrency."
        ]
      },
      {
        q: "[Advanced] How do lead() and lag() window functions work? Give a real-world scenario.",
        a: [
          "LEAD() fetches data from a subsequent row in the same result set without using self-joins.",
          "LAG() fetches data from a preceding row in the same result set.",
          "Real-World Scenario: Calculating Month-over-Month (MoM) sales growth.",
          "SELECT Month, Sales, Sales - LAG(Sales, 1) OVER (ORDER BY Month) as SalesGrowth FROM MonthlyRevenue;"
        ]
      },
      {
        q: "[Advanced] Compare Optimistic Locking vs Pessimistic Locking.",
        a: [
          "Optimistic Locking: Assumes multiple transactions can complete without affecting each other. It checks for conflict only when committing (e.g. using a version number or timestamp column). If a conflict is found, transaction rolls back.",
          "Pessimistic Locking: Assumes conflicts are highly likely. It explicitly locks rows (e.g., SELECT ... FOR UPDATE) when reading them, blocking other transactions from modifying them until the lock is released."
        ]
      },
      {
        q: "[Advanced] Explain the difference between a Database View, Materialized View, and Temporary Table.",
        a: [
          "View: A virtual table representing the result of a stored query. It does not store data physically; the query runs every time the view is accessed.",
          "Materialized View: A physical copy of the query result stored on disk. It must be refreshed (manually or on a schedule) to sync with source tables. Highly efficient for complex aggregations.",
          "Temporary Table: A session-specific table stored in temporary memory/disk. It exists only during the connection lifetime and is useful for complex multi-step data transformations."
        ]
      },
      {
        q: "[Advanced] What is Database Sharding, and how does it differ from Horizontal Partitioning?",
        a: [
          "Horizontal Partitioning: Splits rows of a single table across multiple tables/disks within the *same database instance* based on a key (e.g. partition by Date).",
          "Sharding: A shared-nothing architecture where data is partitioned horizontally across *multiple independent database servers/machines*.",
          "Sharding allows database systems to scale horizontally past hardware limits of a single machine, but introduces complexity in cross-shard joins and transaction management."
        ]
      },
      {
        q: "[Advanced] Explain Query Join Operators: Nested Loops, Hash Join, and Merge Join.",
        a: [
          "Nested Loops: For each row in the outer table, it scans the inner table. Best for small datasets or when the inner table has a highly selective index.",
          "Hash Join: Builds an in-memory hash table of the smaller join input, then probes it with the larger input. Efficient for large unsorted datasets.",
          "Merge Join: Reads two sorted inputs and merges them. Fastest join type but requires both inputs to be sorted on the join key (usually utilizing indexes)."
        ]
      },
      {
        q: "[Intermediate] How do you find the second highest salary without using LIMIT or OFFSET?",
        a: [
          "Using a subquery with the MAX aggregate function is the standard ANSI SQL solution:",
          "SELECT MAX(salary) FROM employees WHERE salary < (SELECT MAX(salary) FROM employees);"
        ]
      },
      {
        q: "[Intermediate] How do you fetch employees who earn more than their manager (Self-Join scenario)?",
        a: [
          "You must join the employee table to itself, treating one instance as employee (e) and the other as manager (m):",
          "SELECT e.name AS employee_name, e.salary, m.name AS manager_name, m.salary FROM employees e INNER JOIN employees m ON e.manager_id = m.emp_id WHERE e.salary > m.salary;"
        ]
      },
      {
        q: "[Intermediate] How do you query for employees who do NOT belong to any department?",
        a: [
          "Method 1: Using IS NULL",
          "SELECT name FROM employees WHERE dept_id IS NULL;",
          "Method 2: Using a LEFT JOIN to identify unmatched records",
          "SELECT e.name FROM employees e LEFT JOIN departments d ON e.dept_id = d.dept_id WHERE d.dept_id IS NULL;"
        ]
      },
      {
        q: "[Intermediate] How do you swap values in a column without using a temporary table? (e.g. Swapping 'Male' and 'Female' in a gender column)",
        a: [
          "Use a CASE statement inside an UPDATE query to conditionally swap values in-place:",
          "UPDATE Users SET gender = CASE WHEN gender = 'Male' THEN 'Female' ELSE 'Male' END;"
        ]
      },
      {
        q: "[Intermediate] How do you select only odd or even rows from a table?",
        a: [
          "-- Query to fetch records with odd IDs",
          "SELECT * FROM employees WHERE MOD(emp_id, 2) <> 0;",
          "",
          "-- Query to fetch records with even IDs",
          "SELECT * FROM employees WHERE MOD(emp_id, 2) = 0;"
        ]
      },
      {
        q: "[Intermediate] How do you fetch rows that are common between two different tables?",
        a: [
          "Method 1: Using an INNER JOIN",
          "SELECT a.* FROM TableA a INNER JOIN TableB b ON a.id = b.id;",
          "Method 2: Using the INTERSECT operator (supported in PostgreSQL, Oracle, SQL Server)",
          "SELECT id, name FROM TableA INTERSECT SELECT id, name FROM TableB;"
        ]
      },
      {
        q: "[Beginner] What is the difference between CHAR and VARCHAR data types?",
        a: [
          "CHAR is fixed-length. If you define CHAR(10) and store 'cat', the remaining 7 spaces are padded with spaces. Ideal for values of constant length like ISO codes or country codes.",
          "VARCHAR is variable-length. If you define VARCHAR(10) and store 'cat', it occupies only 3 characters of storage space. Ideal for addresses, names, and descriptions."
        ]
      },
      {
        q: "[Beginner] What is a NULL value in SQL and how do you test for it?",
        a: [
          "A NULL value represents missing, unknown, or inapplicable data. It is not equivalent to zero or an empty string.",
          "To test for NULL, use the IS NULL or IS NOT NULL operators:",
          "SELECT * FROM employees WHERE manager_id IS NULL;"
        ]
      },
      {
        q: "[Beginner] Explain the SELECT DISTINCT statement with an example.",
        a: [
          "SELECT DISTINCT is used to return only unique (different) values from a column, eliminating duplicates from the output:",
          "SELECT DISTINCT department FROM employees;"
        ]
      },
      {
        q: "[Beginner] What is the default sorting order of ORDER BY and how do you reverse it?",
        a: [
          "By default, ORDER BY sorts values in ascending order (ASC).",
          "To reverse it to descending order, append the DESC keyword:",
          "SELECT * FROM employees ORDER BY salary DESC;"
        ]
      },
      {
        q: "[Beginner] What is the difference between the BETWEEN and IN operators?",
        a: [
          "BETWEEN filters values within a continuous range (inclusive of endpoints):",
          "SELECT * FROM employees WHERE salary BETWEEN 50000 AND 80000;",
          "IN filters values that match any values in a discrete list:",
          "SELECT * FROM employees WHERE department IN ('HR', 'Finance', 'Engineering');"
        ]
      },
      {
        q: "[Intermediate] Explain the difference between UNION and UNION ALL.",
        a: [
          "UNION: Combines result sets of two SELECT statements and filters out duplicate rows. It performs an implicit sorting operation to de-duplicate, which is slower.",
          "UNION ALL: Combines result sets of two SELECT statements and includes all duplicates. It is faster because no sorting or de-duplication occurs."
        ]
      },
      {
        q: "[Intermediate] What is a Self Join and when would you use it?",
        a: [
          "A Self Join is a regular join where a table is joined with itself. It requires using table aliases to distinguish the left copy from the right copy.",
          "Common Use Case: Querying hierarchical data, such as finding employees and their managers from a single employee table containing a manager_id column."
        ]
      },
      {
        q: "[Intermediate] How do wildcards work with the LIKE operator?",
        a: [
          "The LIKE operator is used in WHERE clauses to search for a specified pattern in a column using wildcards:",
          "1. % (Percent sign): Matches zero, one, or multiple characters. E.g., 'a%' finds values starting with 'a'.",
          "2. _ (Underscore): Matches exactly one character. E.g., '_r%' finds values having 'r' as the second character."
        ]
      },
      {
        q: "[Intermediate] Explain SQL aggregate functions: COUNT, SUM, AVG, MIN, and MAX.",
        a: [
          "Aggregate functions perform a calculation on a set of values and return a single value:",
          "COUNT(): Returns the number of rows matching the query.",
          "SUM(): Returns the total sum of a numeric column.",
          "AVG(): Returns the average value of a numeric column.",
          "MIN(): Returns the smallest value in the column.",
          "MAX(): Returns the largest value in the column."
        ]
      },
      {
        q: "[Intermediate] What is Referential Integrity and how does a Foreign Key enforce it?",
        a: [
          "Referential Integrity is a database state where all foreign key references are valid.",
          "A Foreign Key enforces this by preventing orphaned records. It ensures that a value in a child table's foreign key column must already exist in the referenced parent table's primary key column, and prevents deleting parent records that still have child references."
        ]
      },
      {
        q: "[Intermediate] Explain the EXISTS operator and how it differs from the IN operator.",
        a: [
          "EXISTS checks for the existence of any rows matching a subquery. It halts evaluation as soon as a single match is found, making it very efficient for large datasets.",
          "IN compares values in the outer query against a literal list or subquery result set, scanning the entire list."
        ]
      },
      {
        q: "[Intermediate] What is the COALESCE() function and how is it used?",
        a: [
          "COALESCE() evaluates its arguments in order and returns the first non-NULL value in the list. It is commonly used to provide default values for null columns:",
          "SELECT name, COALESCE(bonus, 0) AS bonus_received FROM employees;"
        ]
      },
      {
        q: "[Advanced] What is a Database Trigger and what are common use cases?",
        a: [
          "A Trigger is a stored SQL block that automatically runs in response to database modifications (INSERT, UPDATE, DELETE) on a table.",
          "Common Use Cases:",
          "- Auditing: Logging data changes (who updated which row and when).",
          "- Data Integrity: Performing complex validations before saving.",
          "- Synchronization: Replicating changes to history or mirror tables."
        ]
      },
      {
        q: "[Advanced] What is the difference between a Stored Procedure and a User-Defined Function (UDF)?",
        a: [
          "Stored Procedure: Used to execute complex transactional logic. It can modify database states, accept input/output parameters, does not need to return a value, and can commit/rollback transactions.",
          "User-Defined Function: Used to perform calculations and must return a single value or table. It cannot modify database states, cannot call transactions, and can be used directly inside SELECT or WHERE statements."
        ]
      },
      {
        q: "[Advanced] How do indexes affect write performance (INSERT/UPDATE/DELETE)?",
        a: [
          "While indexes speed up read operations (SELECT), they degrade write performance.",
          "Every time a row is inserted, updated, or deleted, the database must also update the underlying B-Tree index structures to keep them synchronized with the table data. Minimize unnecessary indexes on tables with heavy write loads."
        ]
      },
      {
        q: "[Advanced] Explain ACID transactions using COMMIT, ROLLBACK, and SAVEPOINT syntax.",
        a: [
          "COMMIT: Saves all changes made during the current transaction permanently.",
          "ROLLBACK: Undoes all changes made during the transaction, restoring the database to its previous state.",
          "SAVEPOINT: Creates a checkpoint within a transaction, allowing you to roll back a portion of the transaction rather than the entire block."
        ]
      },
      {
        q: "[Advanced] What is recursive query execution and when would you use it?",
        a: [
          "Recursive queries use self-referential CTEs to loop and traverse hierarchical relations (such as org structures, category trees, or flight routes) until a base termination condition is met.",
          "Example organizational hierarchy traversal:",
          "WITH RECURSIVE OrgChart AS (",
          "  SELECT emp_id, name, manager_id, 1 as level FROM employees WHERE manager_id IS NULL",
          "  UNION ALL",
          "  SELECT e.emp_id, e.name, e.manager_id, o.level + 1 FROM employees e INNER JOIN OrgChart o ON e.manager_id = o.emp_id",
          ") SELECT * FROM OrgChart;"
        ]
      }
    ]
  },
  "playwright-qa": {
    title: "Playwright Automation",
    qa: [
      {
        q: "[Beginner] What is Playwright and why is it preferred over other automation tools like Selenium?",
        a: [
          "Playwright is a modern open-source framework for end-to-end web testing developed by Microsoft.",
          "Why it is preferred:",
          "1. Multi-Browser Support: Runs tests on Chromium, Firefox, and WebKit (Safari engine) using a single API.",
          "2. Auto-Waiting: Automatically waits for elements to be actionable (visible, enabled, stable) before performing actions, drastically reducing flakiness.",
          "3. Multiple Contexts: Supports browser contexts which act as isolated incognito profiles, enabling super fast execution and parallel testing.",
          "4. Network Interception: Easily mocks and intercepts API requests and responses.",
          "5. Native Tooling: Includes Codegen (test generator), Inspector, and Trace Viewer out-of-the-box."
        ]
      },
      {
        q: "[Beginner] How do you write a basic Playwright test script in JavaScript?",
        a: [
          "Here is a simple test case validating a page title and text:",
          "const { test, expect } = require('@playwright/test');",
          "",
          "test('Basic Navigation Test', async ({ page }) => {",
          "  // Navigate to URL",
          "  await page.goto('https://example.com');",
          "",
          "  // Validate page title",
          "  await expect(page).toHaveTitle(/Example Domain/);",
          "",
          "  // Verify heading text is visible",
          "  const heading = page.locator('h1');",
          "  await expect(heading).toHaveText('Example Domain');",
          "});"
        ]
      },
      {
        q: "[Beginner] What are locators in Playwright and how do they differ from Selenium selectors?",
        a: [
          "Locators are the central piece of Playwright's auto-waiting and retry-ability logic.",
          "Unlike Selenium WebElements, which search for elements immediately and throw NoSuchElementException if missing, Playwright locators are 'lazy' descriptions.",
          "They only look for the element when an action (e.g., click(), fill()) is performed, retrying until it becomes actionable.",
          "Example locators:",
          "page.getByRole('button', { name: 'Submit' })",
          "page.getByPlaceholder('Enter your email')",
          "page.getByText('Welcome back')",
          "page.locator('.custom-class-name')"
        ]
      },
      {
        q: "[Beginner] How do you capture screenshots and record videos in Playwright?",
        a: [
          "You can configure this globally in `playwright.config.js` or write inline code:",
          "",
          "-- Config file configuration:",
          "use: {",
          "  screenshot: 'only-on-failure', // Options: 'off', 'on', 'only-on-failure'",
          "  video: 'retain-on-failure',     // Options: 'off', 'on', 'retain-on-failure'",
          "}",
          "",
          "-- Inline Javascript screenshot syntax:",
          "await page.screenshot({ path: 'screenshot.png', fullPage: true });"
        ]
      },
      {
        q: "[Intermediate] How do you handle dropdown selects and checkboxes in Playwright?",
        a: [
          "-- Select option from dropdown by value, label, or index:",
          "await page.locator('select#country').selectOption('US'); // value",
          "await page.locator('select#country').selectOption({ label: 'United States' }); // label",
          "await page.locator('select#country').selectOption({ index: 2 }); // index",
          "",
          "-- Checking and unchecking checkboxes/radio buttons:",
          "await page.getByLabel('I agree to terms').check();",
          "await expect(page.getByLabel('I agree to terms')).toBeChecked();",
          "await page.getByLabel('I agree to terms').uncheck();"
        ]
      },
      {
        q: "[Intermediate] How do you handle JavaScript alerts, confirms, and prompts in Playwright?",
        a: [
          "Playwright automatically dismisses dialogs by default so tests don't freeze. To handle them explicitly, register a dialog listener before the action:",
          "",
          "page.on('dialog', async dialog => {",
          "  console.log(dialog.message());",
          "  await dialog.accept('Prompt Input text'); // Accepts or submits text input",
          "  // Or: await dialog.dismiss(); // Cancels the dialog",
          "});",
          "",
          "await page.getByRole('button', { name: 'Trigger Alert' }).click();"
        ]
      },
      {
        q: "[Intermediate] How do you handle iframes and nested frames in Playwright?",
        a: [
          "Access standard frames using locator.frameLocator() or page.frame():",
          "",
          "-- Access using frameLocator (recommended, supports auto-waiting):",
          "const iframe = page.frameLocator('iframe#payment-frame');",
          "await iframe.getByPlaceholder('Card Number').fill('4111 1111 1111');",
          "",
          "-- Access by name or URL:",
          "const frame = page.frame({ name: 'frame-name' });",
          "await frame.click('button#submit');"
        ]
      },
      {
        q: "[Intermediate] Explain the Page Object Model (POM) structure in Playwright.",
        a: [
          "POM organizes test code by wrapping web element locators and actions into class structures representing pages.",
          "",
          "-- Page Object Class (LoginPage.js):",
          "class LoginPage {",
          "  constructor(page) {",
          "    this.page = page;",
          "    this.usernameInput = page.getByPlaceholder('Username');",
          "    this.passwordInput = page.getByPlaceholder('Password');",
          "    this.loginBtn = page.getByRole('button', { name: 'Login' });",
          "  }",
          "  async login(user, pass) {",
          "    await this.usernameInput.fill(user);",
          "    await this.passwordInput.fill(pass);",
          "    await this.loginBtn.click();",
          "  }",
          "}",
          "module.exports = { LoginPage };",
          "",
          "-- Usage in Test File (login.spec.js):",
          "const { test } = require('@playwright/test');",
          "const { LoginPage } = require('./LoginPage');",
          "",
          "test('Successful Login', async ({ page }) => {",
          "  const loginPage = new LoginPage(page);",
          "  await page.goto('/login');",
          "  await loginPage.login('user123', 'securePass');",
          "});"
        ]
      },
      {
        q: "[Intermediate] How do you intercept, block, or mock network API requests?",
        a: [
          "Use page.route() to mock API responses or block resources (like images/CSS to speed up tests):",
          "",
          "-- Mocking an API JSON response:",
          "await page.route('**/api/v1/users', async route => {",
          "  const json = [{ id: 1, name: 'Mocked User' }];",
          "  await route.fulfill({ json });",
          "});",
          "await page.goto('/users-list'); // Sees 'Mocked User'",
          "",
          "-- Blocking image files:",
          "await page.route('**/*.{png,jpg,jpeg}', route => route.abort());"
        ]
      },
      {
        q: "[Advanced] How do you handle multi-tab (multiple pages) operations in Playwright?",
        a: [
          "Capture new pages created when clicking a target link (e.g. target='_blank'):",
          "",
          "// Start waiting for the popup page before clicking",
          "const pagePromise = context.waitForEvent('page');",
          "",
          "await page.getByText('Open Terms in New Tab').click();",
          "const newPage = await pagePromise;",
          "",
          "await newPage.waitForLoadState();",
          "console.log(await newPage.title());",
          "await newPage.getByRole('button', { name: 'Accept' }).click();",
          "await newPage.close();"
        ]
      },
      {
        q: "[Advanced] Explain Storage State. How do you login once and share state across all tests?",
        a: [
          "Avoid logging in before every single test by saving the session authentication state (cookies and local storage) to a JSON file.",
          "",
          "-- Step 1: Save auth state inside a setup test:",
          "test('Authenticate User', async ({ page }) => {",
          "  await page.goto('/login');",
          "  await page.fill('#user', 'admin');",
          "  await page.fill('#pass', 'secret');",
          "  await page.click('button#submit');",
          "  await page.context().storageState({ path: 'auth/state.json' });",
          "});",
          "",
          "-- Step 2: Reference the auth state file in config:",
          "use: {",
          "  storageState: 'auth/state.json'",
          "}"
        ]
      },
      {
        q: "[Advanced] What are custom fixtures in Playwright and how do you write one?",
        a: [
          "Fixtures are isolated environments setup for each test (like the default 'page' or 'browser' parameters). Custom fixtures encapsulate setup/teardown logic.",
          "",
          "const { test: base } = require('@playwright/test');",
          "const { TodoPage } = require('./TodoPage');",
          "",
          "// Define a custom fixture 'todoPage'",
          "const test = base.extend({",
          "  todoPage: async ({ page }, use) => {",
          "    const todoPage = new TodoPage(page);",
          "    await todoPage.goto();",
          "    await todoPage.addTodo('Initial Task');",
          "    await use(todoPage); // Test executes here",
          "    await todoPage.clearTodos(); // Teardown after test finishes",
          "  }",
          "});",
          "",
          "test('Add item', async ({ todoPage }) => {",
          "  await todoPage.addTodo('Second Task');",
          "  // ... assertions",
          "});"
        ]
      },
      {
        q: "[Advanced] How do you perform visual comparison / snapshot testing in Playwright?",
        a: [
          "Use expect().toHaveScreenshot() to match the page or an element visually against baseline golden images:",
          "",
          "test('Visual landing page match', async ({ page }) => {",
          "  await page.goto('https://example.com');",
          "  // Compares full page screenshot, automatically handles layout and thresholds",
          "  await expect(page).toHaveScreenshot('landing-page.png');",
          "});",
          "",
          "Note: Run with '--update-snapshots' flag to initialize or replace golden images:",
          "npx playwright test --update-snapshots"
        ]
      },
      {
        q: "[Advanced] How do you configure Playwright in CI/CD pipelines (e.g., GitHub Actions)?",
        a: [
          "Create a workflow file `.github/workflows/playwright.yml` to automatically install browsers and run tests on every push/PR:",
          "",
          "name: Playwright Tests",
          "on:",
          "  push:",
          "    branches: [ main, master ]",
          "  pull_request:",
          "    branches: [ main, master ]",
          "jobs:",
          "  test:",
          "    timeout-minutes: 60",
          "    runs-on: ubuntu-latest",
          "    steps:",
          "    - uses: actions/checkout@v4",
          "    - uses: actions/setup-node@v4",
          "      with:",
          "        node-version: 18",
          "    - name: Install dependencies",
          "      run: npm ci",
          "    - name: Install Playwright Browsers",
          "      run: npx playwright install --with-deps",
          "    - name: Run Playwright tests",
          "      run: npx playwright test",
          "    - uses: actions/upload-artifact@v4",
          "      if: always()",
          "      with:",
          "        name: playwright-report",
          "        path: playwright-report/",
          "        retention-days: 30"
        ]
      },
      {
        q: "[Advanced] How do you handle flakiness in Page Object Models (POM) and web elements?",
        a: [
          "1. Avoid Hardcoded Timeouts: Never use `await page.waitForTimeout(5000)`. Instead, wait for specific conditions.",
          "2. Wait for Loaders to Disappear: If a page has an overlay loader, wait for it to detach:",
          "   `await page.locator('#spinner').waitFor({ state: 'detached' });`",
          "3. Combine Assertions with Actionability: Playwright assertions like `toBeVisible()` automatically retry. Use them inside POM methods:",
          "   `async submitForm() {`",
          "   `  await this.submitButton.waitFor({ state: 'visible' });`",
          "   `  await this.submitButton.click();`",
          "   `}`",
          "4. Leverage soft assertions: Use `expect.soft()` if you want the test to continue executing after a non-critical failure."
        ]
      },
      {
        q: "[Advanced] How do you triage and fix test failures in Playwright?",
        a: [
          "1. Trace Viewer: Record traces on failure and view them visually to inspect console logs, network calls, and page state snapshots at every execution step:",
          "   Run config option: `trace: 'on-first-retry'`",
          "   Open trace file: `npx playwright show-trace path/to/trace.zip`",
          "2. Interactive Debugging: Run tests in headed UI Mode or step through line-by-line using Inspector:",
          "   `npx playwright test --ui`",
          "   `npx playwright test --debug`",
          "3. Video / Screenshots: Review the automatically captured media inside `test-results/` to see exactly what the user saw right before the fail."
        ]
      },
      {
        q: "[Advanced] How do you customize BrowserContext settings (Geolocation, Viewport, Locale)?",
        a: [
          "You can configure context parameters either inside test cases or directly inside `playwright.config.js`:",
          "",
          "-- Inline test context overrides:",
          "test('Test with Munich location', async ({ browser }) => {",
          "  const context = await browser.newContext({",
          "    locale: 'de-DE',",
          "    timezoneId: 'Europe/Berlin',",
          "    geolocation: { latitude: 48.1351, longitude: 11.5820 },",
          "    permissions: ['geolocation'],",
          "    viewport: { width: 1280, height: 720 }",
          "  });",
          "  const page = await context.newPage();",
          "  await page.goto('https://maps.google.com');",
          "  await context.close();",
          "});"
        ]
      },
      {
        q: "[Advanced] What does a production-ready playwright.config.js look like?",
        a: [
          "Here is a comprehensive setup config defining workers, retries, browsers, and reporters:",
          "const { defineConfig, devices } = require('@playwright/test');",
          "",
          "module.exports = defineConfig({",
          "  testDir: './tests',",
          "  fullyParallel: true,           // Run tests in parallel within files",
          "  forbidOnly: !!process.env.CI,  // Fail CI if test.only is left in code",
          "  retries: process.env.CI ? 2 : 0, // Retry failed tests twice on CI",
          "  workers: process.env.CI ? 1 : undefined, // Reduce workers on CI to save resources",
          "  reporter: [['html'], ['list']],",
          "  use: {",
          "    baseURL: 'http://localhost:3000',",
          "    trace: 'on-first-retry',     // Record trace for retry runs",
          "    video: 'on-first-retry',",
          "    screenshot: 'only-on-failure'",
          "  },",
          "  projects: [",
          "    { name: 'chromium', use: { ...devices['Desktop Chrome'] } },",
          "    { name: 'firefox', use: { ...devices['Desktop Firefox'] } },",
          "    { name: 'webkit', use: { ...devices['Desktop Safari'] } }",
          "  ]",
          "});"
        ]
      },
      {
        q: "[Advanced] How would you automate an OTP-based login?",
        a: [
          "Automating real SMS/Email systems is slow, brittle, and expensive. Instead, use these industry strategies:",
          "",
          "1. API or Database Access (Recommended for staging/test environments):",
          "   Fetch the OTP code directly from a backend verification service database or API endpoint during execution:",
          "   `const otpCode = await db.query('SELECT code FROM otp_codes WHERE email = $1 ORDER BY created_at DESC LIMIT 1', [userEmail]);`",
          "",
          "2. Mock the Authentication Service:",
          "   Use Playwright's `page.route()` to capture the auth submit call and return a mock successful token, completely bypassing the OTP screen:",
          "   `await page.route('**/api/auth/login', route => route.fulfill({ json: { token: 'mock-session-jwt-token' } }));`",
          "",
          "3. Backdoor / Static Codes for Testing:",
          "   Work with developers to configure static, pre-defined OTP values (e.g. '123456') exclusively enabled on test/staging build environments."
        ]
      },
      {
        q: "[Advanced] A test passes locally but fails in CI. What would you do to troubleshoot and fix it?",
        a: [
          "When tests fail on remote containerized agents, execute these validation steps:",
          "",
          "1. Inspect Failure Artifacts: Check Trace files, captured videos, error console logs, and screenshots on failure to locate the exact trigger step.",
          "2. Address Headless vs. Headed timing issues: Some elements render slower or have different sizes when running headless. Add explicit wait states using locators.",
          "3. Verify Environment Configurations: Check for missing environment variables, API secrets, or database state mismatches present only in the CI container.",
          "4. Hardware Constraints: CI runners (e.g. GitHub actions, Jenkins nodes) typically have limited resources, causing timeouts. Configure higher waits or retries in CI config.",
          "5. Browser Engine version mismatch: Ensure local browser versions match the exact ones installed by Playwright in the CI build step."
        ]
      },
      {
        q: "[Advanced] How do you reduce flaky tests in Playwright?",
        a: [
          "Flaky tests decrease trust. Eliminate them by adhering to these rules:",
          "",
          "1. Avoid Arbitrary Sleep / Pause: Never use `page.waitForTimeout()`. Rely strictly on Playwright's auto-waiting assertions (like `toBeVisible()` or `toHaveText()`).",
          "2. Isolate Test Data: Run tests with unique, dynamically generated data (e.g. adding UUIDs to usernames/emails) to prevent tests from modifying or deleting each other's database records.",
          "3. Mock Flaky Third-Party Integrations: Intercept and mock unstable dependency APIs (like credit card payment gateways) to ensure test stability.",
          "4. Reset State Between Runs: Utilize standard hooks like `beforeEach()` or custom storage states to ensure each test starts on a clean, isolated session."
        ]
      },
      {
        q: "[Intermediate] How do you handle dynamic tables?",
        a: [
          "Dynamic tables have changing row counts and values. Locate elements using structured tree querying:",
          "",
          "1. Iterate rows dynamically:",
          "   `const rows = page.locator('table.data-table tr');`",
          "   `const count = await rows.count();`",
          "",
          "2. Locate a specific row by its unique column value using `.filter()` (recommended over index-based search):",
          "   `const row = page.locator('tr').filter({ hasText: 'Target Employee Name' });`",
          "   `await row.getByRole('button', { name: 'Edit' }).click();`",
          "",
          "3. Target specific columns inside row locators to extract cells:",
          "   `const cellValue = await row.locator('td').nth(2).textContent();`"
        ]
      },
      {
        q: "[Intermediate] How do you run tests on multiple browsers simultaneously?",
        a: [
          "Define multiple browser projects inside your `playwright.config.js` / `playwright.config.ts` configuration file:",
          "",
          "projects: [",
          "  { name: 'chromium', use: { ...devices['Desktop Chrome'] } },",
          "  { name: 'firefox', use: { ...devices['Desktop Firefox'] } },",
          "  { name: 'webkit', use: { ...devices['Desktop Safari'] } }",
          "]",
          "",
          "Run the test runner CLI command. By default, Playwright executes tests in parallel across all defined projects:",
          "`npx playwright test`"
        ]
      },
      {
        q: "[Intermediate] What debugging tools does Playwright provide?",
        a: [
          "Playwright provides a rich suite of built-in diagnostics:",
          "1. Playwright Inspector: Opens an interactive debugger UI where you can step through line-by-line using `npx playwright test --debug`.",
          "2. UI Mode: A fully interactive visual test suite dashboard with watch mode and time-travel steps using `npx playwright test --ui`.",
          "3. Trace Viewer: Captures screencasts, console outputs, net logs, and source locations. Setup via config `trace: 'on-first-retry'`.",
          "4. Inline Pauses: Add `await page.pause()` directly in code to halt execution and inspect DOM elements in the browser."
        ]
      },
      {
        q: "[Intermediate] When should you use Locator instead of ElementHandle?",
        a: [
          "Always prefer `Locator` over `ElementHandle` (which is legacy and generally discouraged).",
          "1. Auto-Waiting & Auto-Retries: `Locator` waits for element actions to become possible, retrying multiple times. `ElementHandle` does not wait; it fails if the element isn't immediately present.",
          "2. Re-resolving elements: If the DOM updates or re-renders (e.g. React/Vue page shifts), a `Locator` dynamically re-searches the element. An `ElementHandle` points to a static element and throws a 'Stale Element Reference' error."
        ]
      },
      {
        q: "[Advanced] How do you organize a large Playwright automation framework?",
        a: [
          "Keep codebase scalable and maintainable by structuring folders logically:",
          "",
          "├── tests/              # Test specs (.spec.js)",
          "├── pages/              # Page Object classes (POM)",
          "├── fixtures/           # Custom test setups and environments",
          "├── utilities/          # Global helper functions, logger configurations",
          "├── test-data/          # Static payloads, JSON models, credentials",
          "├── auth/               # Saved session storageState JSON outputs",
          "├── playwright-report/  # HTML results output files",
          "└── playwright.config.js # Global settings and execution options"
        ]
      },
      {
        q: "[Advanced] How would you test microservices or APIs with Playwright?",
        a: [
          "Playwright provides built-in API testing support using `APIRequestContext`:",
          "",
          "-- Inside standard UI test file:",
          "test('Create record via API and verify in UI', async ({ request, page }) => {",
          "  // Call POST API directly",
          "  const response = await request.post('https://api.example.com/v1/items', {",
          "    data: { name: 'New Item' }",
          "  });",
          "  expect(response.ok()).toBeTruthy();",
          "  const body = await response.json();",
          "",
          "  // Navigate to UI and verify the item is visible",
          "  await page.goto('/dashboard');",
          "  await expect(page.getByText('New Item')).toBeVisible();",
          "});"
        ]
      },
      {
        q: "[Beginner] What programming languages are supported by Playwright?",
        a: [
          "Playwright supports four major programming languages with native API bindings:",
          "1. JavaScript / TypeScript",
          "2. Python",
          "3. Java",
          "4. C# (.NET)"
        ]
      },
      {
        q: "[Beginner] How do you automatically generate tests in Playwright (Codegen)?",
        a: [
          "Playwright has a built-in code generator that records user actions and writes script code automatically.",
          "To launch it, run:",
          "npx playwright codegen https://example.com"
        ]
      },
      {
        q: "[Beginner] What is the difference between page.click(selector) and locator.click()?",
        a: [
          "page.click(selector) is the legacy API that searches for the element and clicks it immediately. It does not store the reference.",
          "locator.click() uses the modern Locator API which is lazy-evaluated. It re-resolves the element on every action, making it more resilient to UI updates."
        ]
      },
      {
        q: "[Beginner] How do you run tests in headed mode from the command line?",
        a: [
          "By default, Playwright runs tests in headless mode (no visible browser window). To run in headed mode, pass the --headed flag:",
          "npx playwright test --headed"
        ]
      },
      {
        q: "[Beginner] How do you assert if an element is hidden or detached?",
        a: [
          "Use the built-in expect assertions:",
          "await expect(page.locator('#alert-box')).toBeHidden();",
          "// Or check for complete detachment from DOM:",
          "await expect(page.locator('#alert-box')).toBeAttached({ attached: false });"
        ]
      },
      {
        q: "[Intermediate] How do you handle file uploads in Playwright?",
        a: [
          "Target the file input element and use setInputFiles() to upload files:",
          "// Upload a single file",
          "await page.locator('input[type=\"file\"]').setInputFiles('path/to/my-doc.pdf');",
          "",
          "// Upload multiple files",
          "await page.locator('input[type=\"file\"]').setInputFiles(['doc1.pdf', 'doc2.pdf']);",
          "",
          "// Clear selected files",
          "await page.locator('input[type=\"file\"]').setInputFiles([]);"
        ]
      },
      {
        q: "[Intermediate] How do you handle file downloads in Playwright?",
        a: [
          "Capture the download event promise triggered by a click action:",
          "const downloadPromise = page.waitForEvent('download');",
          "await page.getByRole('button', { name: 'Download PDF' }).click();",
          "const download = await downloadPromise;",
          "",
          "// Save download to a local file path",
          "await download.saveAs('downloads/report.pdf');"
        ]
      },
      {
        q: "[Intermediate] How do you listen to browser console logs during test execution?",
        a: [
          "Register a listener for the page 'console' event:",
          "page.on('console', msg => {",
          "  if (msg.type() === 'error') {",
          "    console.log(`JS Error: ${msg.text()}`);",
          "  }",
          "});"
        ]
      },
      {
        q: "[Intermediate] How do you maximize browser window size in Playwright?",
        a: [
          "Rather than maximizing physically, set the viewport property inside the configuration or inline browser context:",
          "use: {",
          "  viewport: { width: 1920, height: 1080 }",
          "}"
        ]
      },
      {
        q: "[Intermediate] Explain how soft assertions work in Playwright with code.",
        a: [
          "Soft assertions do not terminate test execution immediately upon failure, allowing subsequent assertions to run. This is useful for checking multiple non-blocking properties:",
          "// If this fails, the test continues executing but will be marked as failed at the end",
          "await expect.soft(page.locator('h1')).toHaveText('Welcome');",
          "await page.click('button#next');"
        ]
      },
      {
        q: "[Intermediate] How do you drag and drop elements in Playwright?",
        a: [
          "Method 1: Direct dragTo API (recommended):",
          "await page.locator('#source-item').dragTo(page.locator('#target-zone'));",
          "",
          "Method 2: Manual step-by-step actions:",
          "await page.locator('#source-item').hover();",
          "await page.mouse.down();",
          "await page.locator('#target-zone').hover();",
          "await page.mouse.up();"
        ]
      },
      {
        q: "[Intermediate] How do you perform hover actions?",
        a: [
          "Use the locator.hover() API which auto-scrolls to the element and performs a mouse hover:",
          "await page.getByRole('menuitem', { name: 'Settings' }).hover();"
        ]
      },
      {
        q: "[Intermediate] How do you handle browser cookies (add, retrieve, clear)?",
        a: [
          "// Retrieve all cookies",
          "const cookies = await page.context().cookies();",
          "",
          "// Set custom cookies",
          "await page.context().addCookies([{ name: 'session-id', value: '1234', domain: 'example.com', path: '/' }]);",
          "",
          "// Clear all cookies",
          "await page.context().clearCookies();"
        ]
      },
      {
        q: "[Advanced] How do you emulate mobile devices or specific user agents in Playwright?",
        a: [
          "Import predefined device configurations from playwright.devices and assign them to a project:",
          "const { devices } = require('@playwright/test');",
          "// In config file:",
          "projects: [",
          "  {",
          "    name: 'Mobile Safari',",
          "    use: { ...devices['iPhone 13'] }",
          "  }",
          "]"
        ]
      },
      {
        q: "[Advanced] How do you execute tests serially instead of in parallel?",
        a: [
          "Use the test.describe.configure() block to force serial execution within a file:",
          "test.describe.configure({ mode: 'serial' });",
          "",
          "test.describe('Serial Block', () => {",
          "  test('Setup task', async () => { ... });",
          "  test('Subsequent task depending on setup', async () => { ... });",
          "});"
        ]
      },
      {
        q: "[Advanced] What are the different timeout levels in Playwright?",
        a: [
          "1. Test Timeout: Max time a single test can run (default 30s).",
          "2. Navigation Timeout: Max time page.goto() or page.waitForNavigation() can take.",
          "3. Assertion Timeout: Max time expect() retries (default 5s).",
          "4. Action Timeout: Max time locators wait for click/fill actionability."
        ]
      },
      {
        q: "[Advanced] What is the difference between locator.waitFor() and page.waitForSelector()?",
        a: [
          "page.waitForSelector() is the legacy query selector API that waits for element presence. It does not use the lazy locator model.",
          "locator.waitFor() is the modern locator-based wait API that supports wait states ('visible', 'hidden', 'attached', 'detached') and automatically re-resolves references."
        ]
      },
      {
        q: "[Advanced] How do you handle OAuth popups opening on completely different domains?",
        a: [
          "Utilize context.waitForEvent('page') to capture the popup window context, interact with it, and resume testing on the main window:",
          "const [popup] = await Promise.all([",
          "  page.context().waitForEvent('page'),",
          "  page.click('button#google-sign-in') // opens popup",
          "]);",
          "await popup.waitForLoadState();",
          "await popup.fill('input[type=\"email\"]', 'testuser@gmail.com');",
          "await popup.click('button#next');"
        ]
      },
      {
        q: "[Advanced] How do you perform visual testing on a specific component instead of the full viewport?",
        a: [
          "Call expectation assertions directly on the target element locator:",
          "const loginCard = page.locator('.login-card-container');",
          "await expect(loginCard).toHaveScreenshot('login-card.png');"
        ]
      },
      {
        q: "[Advanced] How do you capture request headers and response cookies for debugging?",
        a: [
          "Register page 'request' and 'response' event listeners:",
          "page.on('response', async response => {",
          "  if (response.url().includes('/api/auth')) {",
          "    console.log('Status:', response.status());",
          "    console.log('Headers:', await response.allHeaders());",
          "  }",
          "});"
        ]
      },
      {
        q: "[Advanced] Explain test tag execution (@smoke, @regression) in Playwright.",
        a: [
          "Add tag descriptors inside test names, then target them using the --grep command line parameter:",
          "test('Test user login @smoke', async ({ page }) => { ... });",
          "test('Create item transaction @regression', async ({ page }) => { ... });",
          "",
          "-- Execute only smoke tests:",
          "npx playwright test --grep @smoke"
        ]
      },
      {
        q: "[Advanced] How do you configure automatic retries on failure?",
        a: [
          "Set the retries parameter inside playwright.config.js:",
          "module.exports = {",
          "  retries: 2, // Retries failed tests twice",
          "  use: { ... }",
          "};"
        ]
      },
      {
        q: "[Advanced] How do you access native Chrome DevTools Protocol (CDP) sessions in Playwright?",
        a: [
          "Create a CDP session directly using the target page context:",
          "const client = await page.context().newCDPSession(page);",
          "// Enable network performance profiling:",
          "await client.send('Network.enable');",
          "await client.send('Emulation.setCPUThrottlingRate', { rate: 4 });"
        ]
      },
      {
        q: "[Advanced] How do you simulate offline states or custom network speed limits?",
        a: [
          "Call context.grantPermissions() or network parameters using CDP or Page Context overrides:",
          "await page.context().setOffline(true); // Forces offline status",
          "await expect(page.getByText('No Internet')).toBeVisible();",
          "await page.context().setOffline(false); // Restores connection"
        ]
      },
      {
        q: "[Advanced] What is the difference between test.describe() and test.step()?",
        a: [
          "test.describe(): Groups multiple tests logically (e.g. grouped under '/login page tests').",
          "test.step(): Groups sequential blocks *within a single test* to categorize execution stages in the final HTML test report:",
          "test('E-commerce transaction', async ({ page }) => {",
          "  await test.step('Add item to cart', async () => { ... });",
          "  await test.step('Execute payment', async () => { ... });",
          "});"
        ]
      }
    ]
  },
  "selenium-qa": {
    title: "Selenium Automation with Java",
    qa: [
      {
        q: "[Beginner] What is Selenium WebDriver and how does it communicate with the web browser?",
        a: [
          "Selenium WebDriver is a browser automation framework that allows developers to write code to automate web page actions.",
          "How it communicates (under W3C standard):",
          "1. Test Script: Your script (written in Java, Python, C#, etc.) translates actions into commands.",
          "2. W3C WebDriver Protocol: Commands are packaged into JSON/HTTP REST requests.",
          "3. Browser Driver: Browser-specific drivers (like ChromeDriver, GeckoDriver) receive the commands, translate them into native browser commands, and execute them.",
          "4. Browser: The browser performs the actions and returns the result back through the driver to the script."
        ]
      },
      {
        q: "[Beginner] Write a basic Selenium test script in Java.",
        a: [
          "Here is a simple Java script initializing ChromeDriver, performing navigation, and validating page header:",
          "import org.openqa.selenium.By;",
          "import org.openqa.selenium.WebDriver;",
          "import org.openqa.selenium.WebElement;",
          "import org.openqa.selenium.chrome.ChromeDriver;",
          "",
          "public class BasicSeleniumTest {",
          "    public static void main(String[] args) {",
          "        // Initialize Chrome Driver",
          "        WebDriver driver = new ChromeDriver();",
          "        ",
          "        try {",
          "            // Navigate to web page",
          "            driver.get(\"https://example.com\");",
          "            ",
          "            // Verify page header text",
          "            WebElement header = driver.findElement(By.tagName(\"h1\"));",
          "            if (header.getText().equals(\"Example Domain\")) {",
          "                System.out.println(\"Test Passed!\");",
          "            } else {",
          "                System.out.println(\"Test Failed!\");",
          "            }",
          "        } finally {",
          "            // Quit browser sessions",
          "            driver.quit();",
          "        }",
          "    }",
          "}"
        ]
      },
      {
        q: "[Beginner] What is the difference between driver.close() and driver.quit()?",
        a: [
          "driver.close(): Closes the currently active browser window or tab that the driver is focusing on. It does not terminate the background WebDriver session if other windows remain open.",
          "driver.quit(): Closes all open windows and tabs associated with the driver session and safely destroys the WebDriver execution process, releasing system memory. Always use `quit()` at the end of execution."
        ]
      },
      {
        q: "[Beginner] What is the difference between findElement() and findElements()?",
        a: [
          "findElement():",
          "- Returns the first matching WebElement found within the page.",
          "- Throws a 'NoSuchElementException' immediately if no matching element is found.",
          "findElements():",
          "- Returns a List of WebElements matching the locator criteria.",
          "- Does not throw an exception if no elements are found; instead, it simply returns an empty list."
        ]
      },
      {
        q: "[Beginner] What are the key locating strategies supported in Selenium?",
        a: [
          "Selenium provides locator mechanisms via the By class:",
          "1. By.id(): Best strategy if unique IDs are defined.",
          "2. By.className(): Targets elements by CSS class.",
          "3. By.name(): Targets elements by the name attribute.",
          "4. By.cssSelector(): High-speed matching using CSS selectors.",
          "5. By.xpath(): Highly flexible locator that navigates backward/forward through the XML structure. Preferred for dynamic elements.",
          "6. By.linkText() / By.partialLinkText(): Targets anchor tags by link label."
        ]
      },
      {
        q: "[Intermediate] Explain the difference between Implicit, Explicit, and Fluent Wait in Selenium.",
        a: [
          "1. Implicit Wait: A global timeout applied to the driver instance. The driver will wait up to this threshold for *every* element search before throwing NoSuchElementException.",
          "   `driver.manage().timeouts().implicitlyWait(Duration.ofSeconds(10));`",
          "2. Explicit Wait: Applied to a specific element with defined ExpectedConditions (e.g. visibilityOf, elementToBeClickable). Best practice for handling dynamic load times.",
          "   `WebDriverWait wait = new WebDriverWait(driver, Duration.ofSeconds(10));`",
          "   `wait.until(ExpectedConditions.visibilityOfElementLocated(By.id(\"submit\")));`",
          "3. Fluent Wait: Similar to Explicit Wait but allows customization of the polling interval and specific exceptions to ignore (e.g., NoSuchElementException) while waiting.",
          "   `Wait<WebDriver> wait = new FluentWait<>(driver).withTimeout(Duration.ofSeconds(10)).pollingEvery(Duration.ofMillis(500)).ignoring(NoSuchElementException.class);`"
        ]
      },
      {
        q: "[Intermediate] How do you select options from dropdown lists in Selenium?",
        a: [
          "Import and instantiate the Select wrapper class:",
          "import org.openqa.selenium.support.ui.Select;",
          "",
          "WebElement dropdownElement = driver.findElement(By.id(\"country\"));",
          "Select selectCountry = new Select(dropdownElement);",
          "",
          "// Choose by visible text option",
          "selectCountry.selectByVisibleText(\"United States\");",
          "",
          "// Choose by value attribute",
          "selectCountry.selectByValue(\"US\");",
          "",
          "// Choose by zero-based index",
          "selectCountry.selectByIndex(2);"
        ]
      },
      {
        q: "[Intermediate] How do you handle JavaScript alerts, confirms, and prompts in Selenium?",
        a: [
          "Switch focus to the alert dialog using driver.switchTo().alert():",
          "import org.openqa.selenium.Alert;",
          "",
          "// Switch to alert instance",
          "Alert alert = driver.switchTo().alert();",
          "",
          "// Fetch the alert text",
          "String alertMsg = alert.getText();",
          "",
          "// Click OK/Accept",
          "alert.accept();",
          "",
          "// Click Cancel/Dismiss",
          "alert.dismiss();",
          "",
          "// Type text into prompt alerts",
          "alert.sendKeys(\"Inputs\");"
        ]
      },
      {
        q: "[Intermediate] How do you handle iframes and nested frames in Selenium?",
        a: [
          "You must explicitly switch the driver context into the frame before interacting with its inner elements, and switch back afterward:",
          "",
          "// Switch by frame index",
          "driver.switchTo().frame(0);",
          "",
          "// Switch by frame name or ID",
          "driver.switchTo().frame(\"payment-frame\");",
          "",
          "// Switch by WebElement locator",
          "WebElement frameEl = driver.findElement(By.cssSelector(\"iframe.payment-widget\"));",
          "driver.switchTo().frame(frameEl);",
          "",
          "// Switch back to the main default page content context",
          "driver.switchTo().defaultContent();"
        ]
      },
      {
        q: "[Intermediate] What is Page Object Model (POM) and PageFactory in Selenium?",
        a: [
          "POM is a design pattern wrapping elements/actions in page classes.",
          "PageFactory is a built-in Selenium extension that initializes WebElements lazily using @FindBy annotations.",
          "",
          "-- Page Object Class utilizing PageFactory (LoginPage.java):",
          "import org.openqa.selenium.WebDriver;",
          "import org.openqa.selenium.WebElement;",
          "import org.openqa.selenium.support.FindBy;",
          "import org.openqa.selenium.support.PageFactory;",
          "",
          "public class LoginPage {",
          "    WebDriver driver;",
          "    ",
          "    @FindBy(name = \"username\")",
          "    WebElement txtUsername;",
          "    ",
          "    @FindBy(name = \"password\")",
          "    WebElement txtPassword;",
          "    ",
          "    @FindBy(id = \"loginBtn\")",
          "    WebElement btnLogin;",
          "    ",
          "    public LoginPage(WebDriver driver) {",
          "        this.driver = driver;",
          "        // Initializes elements on class creation",
          "        PageFactory.initElements(driver, this);",
          "    }",
          "    ",
          "    public void login(String user, String pass) {",
          "        txtUsername.sendKeys(user);",
          "        txtPassword.sendKeys(pass);",
          "        btnLogin.click();",
          "    }",
          "}"
        ]
      },
      {
        q: "[Intermediate] How do you capture screenshots in Selenium?",
        a: [
          "Cast the WebDriver instance to TakesScreenshot and save the output file:",
          "import org.openqa.selenium.TakesScreenshot;",
          "import org.openqa.selenium.OutputType;",
          "import java.io.File;",
          "import org.apache.commons.io.FileUtils; // Common utility",
          "",
          "File srcFile = ((TakesScreenshot)driver).getScreenshotAs(OutputType.FILE);",
          "File destFile = new File(\"path/to/screenshots/error.png\");",
          "FileUtils.copyFile(srcFile, destFile);"
        ]
      },
      {
        q: "[Advanced] How do you execute JavaScript code in Selenium?",
        a: [
          "Cast the WebDriver instance to JavascriptExecutor. Useful for actions standard Selenium cannot perform (like scrolling or clicking hidden elements):",
          "import org.openqa.selenium.JavascriptExecutor;",
          "",
          "JavascriptExecutor js = (JavascriptExecutor) driver;",
          "",
          "// Execute dynamic click",
          "WebElement element = driver.findElement(By.id(\"submit\"));",
          "js.executeScript(\"arguments[0].click();\", element);",
          "",
          "// Scroll down by 500 pixels",
          "js.executeScript(\"window.scrollBy(0,500)\");",
          "",
          "// Return value from JS console",
          "String pageTitle = (String) js.executeScript(\"return document.title;\");"
        ]
      },
      {
        q: "[Advanced] How do you handle multiple tabs or windows in Selenium?",
        a: [
          "Selenium assigns a unique string ID (Window Handle) to each open tab. Switch driver focus using these handles:",
          "",
          "// Store main parent window handle",
          "String parentWindow = driver.getWindowHandle();",
          "",
          "// Click button that opens a new tab",
          "driver.findElement(By.id(\"newTabBtn\")).click();",
          "",
          "// Fetch all active window handles",
          "Set<String> allWindows = driver.getWindowHandles();",
          "",
          "for (String handle : allWindows) {",
          "    if (!handle.equals(parentWindow)) {",
          "        // Switch focus to the new window tab",
          "        driver.switchTo().window(handle);",
          "        break;",
          "    }",
          "}",
          "",
          "// Perform actions in new tab and close it",
          "driver.close();",
          "",
          "// Switch back to parent window",
          "driver.switchTo().window(parentWindow);"
        ]
      },
      {
        q: "[Advanced] What is Selenium Grid and what are its core components?",
        a: [
          "Selenium Grid is a tool used to execute tests in parallel across multiple browsers, operating systems, and machines.",
          "Core Components (since Grid 4):",
          "1. Hub / Router: The central entry point. Receives test session requests and forwards them to appropriate nodes.",
          "2. Distributor: Matches incoming capabilities requests with active node configurations.",
          "3. Node: The machine hosting the physical browsers and execution agents.",
          "4. Session Map: Key-value database matching active session IDs with their running Node targets."
        ]
      },
      {
        q: "[Advanced] How do you manage custom browser capabilities and configurations?",
        a: [
          "Use BrowserOptions subclasses (like ChromeOptions, FirefoxOptions) to configure browser parameters:",
          "import org.openqa.selenium.chrome.ChromeOptions;",
          "",
          "ChromeOptions options = new ChromeOptions();",
          "",
          "// Run browser in headless mode",
          "options.addArguments(\"--headless\");",
          "",
          "// Disable popup blockers",
          "options.addArguments(\"--disable-popup-blocking\");",
          "",
          "// Accept insecure SSL certificates",
          "options.setAcceptInsecureCerts(true);",
          "",
          "// Launch browser with custom options",
          "WebDriver driver = new ChromeDriver(options);"
        ]
      },
      {
        q: "[Beginner] What is Selenium IDE?",
        a: [
          "Selenium IDE (Integrated Development Environment) is a browser extension (for Chrome/Firefox) used for quick prototyping, recording, and playing back interactions.",
          "It is a codeless tool meant for beginners or creating quick bug reports, but is not scalable for large regression suites."
        ]
      },
      {
        q: "[Beginner] What is the difference between Absolute XPath and Relative XPath?",
        a: [
          "Absolute XPath: Starts from the root node (html) and uses single slashes (/). It is brittle because any layout shift breaks the path. E.g. `/html/body/div[1]/div[2]/h1`.",
          "Relative XPath: Starts from anywhere in the DOM using double slashes (//). It uses attributes and is more stable. E.g. `//h1[@id='title']`."
        ]
      },
      {
        q: "[Beginner] How do you maximize the browser window size in Selenium?",
        a: [
          "Use the window management interface of the driver:",
          "driver.manage().window().maximize();"
        ]
      },
      {
        q: "[Beginner] How do you verify if an element is enabled, selected, or displayed in Selenium?",
        a: [
          "Use the boolean validation methods on a WebElement instance:",
          "boolean isDisplayed = element.isDisplayed(); // Checks visibility",
          "boolean isEnabled = element.isEnabled();     // Checks if clickable/active",
          "boolean isSelected = element.isSelected();   // Checks checkbox/radio selection"
        ]
      },
      {
        q: "[Beginner] How do you press keyboard key combinations (like ENTER, TAB, or CONTROL+A) in Selenium?",
        a: [
          "Use the Keys enum inside sendKeys():",
          "// Press ENTER key",
          "element.sendKeys(Keys.ENTER);",
          "",
          "// Keyboard shortcut combinations",
          "element.sendKeys(Keys.chord(Keys.CONTROL, \"a\"));"
        ]
      },
      {
        q: "[Beginner] How do you retrieve the current page URL and page source in Selenium?",
        a: [
          "String currentUrl = driver.getCurrentUrl();",
          "String pageSource = driver.getPageSource();"
        ]
      },
      {
        q: "[Beginner] How do you navigate back, forward, and refresh a page in Selenium?",
        a: [
          "Use the navigation interface:",
          "driver.navigate().back();",
          "driver.navigate().forward();",
          "driver.navigate().refresh();"
        ]
      },
      {
        q: "[Intermediate] How do you perform mouse hover operations?",
        a: [
          "Instantiate and call the Actions builder class:",
          "import org.openqa.selenium.interactions.Actions;",
          "",
          "Actions actions = new Actions(driver);",
          "WebElement menu = driver.findElement(By.id(\"category-menu\"));",
          "actions.moveToElement(menu).perform();"
        ]
      },
      {
        q: "[Intermediate] How do you perform drag and drop operations in Selenium?",
        a: [
          "Use the Actions class dragAndDrop method:",
          "Actions actions = new Actions(driver);",
          "WebElement source = driver.findElement(By.id(\"source\"));",
          "WebElement target = driver.findElement(By.id(\"target\"));",
          "actions.dragAndDrop(source, target).perform();"
        ]
      },
      {
        q: "[Intermediate] How do you handle file uploads in Selenium?",
        a: [
          "Locate the file input element and send the absolute file path directly using sendKeys():",
          "WebElement fileInput = driver.findElement(By.cssSelector(\"input[type='file']\"));",
          "fileInput.sendKeys(\"/absolute/path/to/document.pdf\");"
        ]
      },
      {
        q: "[Intermediate] How do you read values from a dynamic web table?",
        a: [
          "Locate rows and loop columns using relative XPaths or CSS Selectors:",
          "List<WebElement> rows = driver.findElements(By.xpath(\"//table[@id='data']/tbody/tr\"));",
          "for (WebElement row : rows) {",
          "    String name = row.findElement(By.xpath(\"./td[1]\")).getText();",
          "    String role = row.findElement(By.xpath(\"./td[2]\")).getText();",
          "    System.out.println(name + \" is a \" + role);",
          "}"
        ]
      },
      {
        q: "[Intermediate] How do you retrieve CSS properties (e.g. background-color, font-size) of an element?",
        a: [
          "Use the getCssValue() method on the WebElement:",
          "String bgColor = element.getCssValue(\"background-color\");",
          "String fontSize = element.getCssValue(\"font-size\");"
        ]
      },
      {
        q: "[Intermediate] How do you disable browser notifications in Chrome?",
        a: [
          "Pass configuration arguments inside ChromeOptions:",
          "ChromeOptions options = new ChromeOptions();",
          "options.addArguments(\"--disable-notifications\");",
          "WebDriver driver = new ChromeDriver(options);"
        ]
      },
      {
        q: "[Advanced] Explain the Page Object Model (POM) lifecycle. How do you prevent stale elements?",
        a: [
          "A stale element exception occurs when the DOM re-renders and the element reference is lost.",
          "Preventing stale elements:",
          "1. When using PageFactory, elements are evaluated lazily. You can use @CacheLookup to cache elements if they never change, or omit it so the driver re-locates the element on every action.",
          "2. Wrap execution calls in try-catch blocks and retry locating the element inside a catch block."
        ]
      },
      {
        q: "[Advanced] How do you handle SSL Certificate errors in Chrome and Firefox?",
        a: [
          "Configure the browser options to accept insecure certificates:",
          "// For Chrome:",
          "ChromeOptions chromeOptions = new ChromeOptions();",
          "chromeOptions.setAcceptInsecureCerts(true);",
          "",
          "// For Firefox:",
          "FirefoxOptions firefoxOptions = new FirefoxOptions();",
          "firefoxOptions.setAcceptInsecureCerts(true);"
        ]
      },
      {
        q: "[Advanced] What is the difference between getWindowHandle() and getWindowHandles()?",
        a: [
          "getWindowHandle(): Returns a single unique alphanumeric string ID representing the window context currently in focus.",
          "getWindowHandles(): Returns a Set of unique alphanumeric IDs representing all windows/tabs currently open under this WebDriver session."
        ]
      },
      {
        q: "[Advanced] How do you run tests in parallel using TestNG?",
        a: [
          "Configure the parallel attribute inside the `testng.xml` suite configuration file:",
          "<suite name=\"ParallelSuite\" parallel=\"tests\" thread-count=\"5\">",
          "    <test name=\"ChromeTest\">",
          "        <parameter name=\"browser\" value=\"chrome\"/>",
          "        <classes><class name=\"com.tests.LoginTest\"/></classes>",
          "    </test>",
          "</suite>"
        ]
      },
      {
        q: "[Advanced] How do you handle authentication popups (Basic Auth) in Selenium?",
        a: [
          "Pass credentials directly inside the URL string structure when loading the page:",
          "driver.get(\"https://username:password@example.com/protected-page\");"
        ]
      },
      {
        q: "[Advanced] How do you configure a proxy server in Selenium?",
        a: [
          "Instantiate a Proxy configuration class and map it to your browser options:",
          "import org.openqa.selenium.Proxy;",
          "",
          "Proxy proxy = new Proxy();",
          "proxy.setHttpProxy(\"myproxy.com:8080\");",
          "",
          "ChromeOptions options = new ChromeOptions();",
          "options.setCapability(\"proxy\", proxy);",
          "WebDriver driver = new ChromeDriver(options);"
        ]
      },
      {
        q: "[Advanced] Explain page load strategies in Selenium (Normal, Eager, None).",
        a: [
          "Set the pageLoadStrategy capability to optimize execution speed:",
          "1. Normal: Waits for the entire page to load (CSS, images, frames). Default behavior.",
          "2. Eager: Waits until DOMContentLoaded is complete. Images and frames can still be loading.",
          "3. None: WebDriver returns immediately after launching navigation. Does not wait at all."
        ]
      },
      {
        q: "[Advanced] How do you handle shadow DOM elements in Selenium?",
        a: [
          "Standard findElement() cannot traverse shadow roots. You must retrieve the shadow root using Javascript or modern locator methods (since Selenium 4):",
          "WebElement shadowHost = driver.findElement(By.id(\"shadow-host\"));",
          "SearchContext shadowRoot = shadowHost.getShadowRoot();",
          "WebElement shadowElement = shadowRoot.findElement(By.cssSelector(\"#inner-button\"));",
          "shadowElement.click();"
        ]
      },
      {
        q: "[Advanced] How do you write an XPath to select an SVG element?",
        a: [
          "Standard XPaths like `//svg` will fail. You must use the local-name() function to match SVG nodes:",
          "WebElement svgElement = driver.findElement(By.xpath(\"//*[local-name()='svg']\"));"
        ]
      },
      {
        q: "[Advanced] How do you locate elements when class names have spaces?",
        a: [
          "Using `By.className(\"btn active\")` throws an exception. You must use CSS Selectors or XPaths:",
          "// Using CSS Selector:",
          "driver.findElement(By.cssSelector(\".btn.active\"));",
          "// Using XPath:",
          "driver.findElement(By.xpath(\"//button[contains(@class, 'btn') and contains(@class, 'active')]\"));"
        ]
      },
      {
        q: "[Advanced] How do you configure Selenium to download files without showing the browser prompt?",
        a: [
          "Configure custom preferences within ChromeOptions:",
          "HashMap<String, Object> chromePrefs = new HashMap<>();",
          "chromePrefs.put(\"profile.default_content_settings.popups\", 0);",
          "chromePrefs.put(\"download.default_directory\", \"/path/to/downloads\");",
          "",
          "ChromeOptions options = new ChromeOptions();",
          "options.setExperimentalOption(\"prefs\", chromePrefs);",
          "WebDriver driver = new ChromeDriver(options);"
        ]
      },
      {
        q: "[Advanced] How do you wait for a page to load completely using JavascriptExecutor?",
        a: [
          "Wait for the document.readyState property to equal 'complete':",
          "import org.openqa.selenium.support.ui.WebDriverWait;",
          "",
          "WebDriverWait wait = new WebDriverWait(driver, Duration.ofSeconds(30));",
          "wait.until(d -> ((JavascriptExecutor) d).executeScript(\"return document.readyState\").equals(\"complete\"));"
        ]
      },
      {
        q: "[Advanced] How do you configure a custom User-Agent in Selenium?",
        a: [
          "Pass the custom user-agent string as an argument inside ChromeOptions:",
          "ChromeOptions options = new ChromeOptions();",
          "options.addArguments(\"--user-agent=Mozilla/5.0 (iPhone; CPU iPhone OS 10_3 like Mac OS X) AppleWebKit/602.1.50\");",
          "WebDriver driver = new ChromeDriver(options);"
        ]
      },
      {
        q: "[Advanced] What are Relative Locators in Selenium 4 and how are they used?",
        a: [
          "Relative Locators locate elements relative to other elements using functions like above(), below(), toLeftOf(), toRightOf(), and near():",
          "import static org.openqa.selenium.support.locators.RelativeLocator.with;",
          "",
          "WebElement passwordField = driver.findElement(By.id(\"password\"));",
          "WebElement usernameField = driver.findElement(with(By.tagName(\"input\")).above(passwordField));"
        ]
      },
      {
        q: "[Advanced] How do you handle sliders or sliding scales in Selenium?",
        a: [
          "Perform mouse drag actions using clickAndHold, moveByOffset, and release actions inside the Actions builder:",
          "WebElement slider = driver.findElement(By.id(\"price-slider\"));",
          "Actions actions = new Actions(driver);",
          "// Move slider slider handle to the right by 50 pixels",
          "actions.clickAndHold(slider).moveByOffset(50, 0).release().perform();"
        ]
      },
      {
        q: "[Advanced] How do you extract console error logs from a running Chrome session?",
        a: [
          "Retrieve logging preferences from the browser logs interface:",
          "import org.openqa.selenium.logging.LogEntries;",
          "import org.openqa.selenium.logging.LogEntry;",
          "import org.openqa.selenium.logging.LogType;",
          "",
          "LogEntries logEntries = driver.manage().logs().get(LogType.BROWSER);",
          "for (LogEntry entry : logEntries) {",
          "    if (entry.getLevel().toString().equals(\"SEVERE\")) {",
          "        System.out.println(\"Console Error: \" + entry.getMessage());",
          "    }",
          "}"
        ]
      },
      {
        q: "[Advanced] How do you capture network traffic or mock API calls in Selenium 4?",
        a: [
          "Use the built-in DevTools API session interface:",
          "import org.openqa.selenium.chrome.ChromeDriver;",
          "import org.openqa.selenium.devtools.DevTools;",
          "import org.openqa.selenium.devtools.v119.network.Network;",
          "",
          "ChromeDriver chromeDriver = (ChromeDriver) driver;",
          "DevTools devTools = chromeDriver.getDevTools();",
          "devTools.createSession();",
          "devTools.send(Network.enable(Optional.empty(), Optional.empty(), Optional.empty()));",
          "",
          "// Monitor network requests:",
          "devTools.addListener(Network.requestWillBeSent(), request -> {",
          "    System.out.println(\"Request URL: \" + request.getRequest().getUrl());",
          "});"
        ]
      },
      {
        q: "[Advanced] What is the difference between driver.get() and driver.navigate().to()?",
        a: [
          "driver.get(): Navigates to a specific URL page, blocking thread execution until the page load event is finished. It is the standard, simpler way.",
          "driver.navigate().to(): Behaves similarly but retains the navigation history stack, enabling you to use driver.navigate().back() and driver.navigate().forward()."
        ]
      },
      {
        q: "[Advanced] How do you check if an image loaded successfully (broken images check)?",
        a: [
          "Use JavascriptExecutor to inspect the naturalWidth attribute of the image element:",
          "WebElement image = driver.findElement(By.cssSelector(\"img.logo\"));",
          "Boolean imageLoaded = (Boolean) ((JavascriptExecutor) driver).executeScript(",
          "    \"return arguments[0].complete && typeof arguments[0].naturalWidth != 'undefined' && arguments[0].naturalWidth > 0;\",",
          "    image",
          ");",
          "if (!imageLoaded) { System.out.println(\"Broken Image found!\"); }"
        ]
      },
      {
        q: "[Advanced] How do you dynamically interact with cookies?",
        a: [
          "Manage browser cookies using driver.manage() interface:",
          "// Add a cookie",
          "driver.manage().addCookie(new Cookie(\"auth-token\", \"xyz123\"));",
          "// Get a cookie",
          "Cookie cookie = driver.manage().getCookieNamed(\"auth-token\");",
          "// Delete a cookie",
          "driver.manage().deleteCookieNamed(\"auth-token\");",
          "// Clear all cookies",
          "driver.manage().deleteAllCookies();"
        ]
      }
    ]
  },
  "appium-qa": {
    title: "Appium Mobile Testing",
    qa: [
      {
        q: "[Beginner] What is Appium and how does it work?",
        a: [
          "Appium is an open-source, cross-platform test automation tool used for automating native, hybrid, and mobile web applications on iOS, Android, and Windows desktop platforms.",
          "How it works: Appium is an HTTP server written in Node.js that exposes a REST API. It receives command connections from your client test script, translates them into vendor-specific framework commands (UIAutomator2 for Android, XCUITest for iOS), executes them on the target device, and returns the response."
        ]
      },
      {
        q: "[Beginner] Explain the difference between Native, Hybrid, and Mobile Web applications.",
        a: [
          "Native Apps: Built specifically for a target platform (iOS using Swift/Objective-C; Android using Java/Kotlin) using platform SDKs. High performance, direct access to device APIs.",
          "Mobile Web Apps: Web applications accessed using mobile browsers (like Chrome or Safari). Built using HTML, CSS, and JS. Do not require installation.",
          "Hybrid Apps: Web apps wrapped inside a native container shell (using technologies like Cordova, Ionic, or Capacitor). They look like native apps but load web assets inside a WebView."
        ]
      },
      {
        q: "[Beginner] What is Appium Inspector and what is it used for?",
        a: [
          "Appium Inspector is a GUI-based utility tool used to inspect the structure of native/hybrid mobile apps. It allows testers to take screenshots, view the XML hierarchy tree, identify element locators (like ID or accessibility id), and simulate actions (taps, text input) during scripting."
        ]
      },
      {
        q: "[Beginner] Explain the Client-Server Architecture of Appium.",
        a: [
          "1. Client: The automation script (written in Java, Python, JS, etc.) that uses Appium client libraries to send commands via HTTP REST requests.",
          "2. Appium Server: The Node.js server that receives commands, parses capabilities, and forwards requests to the driver.",
          "3. Drivers: Platform-specific modules (like appium-uiautomator2-driver or appium-xcuitest-driver) that interact with the physical device/emulator.",
          "4. Mobile Device/Emulator: Runs the client application and executes native automated tasks."
        ]
      },
      {
        q: "[Beginner] What is an Emulator vs. a Simulator?",
        a: [
          "Emulator: An Android virtual device that emulates both the target software environment and the underlying physical CPU hardware architecture. Slower to launch, highly accurate.",
          "Simulator: An iOS virtual device that simulates the software behavior of an iPhone/iPad on top of the host Mac computer's CPU. Extremely fast, but does not emulate hardware components."
        ]
      },
      {
        q: "[Beginner] What are Desired Capabilities (Appium Options)?",
        a: [
          "Desired Capabilities are key-value pairs (stored as JSON) sent by the client to the Appium server to configure the automation session.",
          "They instruct the server on platform name, device name, path to app binaries, package activities, and automation engines."
        ]
      },
      {
        q: "[Beginner] What is the difference between appPackage and appActivity in Android?",
        a: [
          "appPackage: The unique identifier of the target Android application (e.g., `com.example.myapp`). Tells Android which app to launch.",
          "appActivity: Represents a specific page/screen screen layout within the application (e.g., `com.example.myapp.MainActivity`). Tells Appium which screen to open on start."
        ]
      },
      {
        q: "[Beginner] What is the preferred locator strategy in Appium and why?",
        a: [
          "Accessibility ID (AccessibilityId) is the preferred locator strategy.",
          "Why: It is cross-platform (works on both Android and iOS), performs fast, and remains stable even if the visual layout or underlying hierarchy changes."
        ]
      },
      {
        q: "[Beginner] How do you inspect an iOS application compared to an Android application?",
        a: [
          "Android: Use Appium Inspector, Android Studio Layout Inspector, or the legacy `uiautomatorviewer` utility.",
          "iOS: Use Appium Inspector, Xcode Accessibility Inspector, or Xcode's built-in Debug View Hierarchy tool."
        ]
      },
      {
        q: "[Beginner] What is automationName capability in Appium?",
        a: [
          "The automationName capability defines the driver engine to use for automation execution:",
          "- Android: `UiAutomator2` (standard default).",
          "- iOS: `XCUITest` (standard default)."
        ]
      },
      {
        q: "[Intermediate] Write the capability configuration block to launch an Android app in Appium 2.x.",
        a: [
          "In Appium 2.0, capabilities use the `appium:` prefix standard:",
          "UiAutomator2Options options = new UiAutomator2Options();",
          "options.setPlatformName(\"Android\");",
          "options.setDeviceName(\"Pixel_7_Pro\");",
          "options.setApp(\"/absolute/path/to/app-debug.apk\");",
          "options.setAppPackage(\"com.example.myapp\");",
          "options.setAppActivity(\"com.example.myapp.MainActivity\");",
          "",
          "AndroidDriver driver = new AndroidDriver(new URL(\"http://127.0.0.1:4723/\"), options);"
        ]
      },
      {
        q: "[Intermediate] How do you handle switching contexts in a Hybrid mobile application?",
        a: [
          "Retrieve available contexts, identify the webview container context, and switch focus from NATIVE_APP:",
          "Set<String> contexts = driver.getContextHandles();",
          "for (String context : contexts) {",
          "    if (context.contains(\"WEBVIEW\")) {",
          "        driver.context(context); // Switches to WebView context",
          "    }",
          "}",
          "// Switch back to Native App context:",
          "driver.context(\"NATIVE_APP\");"
        ]
      },
      {
        q: "[Intermediate] How do you automate mobile gestures (Swipe and Scroll) in modern Appium?",
        a: [
          "In Appium 2.x, use the W3C Actions API or mobile script shortcuts (highly recommended):",
          "// Scroll down shortcut for Android:",
          "driver.executeScript(\"mobile: scrollGesture\", ImmutableMap.of(",
          "    \"left\", 100, \"top\", 100, \"width\", 200, \"height\", 200,",
          "    \"direction\", \"down\",",
          "    \"percent\", 3.0",
          "));"
        ]
      },
      {
        q: "[Intermediate] What are the differences between Appium 1.x and Appium 2.x?",
        a: [
          "1. Driver Decoupling: In Appium 1.x, all drivers (UiAutomator2, XCUITest) were bundled with the main server installer. In Appium 2.x, the server is modular. You install the lightweight server, then install drivers independently (e.g. `appium driver install uiautomator2`).",
          "2. Server Base Path: Appium 2.0 changes the default URL endpoint from `http://localhost:4723/wd/hub` to `http://localhost:4723/`.",
          "3. Plugin Support: Appium 2.x introduces a plugin system to intercept commands, modify logs, and support advanced actions (e.g. image recognition)."
        ]
      },
      {
        q: "[Intermediate] How do you perform a simple Tap and Long Press in Appium?",
        a: [
          "Use the PointerInput class representing fingers:",
          "WebElement element = driver.findElement(AppiumBy.accessibilityId(\"login-btn\"));",
          "// Long press shortcut command:",
          "driver.executeScript(\"mobile: longClickGesture\", ImmutableMap.of(",
          "    \"elementId\", ((RemoteWebElement) element).getId(),",
          "    \"duration\", 2000",
          "));"
        ]
      },
      {
        q: "[Intermediate] Explain the difference between platformName, deviceName, and udid capabilities.",
        a: [
          "platformName: Target mobile operating system (e.g., `Android` or `iOS`).",
          "deviceName: Label identifying the virtual or physical device (e.g. `emulator-5554` or `MyiPhone`).",
          "udid: The unique physical identifier of the hardware device (essential when connecting physical devices or running parallel tests)."
        ]
      },
      {
        q: "[Intermediate] How do you locate elements using AndroidUIAutomator locator strategy?",
        a: [
          "Use AppiumBy with native UiSelector APIs:",
          "WebElement element = driver.findElement(AppiumBy.androidUIAutomator(",
          "    \"new UiSelector().text(\\\"Submit\\\").className(\\\"android.widget.Button\\\")\"",
          "));"
        ]
      },
      {
        q: "[Intermediate] What are common ways to handle synchronizations (waits) in Appium?",
        a: [
          "Always use Explicit Waits (`WebDriverWait`) to handle lazy rendering over mobile networks, and avoid `Thread.sleep()`:",
          "WebDriverWait wait = new WebDriverWait(driver, Duration.ofSeconds(10));",
          "wait.until(ExpectedConditions.visibilityOfElementLocated(AppiumBy.accessibilityId(\"welcome_msg\")));"
        ]
      },
      {
        q: "[Intermediate] How do you inspect and automate toast messages in Android?",
        a: [
          "Toast messages are ephemeral alerts. Inspect them using screen capture recordings, then locate using class name XPath matching because they lack accessibility IDs:",
          "WebElement toast = driver.findElement(AppiumBy.xpath(\"//android.widget.Toast[1]\"));",
          "String toastText = toast.getText();"
        ]
      },
      {
        q: "[Intermediate] Explain how you can toggle Network connections (Wi-Fi, Mobile Data, Airplane Mode).",
        a: [
          "Use the AndroidDriver Connection mapping interfaces:",
          "// Enable Airplane Mode",
          "driver.setConnection(new ConnectionState(ConnectionState.AIRPLANE_MODE_MASK));",
          "// Restore Wi-Fi and Data connection",
          "driver.setConnection(new ConnectionState(ConnectionState.WIFI_MASK | ConnectionState.DATA_MASK));"
        ]
      },
      {
        q: "[Intermediate] How do you lock and unlock mobile screens in Appium?",
        a: [
          "// Lock the screen for 5 seconds",
          "driver.lockDevice(Duration.ofSeconds(5));",
          "",
          "// Check lock status",
          "if (driver.isDeviceLocked()) {",
          "    driver.unlockDevice();",
          "}"
        ]
      },
      {
        q: "[Intermediate] How do you run the app in the background and restore it?",
        a: [
          "Use runAppInBackground API to test app state persistence:",
          "// Put app in background for 10 seconds, then restore",
          "driver.runAppInBackground(Duration.ofSeconds(10));"
        ]
      },
      {
        q: "[Intermediate] How do you install, uninstall, or clear an app during a test run?",
        a: [
          "// Check if app is installed",
          "boolean isInstalled = driver.isAppInstalled(\"com.example.myapp\");",
          "",
          "// Install app from local APK path",
          "driver.installApp(\"/path/to/app.apk\");",
          "",
          "// Remove app",
          "driver.removeApp(\"com.example.myapp\");"
        ]
      },
      {
        q: "[Intermediate] How do you press hardware back buttons or home keys?",
        a: [
          "Use Android key event actions:",
          "import io.appium.java_client.android.nativekey.AndroidKey;",
          "import io.appium.java_client.android.nativekey.KeyEvent;",
          "",
          "driver.pressKey(new KeyEvent(AndroidKey.BACK));",
          "driver.pressKey(new KeyEvent(AndroidKey.HOME));"
        ]
      },
      {
        q: "[Intermediate] Explain the use of the noReset and fullReset desired capabilities.",
        a: [
          "noReset: Set to `true` to bypass uninstalling/re-installing the app and clearing app data before session startup. Preserves logged-in sessions.",
          "fullReset: Set to `true` to completely uninstall the app, clear all data, and perform a fresh install on session start. Ensures clean execution states."
        ]
      },
      {
        q: "[Intermediate] How do you take screenshots in Appium?",
        a: [
          "Cast the driver to TakesScreenshot, identical to Selenium:",
          "File file = ((TakesScreenshot) driver).getScreenshotAs(OutputType.FILE);",
          "FileUtils.copyFile(file, new File(\"screenshots/mobile_fail.png\"));"
        ]
      },
      {
        q: "[Intermediate] What are the differences between using AndroidDriver and iOSDriver?",
        a: [
          "AndroidDriver: Targets Android systems, uses UiAutomator2 engine capabilities, supports key events (BACK, VOLUME_UP), and runs on both Windows and macOS.",
          "iOSDriver: Targets iOS systems, uses XCUITest engine capabilities, requires macOS host systems with Xcode installed, and uses Bundle IDs instead of App Packages."
        ]
      },
      {
        q: "[Intermediate] What port does the Appium server run on by default?",
        a: [
          "By default, the Appium server runs and listens on port `4723`."
        ]
      },
      {
        q: "[Intermediate] How do you hide the virtual keyboard during automation?",
        a: [
          "Use the hideKeyboard() driver action:",
          "if (driver.isKeyboardShown()) {",
          "    driver.hideKeyboard();",
          "}"
        ]
      },
      {
        q: "[Intermediate] How do you test push notifications in Appium?",
        a: [
          "Android: Swipe open the notifications drawer using swipe gestures, interact with the notification elements, click on them to navigate to the app screen, or swipe up to close.",
          "// Open notification panel:",
          "driver.openNotifications();"
        ]
      },
      {
        q: "[Advanced] Explain Appium 2.x command lines to manage drivers and plugins.",
        a: [
          "Appium 2.x decouples driver modules. Execute them directly from the CLI shell:",
          "// List installed drivers",
          "appium driver list --installed",
          "",
          "// Install Android UiAutomator2 driver",
          "appium driver install uiautomator2",
          "",
          "// Install iOS XCUITest driver",
          "appium driver install xcuitest",
          "",
          "// Run server",
          "appium"
        ]
      },
      {
        q: "[Advanced] How do you implement parallel testing in Appium across multiple physical devices?",
        a: [
          "To avoid port and device collision conflicts, assign unique ports and identifiers per thread context inside test configurations:",
          "1. Thread 1 configuration: Set `udid` to `device_A`, `systemPort` to `8201`, and start driver mapped to server A.",
          "2. Thread 2 configuration: Set `udid` to `device_B`, `systemPort` to `8202`, and start driver mapped to server B."
        ]
      },
      {
        q: "[Advanced] Write a Java method using the W3C Actions API to perform a custom scroll gesture.",
        a: [
          "Use PointerInput to create swipe coordinate sequences:",
          "public void swipe(int startX, int startY, int endX, int endY) {",
          "    PointerInput finger = new PointerInput(PointerInput.Kind.TOUCH, \"finger\");",
          "    Sequence swipe = new Sequence(finger, 1);",
          "    swipe.addAction(finger.createPointerMove(Duration.ZERO, PointerInput.Origin.viewport(), startX, startY));",
          "    swipe.addAction(finger.createPointerDown(PointerInput.MouseButton.LEFT.asArg()));",
          "    swipe.addAction(finger.createPointerMove(Duration.ofMillis(600), PointerInput.Origin.viewport(), endX, endY));",
          "    swipe.addAction(finger.createPointerUp(PointerInput.MouseButton.LEFT.asArg()));",
          "    driver.perform(Arrays.asList(swipe));",
          "}"
        ]
      },
      {
        q: "[Advanced] How do you handle system popups (like runtime permission prompts: Camera, Location) automatically?",
        a: [
          "Use the autoGrantPermissions capability inside capability configurations:",
          "UiAutomator2Options options = new UiAutomator2Options();",
          "// Grants all runtime app permissions on install automatically",
          "options.autoGrantPermissions(true);"
        ]
      },
      {
        q: "[Advanced] Explain the differences between Appium driver commands: click() vs. tap().",
        a: [
          "click(): Standard Selenium command mapping. Resolves element boundaries, calculates the center point, and clicks. Good for standard native buttons.",
          "tap(): Appium touch interface command. Allows specifying custom touch counts, finger contacts, coordinates, and pressure metrics. Best for canvas or dynamic game structures."
        ]
      },
      {
        q: "[Advanced] How do you configure and launch testing on a physical iOS device using Appium?",
        a: [
          "Requires configuring code signature attributes to install WebDriverAgentRunner onto the physical device:",
          "1. Capabilities: Set `udid` of the iOS device, `automationName` to `XCUITest`, and provide provisioning profile configurations.",
          "2. Capabilities parameters:",
          "   - `xcodeOrgId`: Your Apple Developer Team ID.",
          "   - `xcodeSigningId`: Set to `iPhone Developer`.",
          "   - `updatedWDABundleId`: Provide a unique bundle identifier."
        ]
      },
      {
        q: "[Advanced] Explain the role of the WebDriverAgent (WDA) in iOS automation.",
        a: [
          "WebDriverAgent is an iOS server runner developed by Facebook that runs inside iOS devices to control simulator/device UI testing.",
          "Appium client commands are translated by the server into WDA command payloads. WDA receives them and executes actions on iOS using Apple's XCTest framework APIs."
        ]
      },
      {
        q: "[Advanced] How do you execute deep linking in Appium to navigate to specific screens directly?",
        a: [
          "Deep links launch application screens directly bypassing standard navigation steps:",
          "// For Android:",
          "driver.executeScript(\"mobile: deepLink\", ImmutableMap.of(",
          "    \"url\", \"myapp://settings/profile\",",
          "    \"package\", \"com.example.myapp\"",
          "));"
        ]
      },
      {
        q: "[Advanced] How do you retrieve mobile device resource vitals (CPU, Memory, Battery) during execution?",
        a: [
          "Use performance metrics collectors:",
          "List<List<Object>> cpuData = driver.getPerformanceData(\"com.example.myapp\", \"cpuinfo\", 5);",
          "List<List<Object>> memoryData = driver.getPerformanceData(\"com.example.myapp\", \"memoryinfo\", 5);",
          "System.out.println(\"CPU Data: \" + cpuData);"
        ]
      },
      {
        q: "[Advanced] How do you simulate biometric authentication (Fingerprint / Face ID) in Appium?",
        a: [
          "// For Android Emulator (simulating fingerprint ID 1 match):",
          "driver.fingerPrint(1);",
          "",
          "// For iOS Simulator (toggling Face ID display matching):",
          "driver.executeScript(\"mobile: enrollBiometric\", ImmutableMap.of(\"isEnabled\", true));",
          "driver.executeScript(\"mobile: performBiometric\", ImmutableMap.of(\"match\", true));"
        ]
      },
      {
        q: "[Advanced] Explain the difference between locate strategies: AppiumBy.iOSClassChain and AppiumBy.iOSNsPredicate.",
        a: [
          "iOSClassChain: Combines DOM XPath capability with speed. Allows indexing and child navigation like `**/XCUIElementTypeCell[`name BEGINSWITH \"item\"`].",
          "iOSNsPredicate: Uses Apple's native query search format directly (extremely fast). Allows complex comparison checks like `name CONTAINS 'Sign' OR label == 'Submit'`."
        ]
      },
      {
        q: "[Advanced] How do you simulate location coordinates (Mock Geo-location) in Appium?",
        a: [
          "Set device geolocation parameters using Location helpers:",
          "Location loc = new Location(37.7749, -122.4194, 0); // San Francisco coordinates",
          "driver.setLocation(loc);"
        ]
      },
      {
        q: "[Advanced] How do you pull a file from the mobile device to the host computer?",
        a: [
          "Retrieve device file assets byte array structures:",
          "byte[] fileData = driver.pullFile(\"/sdcard/Pictures/report.pdf\");",
          "FileOutputStream out = new FileOutputStream(\"downloads/report.pdf\");",
          "out.write(fileData);",
          "out.close();"
        ]
      },
      {
        q: "[Advanced] How do you push a file from the host computer onto the mobile device?",
        a: [
          "Upload local binary bytes into the mobile directory:",
          "byte[] fileData = Files.readAllBytes(Paths.get(\"local-data.txt\"));",
          "driver.pushFile(\"/sdcard/Documents/remote-data.txt\", fileData);"
        ]
      },
      {
        q: "[Advanced] Explain Appium server plugins and how to use the Appium Device Farm plugin.",
        a: [
          "Plugins extend Appium functionality. The Device Farm plugin automatically manages connected emulators/simulators and physical devices, handles dynamic port distribution, and exposes a dashboard to track active device allocation metrics."
        ]
      },
      {
        q: "[Advanced] What is WebDriverAgent runner build compilation failure and how do you troubleshoot it?",
        a: [
          "Occurs on iOS when provisioning profiles or certificates are invalid.",
          "Troubleshooting steps:",
          "1. Open the WebDriverAgent Xcode project inside Xcode manually on the host Mac.",
          "2. Navigate to 'Signing & Capabilities'.",
          "3. Select a valid Apple Developer Account under Team.",
          "4. Build the WebDriverAgentRunner target directly on Xcode to verify code signatures."
        ]
      },
      {
        q: "[Advanced] How do you execute tests on real mobile browsers (like Chrome on Android or Safari on iOS)?",
        a: [
          "Pass the browserName capability directly and omit app paths:",
          "// For Android Chrome:",
          "options.setCapability(\"browserName\", \"Chrome\");",
          "// For iOS Safari:",
          "options.setCapability(\"browserName\", \"Safari\");"
        ]
      },
      {
        q: "[Advanced] How do you automate native mobile settings app screens (like toggling bluetooth or location services)?",
        a: [
          "Launch the settings app dynamically by specifying its target package activity:",
          "driver.startActivity(new Activity(\"com.android.settings\", \"com.android.settings.Settings\"));",
          "// Perform clicks and toggle settings",
          "// Restore target app"
        ]
      },
      {
        q: "[Advanced] How do you capture screen recordings of tests dynamically?",
        a: [
          "Use startRecordingScreen and stopRecordingScreen interfaces:",
          "driver.startRecordingScreen();",
          "// execute tests...",
          "String videoBase64 = driver.stopRecordingScreen();",
          "byte[] decodedVideo = Base64.getDecoder().decode(videoBase64);",
          "Files.write(Paths.get(\"test-recordings/test.mp4\"), decodedVideo);"
        ]
      },
      {
        q: "[Advanced] How do you identify memory leak bottlenecks on Android apps using Appium?",
        a: [
          "Execute cyclic tests (e.g. logging in and logging out 100 times) and retrieve memory data periodically using `driver.getPerformanceData()`. If native heap usage values show a monotonic rise without ever dropping, it indicates a memory leak."
        ]
      }
    ]
  },
  "git-commands": {
    title: "Git Commands – Interview & Daily Reference",
    qa: [
      {
        q: "1. Configure Git",
        a: [
          "Check Git version: git --version",
          "Set username: git config --global user.name 'Your Name'",
          "Set email: git config --global user.email 'you@example.com'",
          "View configuration: git config --list"
        ]
      },
      {
        q: "2. Create & Clone Repository",
        a: [
          "Initialize repository: git init",
          "Clone repository: git clone <repository_url>"
        ]
      },
      {
        q: "3. Check Status & History",
        a: [
          "Check status: git status",
          "View commit history: git log",
          "One-line log: git log --oneline",
          "Show changes: git diff"
        ]
      },
      {
        q: "4. Stage & Commit",
        a: [
          "Stage one file: git add file.txt",
          "Stage all files: git add .",
          "Commit changes: git commit -m 'Initial commit'",
          "Amend last commit: git commit --amend"
        ]
      },
      {
        q: "5. Branching",
        a: [
          "List branches: git branch",
          "Create branch: git branch feature/login",
          "Switch branch: git checkout feature/login",
          "Create & switch: git checkout -b feature/login",
          "Using switch: git switch feature/login"
        ]
      },
      {
        q: "6. Merge & Rebase",
        a: [
          "Merge branch: git merge feature/login",
          "Rebase branch: git rebase main"
        ]
      },
      {
        q: "7. Remote Repository",
        a: [
          "View remotes: git remote -v",
          "Add remote: git remote add origin <url>",
          "Change remote URL: git remote set-url origin <url>"
        ]
      },
      {
        q: "8. Push & Pull",
        a: [
          "Push branch: git push origin main",
          "Push first time: git push -u origin main",
          "Pull latest changes: git pull origin main",
          "Fetch changes: git fetch"
        ]
      },
      {
        q: "9. Undo Changes",
        a: [
          "Restore file: git restore file.txt",
          "Unstage file: git restore --staged file.txt",
          "Reset last commit (keep changes): git reset --soft HEAD~1",
          "Reset last commit: git reset --hard HEAD~1"
        ]
      },
      {
        q: "10. Stash",
        a: [
          "Save changes: git stash",
          "List stashes: git stash list",
          "Apply stash: git stash apply",
          "Pop stash: git stash pop"
        ]
      },
      {
        q: "11. Tags",
        a: [
          "Create tag: git tag v1.0",
          "Push tags: git push --tags"
        ]
      },
      {
        q: "12. Useful Commands",
        a: [
          "Remove untracked files: git clean -fd",
          "Show current branch: git branch --show-current",
          "Show remote branches: git branch -r",
          "Delete local branch: git branch -d feature/login",
          "Delete remote branch: git push origin --delete feature/login"
        ]
      },
      {
        q: "13. Common Workflow",
        a: [
          "Clone project: git clone <repo_url>",
          "Create feature branch: git checkout -b feature/new-test",
          "Stage changes: git add .",
          "Commit: git commit -m 'Add tests'",
          "Push: git push -u origin feature/new-test",
          "Open Pull Request: Create PR in GitHub/GitLab/Azure DevOps"
        ]
      }
    ]
  },
  "python-course": {
    title: "Python Course",
    qa: [
      {
        q: "Python Introduction",
        a: "Python is a popular programming language. It was created by Guido van Rossum, and released in 1991. It is used for web development (server-side), software development, mathematics, and system scripting."
      },
      {
        q: "Python Variables",
        a: "Variables are containers for storing data values. Python has no command for declaring a variable. A variable is created the moment you first assign a value to it.",
        example: {
          title: "Creating Variables",
          code: "x = 5\ny = \"John\"\nprint(x)\nprint(y)",
          output: "5\nJohn"
        }
      },
      {
        q: "Python Data Types",
        a: "In programming, data type is an important concept. Variables can store data of different types, and different types can do different things. Python has the following data types built-in by default, in these categories: Text Type: str, Numeric Types: int, float, complex, Sequence Types: list, tuple, range, Mapping Type: dict, Set Types: set, frozenset, Boolean Type: bool, Binary Types: bytes, bytearray, memoryview."
      },
      {
        q: "Python Strings",
        a: "Strings in python are surrounded by either single quotation marks, or double quotation marks. 'hello' is the same as \"hello\". You can display a string literal with the print() function.",
        example: {
          title: "String formatting",
          code: "a = \"Hello\"\nprint(a)",
          output: "Hello"
        }
      },
      {
        q: "Python Numbers",
        a: "Python has three numeric types: int (integers), float (floating point numbers), and complex (complex numbers). You can perform arithmetic operations like addition (+), subtraction (-), multiplication (*), division (/), floor division (//), modulus (%), and exponentiation (**). Python also has built-in math functions like abs(), round(), pow(), min(), and max().",
        example: {
          title: "Basic arithmetic operations in Python.",
          code: "# Arithmetic operations\nx = 10\ny = 3\n\nprint(x + y)  # Addition\nprint(x - y)  # Subtraction\nprint(x * y)  # Multiplication\nprint(x / y)  # Division\nprint(x // y) # Floor division\nprint(x % y)  # Modulus\nprint(x ** y) # Exponentiation",
          output: "13\n7\n30\n3.3333333333333335\n3\n1\n1000"
        }
      },
      {
        q: "Python Operators",
        a: "Operators are used to perform operations on variables and values. Python divides the operators in the following groups: Arithmetic operators, Assignment operators, Comparison operators, Logical operators, Identity operators, Membership operators, Bitwise operators.",
        example: {
          title: "Comparison and Logical Operators",
          code: "x = 5\ny = 10\nprint(x > 3 and y < 15)\nprint(x == y)",
          output: "True\nFalse"
        }
      },
      {
        q: "Python Lists",
        a: "Lists are used to store multiple items in a single variable. Lists are one of 4 built-in data types in Python used to store collections of data. Lists are created using square brackets [].",
        example: {
          title: "Creating and accessing lists",
          code: "thislist = [\"apple\", \"banana\", \"cherry\"]\nprint(thislist)\nprint(thislist[1])",
          output: "['apple', 'banana', 'cherry']\nbanana"
        }
      },
      {
        q: "Python Tuples",
        a: "Tuples are used to store multiple items in a single variable. A tuple is a collection which is ordered and unchangeable. Tuples are written with round brackets ().",
        example: {
          title: "Working with Tuples",
          code: "thistuple = (\"apple\", \"banana\", \"cherry\")\nprint(thistuple)\nprint(len(thistuple))",
          output: "('apple', 'banana', 'cherry')\n3"
        }
      },
      {
        q: "Python If...Else",
        a: "Python supports the usual logical conditions from mathematics: Equals (a == b), Not Equals (a != b), Less than (a < b), etc. These conditions can be used in several ways, most commonly in 'if statements' and loops.",
        example: {
          title: "If...Else statement",
          code: "a = 200\nb = 33\nif b > a:\n  print(\"b is greater than a\")\nelif a == b:\n  print(\"a and b are equal\")\nelse:\n  print(\"a is greater than b\")",
          output: "a is greater than b"
        }
      },
      {
        q: "Python Loops",
        a: "Python has two primitive loop commands: while loops and for loops. A for loop is used for iterating over a sequence (that is either a list, a tuple, a dictionary, a set, or a string).",
        example: {
          title: "For loop example",
          code: "fruits = [\"apple\", \"banana\", \"cherry\"]\nfor x in fruits:\n  print(x)",
          output: "apple\nbanana\ncherry"
        }
      },
      {
        q: "Python Functions",
        a: "A function is a block of code which only runs when it is called. You can pass data, known as parameters, into a function. A function can return data as a result.",
        example: {
          title: "Creating and calling a function",
          code: "def my_function(fname):\n  print(fname + \" Refsnes\")\n\nmy_function(\"Emil\")\nmy_function(\"Tobias\")",
          output: "Emil Refsnes\nTobias Refsnes"
        }
      },
      {
        q: "Python Lambda",
        a: "A lambda function is a small anonymous function. A lambda function can take any number of arguments, but can only have one expression.",
        example: {
          title: "Lambda Function",
          code: "x = lambda a, b : a * b\nprint(x(5, 6))",
          output: "30"
        }
      },
      {
        q: "Python Classes and Objects",
        a: "Python is an object oriented programming language. Almost everything in Python is an object, with its properties and methods. A Class is like an object constructor, or a 'blueprint' for creating objects.",
        example: {
          title: "Creating a Class and Object",
          code: "class Person:\n  def __init__(self, name, age):\n    self.name = name\n    self.age = age\n\np1 = Person(\"John\", 36)\nprint(p1.name)\nprint(p1.age)",
          output: "John\n36"
        }
      },
      {
        q: "Python Inheritance",
        a: "Inheritance allows us to define a class that inherits all the methods and properties from another class. Parent class is the class being inherited from, also called base class. Child class is the class that inherits from another class.",
        example: {
          title: "Inheritance Example",
          code: "class Person:\n  def __init__(self, fname, lname):\n    self.firstname = fname\n    self.lastname = lname\n\nclass Student(Person):\n  pass\n\nx = Student(\"Mike\", \"Olsen\")\nprint(x.firstname, x.lastname)",
          output: "Mike Olsen"
        }
      },
      {
        q: "Python Iterators",
        a: "An iterator is an object that contains a countable number of values. An iterator is an object that can be iterated upon, meaning that you can traverse through all the values. Technically, in Python, an iterator is an object which implements the iterator protocol, which consist of the methods __iter__() and __next__().",
        example: {
          title: "Iterator Example",
          code: "mytuple = (\"apple\", \"banana\", \"cherry\")\nmyit = iter(mytuple)\n\nprint(next(myit))\nprint(next(myit))\nprint(next(myit))",
          output: "apple\nbanana\ncherry"
        }
      },
      {
        q: "Python Polymorphism",
        a: "The word polymorphism means having many forms. In programming, polymorphism means the same function name (but different signatures) being used for different types.",
        example: {
          title: "Polymorphism Example",
          code: "class Car:\n  def move(self):\n    print(\"Drive!\")\n\nclass Boat:\n  def move(self):\n    print(\"Sail!\")\n\ncar1 = Car()\nboat1 = Boat()\n\nfor x in (car1, boat1):\n  x.move()",
          output: "Drive!\nSail!"
        }
      },
      {
        q: "Python Scope",
        a: "A variable is only available from inside the region it is created. This is called scope. A variable created inside a function belongs to the local scope of that function. A variable created in the main body of the Python code is a global variable and belongs to the global scope.",
        example: {
          title: "Global and Local Scope",
          code: "x = 300\n\ndef myfunc():\n  x = 200\n  print(\"Inside func:\", x)\n\nmyfunc()\nprint(\"Outside func:\", x)",
          output: "Inside func: 200\nOutside func: 300"
        }
      },
      {
        q: "Python Modules",
        a: "Consider a module to be the same as a code library. A file containing a set of functions you want to include in your application. To create a module just save the code you want in a file with the file extension .py.",
        example: {
          title: "Importing a module",
          code: "import platform\n\nx = platform.system()\nprint(x)",
          output: "Linux (or Darwin/Windows)"
        }
      },
      {
        q: "Python Dates",
        a: "A date in Python is not a data type of its own, but we can import a module named datetime to work with dates as date objects.",
        example: {
          title: "Datetime Example",
          code: "import datetime\n\nx = datetime.datetime(2020, 5, 17)\nprint(x.strftime(\"%B\"))",
          output: "May"
        }
      },
      {
        q: "Python Math",
        a: "Python has a set of built-in math functions, including an extensive math module, that allows you to perform mathematical tasks on numbers.",
        example: {
          title: "Math Example",
          code: "import math\n\nx = math.ceil(1.4)\ny = math.floor(1.4)\n\nprint(x)\nprint(y)",
          output: "2\n1"
        }
      },
      {
        q: "Python JSON",
        a: "JSON is a syntax for storing and exchanging data. JSON is text, written with JavaScript object notation. Python has a built-in package called json, which can be used to work with JSON data.",
        example: {
          title: "Parse JSON",
          code: "import json\n\n# some JSON:\nx =  '{ \"name\":\"John\", \"age\":30, \"city\":\"New York\"}'\n\n# parse x:\ny = json.loads(x)\n\nprint(y[\"age\"])",
          output: "30"
        }
      },
      {
        q: "Python RegEx",
        a: "A RegEx, or Regular Expression, is a sequence of characters that forms a search pattern. RegEx can be used to check if a string contains the specified search pattern.",
        example: {
          title: "RegEx Search",
          code: "import re\n\ntxt = \"The rain in Spain\"\nx = re.search(\"^The.*Spain$\", txt)\nprint(bool(x))",
          output: "True"
        }
      },
      {
        q: "Python PIP",
        a: "PIP is a package manager for Python packages, or modules if you like. A package contains all the files you need for a module.",
        example: {
          title: "Using a package",
          code: "# Assuming camelcase is installed via pip\nimport camelcase\n\nc = camelcase.CamelCase()\ntxt = \"hello world\"\nprint(c.hump(txt))",
          output: "Hello World"
        }
      },
      {
        q: "Python Try...Except",
        a: "The try block lets you test a block of code for errors. The except block lets you handle the error. The else block lets you execute code when there is no error. The finally block lets you execute code, regardless of the result of the try- and except blocks.",
        example: {
          title: "Exception Handling",
          code: "try:\n  print(x)\nexcept NameError:\n  print(\"Variable x is not defined\")\nexcept:\n  print(\"Something else went wrong\")",
          output: "Variable x is not defined"
        }
      },
      {
        q: "Python User Input",
        a: "Python allows for user input. That means we are able to ask the user for input. The method is a bit different in Python 3.6 than Python 2.7. Python 3.6 uses the input() method.",
        example: {
          title: "User Input",
          code: "username = input(\"Enter username:\")\nprint(\"Username is: \" + username)",
          output: "Enter username:John\nUsername is: John"
        }
      },
      {
        q: "Python String Formatting",
        a: "To make sure a string will display as expected, we can format the result with the format() method or f-strings. F-strings allow you to embed expressions directly inside string literals.",
        example: {
          title: "F-Strings",
          code: "name = \"John\"\nage = 36\ntxt = f\"My name is {name}, and I am {age}\"\nprint(txt)",
          output: "My name is John, and I am 36"
        }
      },
      {
        q: "Python File Handling",
        a: "File handling is an important part of any web application. Python has several functions for creating, reading, updating, and deleting files. The key function for working with files in Python is the open() function.",
        example: {
          title: "Opening a file",
          code: "# f = open(\"demofile.txt\", \"r\")\n# print(f.read())\nprint(\"File contents read successfully\")",
          output: "File contents read successfully"
        }
      },
      {
        q: "Python List Comprehension",
        a: "List comprehension offers a shorter syntax when you want to create a new list based on the values of an existing list.",
        example: {
          title: "List Comprehension",
          code: "fruits = [\"apple\", \"banana\", \"cherry\", \"kiwi\", \"mango\"]\nnewlist = [x for x in fruits if \"a\" in x]\nprint(newlist)",
          output: "['apple', 'banana', 'mango']"
        }
      },
      {
        q: "Python Dictionary Comprehension",
        a: "Similar to list comprehensions, dictionary comprehensions allow you to easily create dictionaries using a compact syntax.",
        example: {
          title: "Dict Comprehension",
          code: "squares = {x: x*x for x in range(1, 6)}\nprint(squares)",
          output: "{1: 1, 2: 4, 3: 9, 4: 16, 5: 25}"
        }
      },
      {
        q: "Python Generators",
        a: "Generators are a simple way of creating iterators. A generator is a function that returns an object (iterator) which we can iterate over (one value at a time). It uses the yield keyword instead of return.",
        example: {
          title: "Generator Function",
          code: "def my_generator():\n  yield 1\n  yield 2\n  yield 3\n\nfor val in my_generator():\n  print(val)",
          output: "1\n2\n3"
        }
      },
      {
        q: "Python Decorators",
        a: "Decorators allow you to modify the behavior of a function or class. Decorators allow us to wrap another function in order to extend the behavior of the wrapped function, without permanently modifying it.",
        example: {
          title: "Basic Decorator",
          code: "def my_decorator(func):\n  def wrapper():\n    print(\"Before function\")\n    func()\n    print(\"After function\")\n  return wrapper\n\n@my_decorator\ndef say_hello():\n  print(\"Hello!\")\n\nsay_hello()",
          output: "Before function\nHello!\nAfter function"
        }
      },
      {
        q: "Python Context Managers",
        a: "Context managers allow you to allocate and release resources precisely when you want to. The most widely used example of context managers is the with statement. Suppose you have two related operations which you'd like to execute as a pair, with a block of code in between. Context managers allow you to do specifically that.",
        example: {
          title: "With Statement",
          code: "class MyContextManager:\n  def __enter__(self):\n    print(\"Entering context\")\n    return self\n  def __exit__(self, exc_type, exc_value, traceback):\n    print(\"Exiting context\")\n\nwith MyContextManager() as cm:\n  print(\"Inside context\")",
          output: "Entering context\nInside context\nExiting context"
        }
      },
      {
        q: "Python Magic Methods",
        a: "Magic methods in Python are the special methods that start and end with the double underscores. They are also called dunder methods. Magic methods are not meant to be invoked directly by you, but the invocation happens internally from the class on a certain action.",
        example: {
          title: "Dunder string method",
          code: "class Point:\n  def __init__(self, x, y):\n    self.x = x\n    self.y = y\n  def __str__(self):\n    return f\"Point({self.x}, {self.y})\"\n\np = Point(3, 4)\nprint(p)",
          output: "Point(3, 4)"
        }
      },
      {
        q: "Python Threading",
        a: "Threading in python is used to run multiple threads (tasks, function calls) at the same time. The threading module provides a very simple and intuitive API for spawning multiple threads in a program.",
        example: {
          title: "Basic Threading",
          code: "import threading\nimport time\n\ndef print_hello():\n  print(\"Hello from thread\")\n\nt = threading.Thread(target=print_hello)\nt.start()\nt.join()",
          output: "Hello from thread"
        }
      },
      {
        q: "Python Multiprocessing",
        a: "The multiprocessing module allows the programmer to fully leverage multiple processors on a given machine. It runs processes in parallel, unlike threading which is limited by the Global Interpreter Lock (GIL) in CPython.",
        example: {
          title: "Multiprocessing basics",
          code: "from multiprocessing import Process\n\ndef f(name):\n  print('hello', name)\n\nif __name__ == '__main__':\n  p = Process(target=f, args=('bob',))\n  p.start()\n  p.join()",
          output: "hello bob"
        }
      },
      {
        q: "Python Asyncio",
        a: "asyncio is a library to write concurrent code using the async/await syntax. asyncio is used as a foundation for multiple Python asynchronous frameworks that provide high-performance network and web-servers, database connection libraries, distributed task queues, etc.",
        example: {
          title: "Async/Await",
          code: "import asyncio\n\nasync def main():\n  print('Hello')\n  await asyncio.sleep(1)\n  print('World')\n\nasyncio.run(main())",
          output: "Hello\nWorld"
        }
      },
      {
        q: "Python Type Hinting",
        a: "Type hinting is a formal solution to statically indicate the type of a value within your Python code. It helps catch errors early and improves code readability and IDE support.",
        example: {
          title: "Type hints for function",
          code: "def greeting(name: str) -> str:\n  return f\"Hello {name}\"\n\nprint(greeting(\"Alice\"))",
          output: "Hello Alice"
        }
      },
      {
        q: "Python \*args and \*\*kwargs",
        a: "The special syntax *args in function definitions in python is used to pass a variable number of arguments to a function. **kwargs is used to pass a keyworded, variable-length argument list.",
        example: {
          title: "Variable arguments",
          code: "def my_func(*args, **kwargs):\n  print(args)\n  print(kwargs)\n\nmy_func(1, 2, 3, a=4, b=5)",
          output: "(1, 2, 3)\n{'a': 4, 'b': 5}"
        }
      },
      {
        q: "Python Map, Filter, Reduce",
        a: "Map applies a function to all the items in an input_list. Filter creates a list of elements for which a function returns true. Reduce applies a rolling computation to sequential pairs of values in a list.",
        example: {
          title: "Map and Filter",
          code: "nums = [1, 2, 3, 4, 5]\nsquares = list(map(lambda x: x**2, nums))\nevens = list(filter(lambda x: x%2 == 0, nums))\nprint(squares)\nprint(evens)",
          output: "[1, 4, 9, 16, 25]\n[2, 4]"
        }
      },
      {
        q: "Python Property Decorator",
        a: "The @property decorator is a built-in decorator in Python which is helpful in defining the properties effortlessly without manually calling the inbuilt function property(). It is used to give \"special\" behavior to class attributes.",
        example: {
          title: "Using @property",
          code: "class Person:\n  def __init__(self, name):\n    self._name = name\n  \n  @property\n  def name(self):\n    return self._name.upper()\n\np = Person(\"john\")\nprint(p.name)",
          output: "JOHN"
        }
      }
    ]
  },
  "javascript-course": {
    title: "JavaScript Course",
    qa: [
      {
        q: "JS Introduction",
        a: "JavaScript is the world's most popular programming language. It is the programming language of the Web. JavaScript is easy to learn.",
        example: {
          title: "My First JavaScript",
          code: "console.log(\"Hello World!\");",
          output: "Hello World!"
        }
      },
      {
        q: "JS Variables (var, let, const)",
        a: "Variables are containers for storing data. In JavaScript, you can declare variables using var, let, or const. 'let' and 'const' were introduced in ES6 and are block-scoped, while 'var' is function-scoped.",
        example: {
          title: "Declaring variables",
          code: "let x = 5;\nconst y = 6;\nlet z = x + y;\nconsole.log(z);",
          output: "11"
        }
      },
      {
        q: "JS Data Types",
        a: "JavaScript has 8 Datatypes: String, Number, BigInt, Boolean, Undefined, Null, Symbol, and Object. The Object Datatype can contain an object, an array, or a date.",
        example: {
          title: "Checking data types",
          code: "let length = 16;\nlet lastName = \"Johnson\";\nlet x = {firstName:\"John\", lastName:\"Doe\"};\n\nconsole.log(typeof length);\nconsole.log(typeof lastName);\nconsole.log(typeof x);",
          output: "number\nstring\nobject"
        }
      },
      {
        q: "JS Functions",
        a: "A JavaScript function is a block of code designed to perform a particular task. A JavaScript function is executed when 'something' invokes it (calls it).",
        example: {
          title: "Simple Function",
          code: "function myFunction(p1, p2) {\n  return p1 * p2;\n}\nconsole.log(myFunction(4, 3));",
          output: "12"
        }
      },
      {
        q: "JS Objects",
        a: "In JavaScript, almost 'everything' is an object. Objects are variables too. But objects can contain many values. The values are written as name:value pairs.",
        example: {
          title: "Object properties",
          code: "const person = {\n  firstName: \"John\",\n  lastName: \"Doe\",\n  age: 50\n};\nconsole.log(person.firstName + \" is \" + person.age);",
          output: "John is 50"
        }
      },
      {
        q: "JS Arrays",
        a: "JavaScript arrays are used to store multiple values in a single variable. Arrays are a special type of objects. The typeof operator in JavaScript returns 'object' for arrays.",
        example: {
          title: "Array manipulation",
          code: "const cars = [\"Saab\", \"Volvo\", \"BMW\"];\ncars[0] = \"Opel\";\nconsole.log(cars);",
          output: "[ 'Opel', 'Volvo', 'BMW' ]"
        }
      },
      {
        q: "JS Array Methods",
        a: "JavaScript arrays have many built-in methods. Common methods include push(), pop(), shift(), unshift(), length, join(), and slice().",
        example: {
          title: "Using array methods",
          code: "const fruits = [\"Banana\", \"Orange\", \"Apple\"];\nfruits.push(\"Kiwi\");\nconsole.log(fruits.join(\" - \"));",
          output: "Banana - Orange - Apple - Kiwi"
        }
      },
      {
        q: "JS String Methods",
        a: "Strings have many methods that help you work with text. These include length, slice(), substring(), replace(), toUpperCase(), toLowerCase(), concat(), and trim().",
        example: {
          title: "String manipulation",
          code: "let text = \"Apple, Banana, Kiwi\";\nlet part = text.slice(7, 13);\nconsole.log(part);",
          output: "Banana"
        }
      },
      {
        q: "JS Template Literals",
        a: "Template Literals use back-ticks (``) rather than the quotes (\"\") to define a string. They allow multiline strings and string interpolation (variables in strings).",
        example: {
          title: "String Interpolation",
          code: "let firstName = \"John\";\nlet lastName = \"Doe\";\nlet text = `Welcome ${firstName}, ${lastName}!`;\nconsole.log(text);",
          output: "Welcome John, Doe!"
        }
      },
      {
        q: "JS If...Else",
        a: "Conditional statements are used to perform different actions based on different conditions. Use if to specify a block of code to be executed, if a specified condition is true.",
        example: {
          title: "Conditionals",
          code: "let time = 20;\nif (time < 18) {\n  console.log(\"Good day\");\n} else {\n  console.log(\"Good evening\");\n}",
          output: "Good evening"
        }
      },
      {
        q: "JS Switch",
        a: "The switch statement is used to perform different actions based on different conditions. Use the switch statement to select one of many code blocks to be executed.",
        example: {
          title: "Switch case",
          code: "let day;\nswitch (new Date(2023, 0, 1).getDay()) {\n  case 0:\n    day = \"Sunday\";\n    break;\n  case 1:\n    day = \"Monday\";\n    break;\n  default:\n    day = \"Other\";\n}\nconsole.log(day);",
          output: "Sunday"
        }
      },
      {
        q: "JS For Loop",
        a: "Loops can execute a block of code a number of times. The for loop is perfect when you know exactly how many times you want to loop through a block of code.",
        example: {
          title: "For Loop",
          code: "let text = \"\";\nfor (let i = 0; i < 3; i++) {\n  text += i + \" \";\n}\nconsole.log(text);",
          output: "0 1 2 "
        }
      },
      {
        q: "JS While Loop",
        a: "The while loop loops through a block of code as long as a specified condition is true.",
        example: {
          title: "While Loop",
          code: "let text = \"\";\nlet i = 0;\nwhile (i < 3) {\n  text += i + \" \";\n  i++;\n}\nconsole.log(text);",
          output: "0 1 2 "
        }
      },
      {
        q: "JS Arrow Functions",
        a: "Arrow functions were introduced in ES6. Arrow functions allow us to write shorter function syntax. They do not have their own 'this' binding.",
        example: {
          title: "Arrow Function Syntax",
          code: "const hello = (val) => \"Hello \" + val;\nconsole.log(hello(\"World\"));",
          output: "Hello World"
        }
      },
      {
        q: "JS Classes",
        a: "ECMAScript 2015, also known as ES6, introduced JavaScript Classes. JavaScript Classes are templates for JavaScript Objects.",
        example: {
          title: "Defining a Class",
          code: "class Car {\n  constructor(name, year) {\n    this.name = name;\n    this.year = year;\n  }\n}\nconst myCar = new Car(\"Ford\", 2014);\nconsole.log(myCar.name);",
          output: "Ford"
        }
      },
      {
        q: "JS Modules",
        a: "JavaScript modules allow you to break up your code into separate files. This makes it easier to maintain the code base. Modules are imported from external files with the import statement.",
        example: {
          title: "Importing a Module",
          code: "// import { name, age } from \"./person.js\";\nconsole.log(\"Modules help split code into separate files.\");",
          output: "Modules help split code into separate files."
        }
      },
      {
        q: "JS JSON",
        a: "JSON is a format for storing and transporting data. JSON is often used when data is sent from a server to a web page. JavaScript has a built in function to convert a string into a JavaScript object: JSON.parse().",
        example: {
          title: "Parsing JSON",
          code: "let text = '{\"employees\":[\"John\", \"Anna\", \"Peter\"]}';\nlet obj = JSON.parse(text);\nconsole.log(obj.employees[1]);",
          output: "Anna"
        }
      },
      {
        q: "JS This Keyword",
        a: "In JavaScript, the 'this' keyword refers to an object. Which object depends on how this is being invoked (used or called). In an object method, this refers to the object.",
        example: {
          title: "Using 'this' in objects",
          code: "const person = {\n  firstName: \"John\",\n  lastName: \"Doe\",\n  fullName: function() {\n    return this.firstName + \" \" + this.lastName;\n  }\n};\nconsole.log(person.fullName());",
          output: "John Doe"
        }
      },
      {
        q: "JS Callbacks",
        a: "A callback is a function passed as an argument to another function. This technique allows a function to call another function. A callback function can run after another function has finished.",
        example: {
          title: "Callback Example",
          code: "function myDisplayer(some) {\n  console.log(some);\n}\n\nfunction myCalculator(num1, num2, myCallback) {\n  let sum = num1 + num2;\n  myCallback(sum);\n}\n\nmyCalculator(5, 5, myDisplayer);",
          output: "10"
        }
      },
      {
        q: "JS Promises",
        a: "A Promise is an object linking producing code and consuming code. 'Producing code' is code that can take some time. 'Consuming code' is code that must wait for the result.",
        example: {
          title: "Creating a Promise",
          code: "let myPromise = new Promise(function(myResolve, myReject) {\n  myResolve(\"I love You !!\");\n});\n\nmyPromise.then(\n  function(value) { console.log(value); },\n  function(error) { console.log(error); }\n);",
          output: "I love You !!"
        }
      },
      {
        q: "JS Async/Await",
        a: "The keyword async before a function makes the function return a promise. The keyword await before a function makes the function wait for a promise.",
        example: {
          title: "Async Function",
          code: "async function myDisplay() {\n  let myPromise = new Promise(function(resolve) {\n    setTimeout(function() {resolve(\"I love You !!\");}, 100);\n  });\n  console.log(await myPromise);\n}\n\nmyDisplay();",
          output: "I love You !!"
        }
      },
      {
        q: "JS Destructuring",
        a: "Destructuring assignment is a special syntax that allows us to 'unpack' arrays or objects into a bunch of variables, as sometimes that’s more convenient.",
        example: {
          title: "Object Destructuring",
          code: "const person = {\n  name: 'John',\n  age: 30\n};\nconst { name, age } = person;\nconsole.log(name, age);",
          output: "John 30"
        }
      },
      {
        q: "JS Spread/Rest Operator",
        a: "The spread operator (...) allows an iterable, such as an array or string, to be expanded in places where zero or more arguments or elements are expected. The rest operator collects multiple elements and 'condenses' them into a single array.",
        example: {
          title: "Spread Syntax",
          code: "const q1 = [\"Jan\", \"Feb\", \"Mar\"];\nconst q2 = [\"Apr\", \"May\", \"Jun\"];\nconst year = [...q1, ...q2];\nconsole.log(year);",
          output: "[ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun' ]"
        }
      },
      {
        q: "JS Map",
        a: "A Map holds key-value pairs where the keys can be any datatype. A Map remembers the original insertion order of the keys.",
        example: {
          title: "Using Map",
          code: "const fruits = new Map([\n  [\"apples\", 500],\n  [\"bananas\", 300],\n  [\"oranges\", 200]\n]);\nconsole.log(fruits.get(\"apples\"));",
          output: "500"
        }
      },
      {
        q: "JS Set",
        a: "A Set is a collection of unique values. Each value can only occur once in a Set. A Set can hold any value of any data type.",
        example: {
          title: "Using Set",
          code: "const letters = new Set([\"a\",\"b\",\"c\",\"c\",\"b\"]);\nconsole.log(letters.size);",
          output: "3"
        }
      },
      {
        q: "JS Errors (Try/Catch)",
        a: "The try statement lets you test a block of code for errors. The catch statement lets you handle the error. The throw statement lets you create custom errors. The finally statement lets you execute code, after try and catch, regardless of the result.",
        example: {
          title: "Error Handling",
          code: "try {\n  nonExistentFunction();\n} catch (err) {\n  console.log(err.name);\n}",
          output: "ReferenceError"
        }
      },
      {
        q: "JS Strict Mode",
        a: "Strict mode is declared by adding 'use strict'; to the beginning of a script or a function. It executes the code in a 'strict' operating context, preventing certain actions from being taken and throwing more exceptions.",
        example: {
          title: "Strict Mode",
          code: "\"use strict\";\ntry {\n  x = 3.14; // This will cause an error because x is not declared\n} catch (err) {\n  console.log(\"Error caught\");\n}",
          output: "Error caught"
        }
      },
      {
        q: "JS Closure",
        a: "A closure is a function having access to the parent scope, even after the parent function has closed. It makes it possible for a function to have 'private' variables.",
        example: {
          title: "Closure Example",
          code: "const add = (function () {\n  let counter = 0;\n  return function () {counter += 1; return counter}\n})();\n\nconsole.log(add());\nconsole.log(add());",
          output: "1\n2"
        }
      },
      {
        q: "JS Hoisting",
        a: "Hoisting is JavaScript's default behavior of moving declarations to the top. Variables defined with let and const are hoisted to the top of the block, but not initialized.",
        example: {
          title: "Hoisting Example",
          code: "x = 5;\nconsole.log(x);\nvar x;",
          output: "5"
        }
      },
      {
        q: "JS Array Map/Filter/Reduce",
        a: "The map() method creates a new array by performing a function on each array element. The filter() method creates a new array with array elements that pass a test. The reduce() method runs a function on each array element to produce a single value.",
        example: {
          title: "Array Higher-Order Functions",
          code: "const numbers = [45, 4, 9, 16, 25];\nconst over18 = numbers.filter(value => value > 18);\nconsole.log(over18);",
          output: "[ 45, 25 ]"
        }
      },
      {
        q: "JS Event Loop",
        a: "The Event Loop is a queue of callback functions. When an async function executes, the callback function is pushed into the queue. The JavaScript engine doesn't start processing the event loop until the code after an async function has executed.",
        example: {
          title: "Event Loop Concept",
          code: "console.log(\"Start\");\nsetTimeout(() => console.log(\"Callback\"), 0);\nconsole.log(\"End\");",
          output: "Start\nEnd\nCallback"
        }
      },
      {
        q: "JS DOM Elements",
        a: "Finding HTML elements in the DOM: document.getElementById(id), document.getElementsByTagName(name), document.getElementsByClassName(name), document.querySelector().",
        example: {
          title: "DOM Query",
          code: "// const myElement = document.getElementById(\"demo\");\nconsole.log(\"Used to select DOM elements.\");",
          output: "Used to select DOM elements."
        }
      },
      {
        q: "JS Events",
        a: "HTML events are \"things\" that happen to HTML elements. When JavaScript is used in HTML pages, JavaScript can \"react\" on these events. Examples: onclick, onchange, onmouseover.",
        example: {
          title: "Event Listener",
          code: "// element.addEventListener(\"click\", myFunction);\nconsole.log(\"Attaches an event handler to an element.\");",
          output: "Attaches an event handler to an element."
        }
      },
      {
        q: "JS Fetch API",
        a: "The Fetch API provides a JavaScript interface for accessing and manipulating parts of the protocol, such as requests and responses. It provides a global fetch() method that provides an easy, logical way to fetch resources asynchronously across the network.",
        example: {
          title: "Fetching Data",
          code: "// fetch('https://api.example.com/data')\n//   .then(response => response.json())\n//   .then(data => console.log(data));\nconsole.log(\"Modern alternative to XMLHttpRequest.\");",
          output: "Modern alternative to XMLHttpRequest."
        }
      }

    ]
  },
  "javascript-programs": {
    "title": "JS Programs",
    "description": "A collection of basic to advanced JavaScript programs to practice coding.",
    "qa": [
      {
        "category": "Introduction",
        "q": "JavaScript Program To Print Hello World",
        "a": "A \"Hello, World!\" is a simple program that prints Hello, World! on the screen. Since it's a very simple program, this program is often used to introduce a new programming language to beginners.\n\nWe will use these three ways to print 'Hello, World!'.\n\n* `console.log()`\n* `alert()`\n* `document.write()`\n\n### 1. Using console.log()\n`console.log()` is used in debugging the code.\n\n**Source Code**\n\n```javascript\n// the hello world program\nconsole.log('Hello World');\n```\n\n**Output**\n```\nHello, World!\n```\n\nHere, the first line is a comment.\n\n```javascript\n// the hello world program\n```\n\nThe second line\n\n```javascript\nconsole.log('Hello, World!');\n```\nprints the 'Hello, World!' string to the console.\n\n### 2. Using alert()\nThe `alert()` method displays an alert box over the current window with the specified message.\n\n**Source Code**\n\n```javascript\n// the hello world program\nalert(\"Hello, World!\");\n```\n\n### 3. Using document.write()\n`document.write()` is used when you want to print the content to the HTML document.\n\n**Source Code**\n\n```javascript\n// the hello world program\ndocument.write('Hello, World!');\n```\n",
        "example": {
          "title": "Hello World in JS",
          "code": "console.log(\"Hello World!\");",
          "output": "Hello World!"
        }
      },
      {
        "category": "Introduction",
        "q": "JavaScript Program to Add Two Numbers",
        "a": "You can add two numbers in JavaScript using the + operator.",
        "example": {
          "title": "Adding Two Numbers",
          "code": "const num1 = 5;\nconst num2 = 10;\nconst sum = num1 + num2;\n\nconsole.log(\"The sum is: \" + sum);",
          "output": "The sum is: 15"
        }
      },
      {
        "category": "Introduction",
        "q": "JavaScript Program to Find the Square Root",
        "a": "To find the square root of a number in JavaScript, you can use the built-in Math.sqrt() method.",
        "example": {
          "title": "Finding Square Root",
          "code": "const number = 16;\nconst result = Math.sqrt(number);\n\nconsole.log(\"The square root of \" + number + \" is \" + result);",
          "output": "The square root of 16 is 4"
        }
      },
      {
        "category": "Introduction",
        "q": "JavaScript Program to Calculate the Area of a Triangle",
        "a": "The area of a triangle can be calculated using the formula: (base * height) / 2.",
        "example": {
          "title": "Area of a Triangle",
          "code": "const base = 10;\nconst height = 5;\nconst area = (base * height) / 2;\n\nconsole.log(\"The area of the triangle is \" + area);",
          "output": "The area of the triangle is 25"
        }
      },
      {
        "category": "Introduction",
        "q": "JavaScript Program to Swap Two Variables",
        "a": "You can swap the values of two variables using a temporary variable, or using array destructuring in modern JavaScript.",
        "example": {
          "title": "Swapping Variables using Destructuring",
          "code": "let a = 1;\nlet b = 2;\n\nconsole.log(\"Before: a=\" + a + \", b=\" + b);\n\n[a, b] = [b, a];\n\nconsole.log(\"After: a=\" + a + \", b=\" + b);",
          "output": "Before: a=1, b=2\nAfter: a=2, b=1"
        }
      },
      {
        "category": "Control Flow",
        "q": "JavaScript Program to Solve Quadratic Equation",
        "a": "A quadratic equation is in the form ax^2 + bx + c = 0. The roots can be found using the quadratic formula.",
        "example": {
          "title": "Quadratic Equation Roots",
          "code": "let root1, root2;\nlet a = 1, b = -3, c = 2;\nlet discriminant = b * b - 4 * a * c;\n\nif (discriminant > 0) {\n  root1 = (-b + Math.sqrt(discriminant)) / (2 * a);\n  root2 = (-b - Math.sqrt(discriminant)) / (2 * a);\n  console.log(\"Roots are \" + root1 + \" and \" + root2);\n} else if (discriminant == 0) {\n  root1 = root2 = -b / (2 * a);\n  console.log(\"Roots are \" + root1 + \" and \" + root2);\n}",
          "output": "Roots are 2 and 1"
        }
      },
      {
        "category": "Introduction",
        "q": "JavaScript Program to Convert Kilometers to Miles",
        "a": "To convert kilometers to miles, you multiply the kilometers by the conversion factor 0.621371.",
        "example": {
          "title": "KM to Miles",
          "code": "const kilometers = 10;\nconst factor = 0.621371;\nconst miles = kilometers * factor;\n\nconsole.log(kilometers + \" kilometers is equal to \" + miles + \" miles.\");",
          "output": "10 kilometers is equal to 6.21371 miles."
        }
      },
      {
        "category": "Introduction",
        "q": "Javascript Program to Convert Celsius to Fahrenheit",
        "a": "You can convert Celsius to Fahrenheit using the formula: (Celsius * 9/5) + 32.",
        "example": {
          "title": "Celsius to Fahrenheit",
          "code": "const celsius = 30;\nconst fahrenheit = (celsius * 9/5) + 32;\n\nconsole.log(celsius + \" degree celsius is equal to \" + fahrenheit + \" degree fahrenheit.\");",
          "output": "30 degree celsius is equal to 86 degree fahrenheit."
        }
      }
    
      ,{
        "category": "Functions",
        "q": "Javascript Program to Generate a Random Number",
        "a": "This is a placeholder for the explanation of 'Javascript Program to Generate a Random Number'.",
        "example": {
          "title": "Javascript Program to Generate a Random Number",
          "code": "// TODO: Implement Javascript Program to Generate a Random Number\nconsole.log('Output for Javascript Program to Generate a Random Number');",
          "output": "Output for Javascript Program to Generate a Random Number"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "Javascript Program to Check if a number is Positive, Negative, or Zero",
        "a": "This is a placeholder for the explanation of 'Javascript Program to Check if a number is Positive, Negative, or Zero'.",
        "example": {
          "title": "Javascript Program to Check if a number is Positive, Negative, or Zero",
          "code": "// TODO: Implement Javascript Program to Check if a number is Positive, Negative, or Zero\nconsole.log('Output for Javascript Program to Check if a number is Positive, Negative, or Zero');",
          "output": "Output for Javascript Program to Check if a number is Positive, Negative, or Zero"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "Javascript Program to Check if a Number is Odd or Even",
        "a": "This is a placeholder for the explanation of 'Javascript Program to Check if a Number is Odd or Even'.",
        "example": {
          "title": "Javascript Program to Check if a Number is Odd or Even",
          "code": "// TODO: Implement Javascript Program to Check if a Number is Odd or Even\nconsole.log('Output for Javascript Program to Check if a Number is Odd or Even');",
          "output": "Output for Javascript Program to Check if a Number is Odd or Even"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Find the Largest Among Three Numbers",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find the Largest Among Three Numbers'.",
        "example": {
          "title": "JavaScript Program to Find the Largest Among Three Numbers",
          "code": "// TODO: Implement JavaScript Program to Find the Largest Among Three Numbers\nconsole.log('Output for JavaScript Program to Find the Largest Among Three Numbers');",
          "output": "Output for JavaScript Program to Find the Largest Among Three Numbers"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Check Prime Number",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check Prime Number'.",
        "example": {
          "title": "JavaScript Program to Check Prime Number",
          "code": "// TODO: Implement JavaScript Program to Check Prime Number\nconsole.log('Output for JavaScript Program to Check Prime Number');",
          "output": "Output for JavaScript Program to Check Prime Number"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Print All Prime Numbers in an Interval",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Print All Prime Numbers in an Interval'.",
        "example": {
          "title": "JavaScript Program to Print All Prime Numbers in an Interval",
          "code": "// TODO: Implement JavaScript Program to Print All Prime Numbers in an Interval\nconsole.log('Output for JavaScript Program to Print All Prime Numbers in an Interval');",
          "output": "Output for JavaScript Program to Print All Prime Numbers in an Interval"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Find the Factorial of a Number",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find the Factorial of a Number'.",
        "example": {
          "title": "JavaScript Program to Find the Factorial of a Number",
          "code": "// TODO: Implement JavaScript Program to Find the Factorial of a Number\nconsole.log('Output for JavaScript Program to Find the Factorial of a Number');",
          "output": "Output for JavaScript Program to Find the Factorial of a Number"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Display the Multiplication Table",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Display the Multiplication Table'.",
        "example": {
          "title": "JavaScript Program to Display the Multiplication Table",
          "code": "// TODO: Implement JavaScript Program to Display the Multiplication Table\nconsole.log('Output for JavaScript Program to Display the Multiplication Table');",
          "output": "Output for JavaScript Program to Display the Multiplication Table"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Print the Fibonacci Sequence",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Print the Fibonacci Sequence'.",
        "example": {
          "title": "JavaScript Program to Print the Fibonacci Sequence",
          "code": "// TODO: Implement JavaScript Program to Print the Fibonacci Sequence\nconsole.log('Output for JavaScript Program to Print the Fibonacci Sequence');",
          "output": "Output for JavaScript Program to Print the Fibonacci Sequence"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Check Armstrong Number",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check Armstrong Number'.",
        "example": {
          "title": "JavaScript Program to Check Armstrong Number",
          "code": "// TODO: Implement JavaScript Program to Check Armstrong Number\nconsole.log('Output for JavaScript Program to Check Armstrong Number');",
          "output": "Output for JavaScript Program to Check Armstrong Number"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Find Armstrong Number in an Interval",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find Armstrong Number in an Interval'.",
        "example": {
          "title": "JavaScript Program to Find Armstrong Number in an Interval",
          "code": "// TODO: Implement JavaScript Program to Find Armstrong Number in an Interval\nconsole.log('Output for JavaScript Program to Find Armstrong Number in an Interval');",
          "output": "Output for JavaScript Program to Find Armstrong Number in an Interval"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Make a Simple Calculator",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Make a Simple Calculator'.",
        "example": {
          "title": "JavaScript Program to Make a Simple Calculator",
          "code": "// TODO: Implement JavaScript Program to Make a Simple Calculator\nconsole.log('Output for JavaScript Program to Make a Simple Calculator');",
          "output": "Output for JavaScript Program to Make a Simple Calculator"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Find the Sum of Natural Numbers",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find the Sum of Natural Numbers'.",
        "example": {
          "title": "JavaScript Program to Find the Sum of Natural Numbers",
          "code": "// TODO: Implement JavaScript Program to Find the Sum of Natural Numbers\nconsole.log('Output for JavaScript Program to Find the Sum of Natural Numbers');",
          "output": "Output for JavaScript Program to Find the Sum of Natural Numbers"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Check if the Numbers Have Same Last Digit",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check if the Numbers Have Same Last Digit'.",
        "example": {
          "title": "JavaScript Program to Check if the Numbers Have Same Last Digit",
          "code": "// TODO: Implement JavaScript Program to Check if the Numbers Have Same Last Digit\nconsole.log('Output for JavaScript Program to Check if the Numbers Have Same Last Digit');",
          "output": "Output for JavaScript Program to Check if the Numbers Have Same Last Digit"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Find HCF or GCD",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find HCF or GCD'.",
        "example": {
          "title": "JavaScript Program to Find HCF or GCD",
          "code": "// TODO: Implement JavaScript Program to Find HCF or GCD\nconsole.log('Output for JavaScript Program to Find HCF or GCD');",
          "output": "Output for JavaScript Program to Find HCF or GCD"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Find LCM",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find LCM'.",
        "example": {
          "title": "JavaScript Program to Find LCM",
          "code": "// TODO: Implement JavaScript Program to Find LCM\nconsole.log('Output for JavaScript Program to Find LCM');",
          "output": "Output for JavaScript Program to Find LCM"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Find the Factors of a Number",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find the Factors of a Number'.",
        "example": {
          "title": "JavaScript Program to Find the Factors of a Number",
          "code": "// TODO: Implement JavaScript Program to Find the Factors of a Number\nconsole.log('Output for JavaScript Program to Find the Factors of a Number');",
          "output": "Output for JavaScript Program to Find the Factors of a Number"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Find Sum of Natural Numbers Using Recursion",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find Sum of Natural Numbers Using Recursion'.",
        "example": {
          "title": "JavaScript Program to Find Sum of Natural Numbers Using Recursion",
          "code": "// TODO: Implement JavaScript Program to Find Sum of Natural Numbers Using Recursion\nconsole.log('Output for JavaScript Program to Find Sum of Natural Numbers Using Recursion');",
          "output": "Output for JavaScript Program to Find Sum of Natural Numbers Using Recursion"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Guess a Random Number",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Guess a Random Number'.",
        "example": {
          "title": "JavaScript Program to Guess a Random Number",
          "code": "// TODO: Implement JavaScript Program to Guess a Random Number\nconsole.log('Output for JavaScript Program to Guess a Random Number');",
          "output": "Output for JavaScript Program to Guess a Random Number"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Shuffle Deck of Cards",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Shuffle Deck of Cards'.",
        "example": {
          "title": "JavaScript Program to Shuffle Deck of Cards",
          "code": "// TODO: Implement JavaScript Program to Shuffle Deck of Cards\nconsole.log('Output for JavaScript Program to Shuffle Deck of Cards');",
          "output": "Output for JavaScript Program to Shuffle Deck of Cards"
        }
      }
      ,{
        "category": "Control Flow",
        "q": "JavaScript Program to Display Fibonacci Sequence Using Recursion",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Display Fibonacci Sequence Using Recursion'.",
        "example": {
          "title": "JavaScript Program to Display Fibonacci Sequence Using Recursion",
          "code": "// TODO: Implement JavaScript Program to Display Fibonacci Sequence Using Recursion\nconsole.log('Output for JavaScript Program to Display Fibonacci Sequence Using Recursion');",
          "output": "Output for JavaScript Program to Display Fibonacci Sequence Using Recursion"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Find Factorial of Number Using Recursion",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find Factorial of Number Using Recursion'.",
        "example": {
          "title": "JavaScript Program to Find Factorial of Number Using Recursion",
          "code": "// TODO: Implement JavaScript Program to Find Factorial of Number Using Recursion\nconsole.log('Output for JavaScript Program to Find Factorial of Number Using Recursion');",
          "output": "Output for JavaScript Program to Find Factorial of Number Using Recursion"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Convert Decimal to Binary",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Convert Decimal to Binary'.",
        "example": {
          "title": "JavaScript Program to Convert Decimal to Binary",
          "code": "// TODO: Implement JavaScript Program to Convert Decimal to Binary\nconsole.log('Output for JavaScript Program to Convert Decimal to Binary');",
          "output": "Output for JavaScript Program to Convert Decimal to Binary"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Find ASCII Value of Character",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Find ASCII Value of Character'.",
        "example": {
          "title": "JavaScript Program to Find ASCII Value of Character",
          "code": "// TODO: Implement JavaScript Program to Find ASCII Value of Character\nconsole.log('Output for JavaScript Program to Find ASCII Value of Character');",
          "output": "Output for JavaScript Program to Find ASCII Value of Character"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Check Whether a String is Palindrome or Not",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check Whether a String is Palindrome or Not'.",
        "example": {
          "title": "JavaScript Program to Check Whether a String is Palindrome or Not",
          "code": "// TODO: Implement JavaScript Program to Check Whether a String is Palindrome or Not\nconsole.log('Output for JavaScript Program to Check Whether a String is Palindrome or Not');",
          "output": "Output for JavaScript Program to Check Whether a String is Palindrome or Not"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Sort Words in Alphabetical Order",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Sort Words in Alphabetical Order'.",
        "example": {
          "title": "JavaScript Program to Sort Words in Alphabetical Order",
          "code": "// TODO: Implement JavaScript Program to Sort Words in Alphabetical Order\nconsole.log('Output for JavaScript Program to Sort Words in Alphabetical Order');",
          "output": "Output for JavaScript Program to Sort Words in Alphabetical Order"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Replace Characters of a String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Replace Characters of a String'.",
        "example": {
          "title": "JavaScript Program to Replace Characters of a String",
          "code": "// TODO: Implement JavaScript Program to Replace Characters of a String\nconsole.log('Output for JavaScript Program to Replace Characters of a String');",
          "output": "Output for JavaScript Program to Replace Characters of a String"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Reverse a String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Reverse a String'.",
        "example": {
          "title": "JavaScript Program to Reverse a String",
          "code": "// TODO: Implement JavaScript Program to Reverse a String\nconsole.log('Output for JavaScript Program to Reverse a String');",
          "output": "Output for JavaScript Program to Reverse a String"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Create Objects in Different Ways",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Create Objects in Different Ways'.",
        "example": {
          "title": "JavaScript Program to Create Objects in Different Ways",
          "code": "// TODO: Implement JavaScript Program to Create Objects in Different Ways\nconsole.log('Output for JavaScript Program to Create Objects in Different Ways');",
          "output": "Output for JavaScript Program to Create Objects in Different Ways"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Check the Number of Occurrences of a Character in the String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check the Number of Occurrences of a Character in the String'.",
        "example": {
          "title": "JavaScript Program to Check the Number of Occurrences of a Character in the String",
          "code": "// TODO: Implement JavaScript Program to Check the Number of Occurrences of a Character in the String\nconsole.log('Output for JavaScript Program to Check the Number of Occurrences of a Character in the String');",
          "output": "Output for JavaScript Program to Check the Number of Occurrences of a Character in the String"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Convert the First Letter of a String into UpperCase",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Convert the First Letter of a String into UpperCase'.",
        "example": {
          "title": "JavaScript Program to Convert the First Letter of a String into UpperCase",
          "code": "// TODO: Implement JavaScript Program to Convert the First Letter of a String into UpperCase\nconsole.log('Output for JavaScript Program to Convert the First Letter of a String into UpperCase');",
          "output": "Output for JavaScript Program to Convert the First Letter of a String into UpperCase"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Count the Number of Vowels in a String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Count the Number of Vowels in a String'.",
        "example": {
          "title": "JavaScript Program to Count the Number of Vowels in a String",
          "code": "// TODO: Implement JavaScript Program to Count the Number of Vowels in a String\nconsole.log('Output for JavaScript Program to Count the Number of Vowels in a String');",
          "output": "Output for JavaScript Program to Count the Number of Vowels in a String"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Remove a Property from an Object",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Remove a Property from an Object'.",
        "example": {
          "title": "JavaScript Program to Remove a Property from an Object",
          "code": "// TODO: Implement JavaScript Program to Remove a Property from an Object\nconsole.log('Output for JavaScript Program to Remove a Property from an Object');",
          "output": "Output for JavaScript Program to Remove a Property from an Object"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Check Whether a String Starts and Ends With Certain Characters",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check Whether a String Starts and Ends With Certain Characters'.",
        "example": {
          "title": "JavaScript Program to Check Whether a String Starts and Ends With Certain Characters",
          "code": "// TODO: Implement JavaScript Program to Check Whether a String Starts and Ends With Certain Characters\nconsole.log('Output for JavaScript Program to Check Whether a String Starts and Ends With Certain Characters');",
          "output": "Output for JavaScript Program to Check Whether a String Starts and Ends With Certain Characters"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Check if a Key Exists in an Object",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check if a Key Exists in an Object'.",
        "example": {
          "title": "JavaScript Program to Check if a Key Exists in an Object",
          "code": "// TODO: Implement JavaScript Program to Check if a Key Exists in an Object\nconsole.log('Output for JavaScript Program to Check if a Key Exists in an Object');",
          "output": "Output for JavaScript Program to Check if a Key Exists in an Object"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Clone a JS Object",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Clone a JS Object'.",
        "example": {
          "title": "JavaScript Program to Clone a JS Object",
          "code": "// TODO: Implement JavaScript Program to Clone a JS Object\nconsole.log('Output for JavaScript Program to Clone a JS Object');",
          "output": "Output for JavaScript Program to Clone a JS Object"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Loop Through an Object",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Loop Through an Object'.",
        "example": {
          "title": "JavaScript Program to Loop Through an Object",
          "code": "// TODO: Implement JavaScript Program to Loop Through an Object\nconsole.log('Output for JavaScript Program to Loop Through an Object');",
          "output": "Output for JavaScript Program to Loop Through an Object"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Merge Property of Two Objects",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Merge Property of Two Objects'.",
        "example": {
          "title": "JavaScript Program to Merge Property of Two Objects",
          "code": "// TODO: Implement JavaScript Program to Merge Property of Two Objects\nconsole.log('Output for JavaScript Program to Merge Property of Two Objects');",
          "output": "Output for JavaScript Program to Merge Property of Two Objects"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Count the Number of Keys/Properties in an Object",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Count the Number of Keys/Properties in an Object'.",
        "example": {
          "title": "JavaScript Program to Count the Number of Keys/Properties in an Object",
          "code": "// TODO: Implement JavaScript Program to Count the Number of Keys/Properties in an Object\nconsole.log('Output for JavaScript Program to Count the Number of Keys/Properties in an Object');",
          "output": "Output for JavaScript Program to Count the Number of Keys/Properties in an Object"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Add Key/Value Pair to an Object",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Add Key/Value Pair to an Object'.",
        "example": {
          "title": "JavaScript Program to Add Key/Value Pair to an Object",
          "code": "// TODO: Implement JavaScript Program to Add Key/Value Pair to an Object\nconsole.log('Output for JavaScript Program to Add Key/Value Pair to an Object');",
          "output": "Output for JavaScript Program to Add Key/Value Pair to an Object"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Replace All Occurrences of a String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Replace All Occurrences of a String'.",
        "example": {
          "title": "JavaScript Program to Replace All Occurrences of a String",
          "code": "// TODO: Implement JavaScript Program to Replace All Occurrences of a String\nconsole.log('Output for JavaScript Program to Replace All Occurrences of a String');",
          "output": "Output for JavaScript Program to Replace All Occurrences of a String"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Create Multiline Strings",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Create Multiline Strings'.",
        "example": {
          "title": "JavaScript Program to Create Multiline Strings",
          "code": "// TODO: Implement JavaScript Program to Create Multiline Strings\nconsole.log('Output for JavaScript Program to Create Multiline Strings');",
          "output": "Output for JavaScript Program to Create Multiline Strings"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Format Numbers as Currency Strings",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Format Numbers as Currency Strings'.",
        "example": {
          "title": "JavaScript Program to Format Numbers as Currency Strings",
          "code": "// TODO: Implement JavaScript Program to Format Numbers as Currency Strings\nconsole.log('Output for JavaScript Program to Format Numbers as Currency Strings');",
          "output": "Output for JavaScript Program to Format Numbers as Currency Strings"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Generate Random String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Generate Random String'.",
        "example": {
          "title": "JavaScript Program to Generate Random String",
          "code": "// TODO: Implement JavaScript Program to Generate Random String\nconsole.log('Output for JavaScript Program to Generate Random String');",
          "output": "Output for JavaScript Program to Generate Random String"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Check if a String Starts With Another String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check if a String Starts With Another String'.",
        "example": {
          "title": "JavaScript Program to Check if a String Starts With Another String",
          "code": "// TODO: Implement JavaScript Program to Check if a String Starts With Another String\nconsole.log('Output for JavaScript Program to Check if a String Starts With Another String');",
          "output": "Output for JavaScript Program to Check if a String Starts With Another String"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Trim a String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Trim a String'.",
        "example": {
          "title": "JavaScript Program to Trim a String",
          "code": "// TODO: Implement JavaScript Program to Trim a String\nconsole.log('Output for JavaScript Program to Trim a String');",
          "output": "Output for JavaScript Program to Trim a String"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Convert Objects to Strings",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Convert Objects to Strings'.",
        "example": {
          "title": "JavaScript Program to Convert Objects to Strings",
          "code": "// TODO: Implement JavaScript Program to Convert Objects to Strings\nconsole.log('Output for JavaScript Program to Convert Objects to Strings');",
          "output": "Output for JavaScript Program to Convert Objects to Strings"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Check Whether a String Contains a Substring",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check Whether a String Contains a Substring'.",
        "example": {
          "title": "JavaScript Program to Check Whether a String Contains a Substring",
          "code": "// TODO: Implement JavaScript Program to Check Whether a String Contains a Substring\nconsole.log('Output for JavaScript Program to Check Whether a String Contains a Substring');",
          "output": "Output for JavaScript Program to Check Whether a String Contains a Substring"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Compare Two Strings",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Compare Two Strings'.",
        "example": {
          "title": "JavaScript Program to Compare Two Strings",
          "code": "// TODO: Implement JavaScript Program to Compare Two Strings\nconsole.log('Output for JavaScript Program to Compare Two Strings');",
          "output": "Output for JavaScript Program to Compare Two Strings"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Encode a String to Base64",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Encode a String to Base64'.",
        "example": {
          "title": "JavaScript Program to Encode a String to Base64",
          "code": "// TODO: Implement JavaScript Program to Encode a String to Base64\nconsole.log('Output for JavaScript Program to Encode a String to Base64');",
          "output": "Output for JavaScript Program to Encode a String to Base64"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Replace all Instances of a Character in a String",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Replace all Instances of a Character in a String'.",
        "example": {
          "title": "JavaScript Program to Replace all Instances of a Character in a String",
          "code": "// TODO: Implement JavaScript Program to Replace all Instances of a Character in a String\nconsole.log('Output for JavaScript Program to Replace all Instances of a Character in a String');",
          "output": "Output for JavaScript Program to Replace all Instances of a Character in a String"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Replace All Line Breaks with",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Replace All Line Breaks with'.",
        "example": {
          "title": "JavaScript Program to Replace All Line Breaks with",
          "code": "// TODO: Implement JavaScript Program to Replace All Line Breaks with\nconsole.log('Output for JavaScript Program to Replace All Line Breaks with');",
          "output": "Output for JavaScript Program to Replace All Line Breaks with"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Display Date and Time",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Display Date and Time'.",
        "example": {
          "title": "JavaScript Program to Display Date and Time",
          "code": "// TODO: Implement JavaScript Program to Display Date and Time\nconsole.log('Output for JavaScript Program to Display Date and Time');",
          "output": "Output for JavaScript Program to Display Date and Time"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Check Leap Year",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check Leap Year'.",
        "example": {
          "title": "JavaScript Program to Check Leap Year",
          "code": "// TODO: Implement JavaScript Program to Check Leap Year\nconsole.log('Output for JavaScript Program to Check Leap Year');",
          "output": "Output for JavaScript Program to Check Leap Year"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Format the Date",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Format the Date'.",
        "example": {
          "title": "JavaScript Program to Format the Date",
          "code": "// TODO: Implement JavaScript Program to Format the Date\nconsole.log('Output for JavaScript Program to Format the Date');",
          "output": "Output for JavaScript Program to Format the Date"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "Javascript Program to Display Current Date",
        "a": "This is a placeholder for the explanation of 'Javascript Program to Display Current Date'.",
        "example": {
          "title": "Javascript Program to Display Current Date",
          "code": "// TODO: Implement Javascript Program to Display Current Date\nconsole.log('Output for Javascript Program to Display Current Date');",
          "output": "Output for Javascript Program to Display Current Date"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Compare The Value of Two Dates",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Compare The Value of Two Dates'.",
        "example": {
          "title": "JavaScript Program to Compare The Value of Two Dates",
          "code": "// TODO: Implement JavaScript Program to Compare The Value of Two Dates\nconsole.log('Output for JavaScript Program to Compare The Value of Two Dates');",
          "output": "Output for JavaScript Program to Compare The Value of Two Dates"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Create Countdown Timer",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Create Countdown Timer'.",
        "example": {
          "title": "JavaScript Program to Create Countdown Timer",
          "code": "// TODO: Implement JavaScript Program to Create Countdown Timer\nconsole.log('Output for JavaScript Program to Create Countdown Timer');",
          "output": "Output for JavaScript Program to Create Countdown Timer"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Remove Specific Item From an Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Remove Specific Item From an Array'.",
        "example": {
          "title": "JavaScript Program to Remove Specific Item From an Array",
          "code": "// TODO: Implement JavaScript Program to Remove Specific Item From an Array\nconsole.log('Output for JavaScript Program to Remove Specific Item From an Array');",
          "output": "Output for JavaScript Program to Remove Specific Item From an Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Check if An Array Contains a Specified Value",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check if An Array Contains a Specified Value'.",
        "example": {
          "title": "JavaScript Program to Check if An Array Contains a Specified Value",
          "code": "// TODO: Implement JavaScript Program to Check if An Array Contains a Specified Value\nconsole.log('Output for JavaScript Program to Check if An Array Contains a Specified Value');",
          "output": "Output for JavaScript Program to Check if An Array Contains a Specified Value"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Insert Item in an Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Insert Item in an Array'.",
        "example": {
          "title": "JavaScript Program to Insert Item in an Array",
          "code": "// TODO: Implement JavaScript Program to Insert Item in an Array\nconsole.log('Output for JavaScript Program to Insert Item in an Array');",
          "output": "Output for JavaScript Program to Insert Item in an Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Append an Object to an Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Append an Object to an Array'.",
        "example": {
          "title": "JavaScript Program to Append an Object to an Array",
          "code": "// TODO: Implement JavaScript Program to Append an Object to an Array\nconsole.log('Output for JavaScript Program to Append an Object to an Array');",
          "output": "Output for JavaScript Program to Append an Object to an Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Check if An Object is An Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check if An Object is An Array'.",
        "example": {
          "title": "JavaScript Program to Check if An Object is An Array",
          "code": "// TODO: Implement JavaScript Program to Check if An Object is An Array\nconsole.log('Output for JavaScript Program to Check if An Object is An Array');",
          "output": "Output for JavaScript Program to Check if An Object is An Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Empty an Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Empty an Array'.",
        "example": {
          "title": "JavaScript Program to Empty an Array",
          "code": "// TODO: Implement JavaScript Program to Empty an Array\nconsole.log('Output for JavaScript Program to Empty an Array');",
          "output": "Output for JavaScript Program to Empty an Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Add Element to Start of an Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Add Element to Start of an Array'.",
        "example": {
          "title": "JavaScript Program to Add Element to Start of an Array",
          "code": "// TODO: Implement JavaScript Program to Add Element to Start of an Array\nconsole.log('Output for JavaScript Program to Add Element to Start of an Array');",
          "output": "Output for JavaScript Program to Add Element to Start of an Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Remove Duplicates From Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Remove Duplicates From Array'.",
        "example": {
          "title": "JavaScript Program to Remove Duplicates From Array",
          "code": "// TODO: Implement JavaScript Program to Remove Duplicates From Array\nconsole.log('Output for JavaScript Program to Remove Duplicates From Array');",
          "output": "Output for JavaScript Program to Remove Duplicates From Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Merge Two Arrays and Remove Duplicate Items",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Merge Two Arrays and Remove Duplicate Items'.",
        "example": {
          "title": "JavaScript Program to Merge Two Arrays and Remove Duplicate Items",
          "code": "// TODO: Implement JavaScript Program to Merge Two Arrays and Remove Duplicate Items\nconsole.log('Output for JavaScript Program to Merge Two Arrays and Remove Duplicate Items');",
          "output": "Output for JavaScript Program to Merge Two Arrays and Remove Duplicate Items"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Sort Array of Objects by Property Values",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Sort Array of Objects by Property Values'.",
        "example": {
          "title": "JavaScript Program to Sort Array of Objects by Property Values",
          "code": "// TODO: Implement JavaScript Program to Sort Array of Objects by Property Values\nconsole.log('Output for JavaScript Program to Sort Array of Objects by Property Values');",
          "output": "Output for JavaScript Program to Sort Array of Objects by Property Values"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Create Two Dimensional Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Create Two Dimensional Array'.",
        "example": {
          "title": "JavaScript Program to Create Two Dimensional Array",
          "code": "// TODO: Implement JavaScript Program to Create Two Dimensional Array\nconsole.log('Output for JavaScript Program to Create Two Dimensional Array');",
          "output": "Output for JavaScript Program to Create Two Dimensional Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Extract Given Property Values from Objects as Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Extract Given Property Values from Objects as Array'.",
        "example": {
          "title": "JavaScript Program to Extract Given Property Values from Objects as Array",
          "code": "// TODO: Implement JavaScript Program to Extract Given Property Values from Objects as Array\nconsole.log('Output for JavaScript Program to Extract Given Property Values from Objects as Array');",
          "output": "Output for JavaScript Program to Extract Given Property Values from Objects as Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Compare Elements of Two Arrays",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Compare Elements of Two Arrays'.",
        "example": {
          "title": "JavaScript Program to Compare Elements of Two Arrays",
          "code": "// TODO: Implement JavaScript Program to Compare Elements of Two Arrays\nconsole.log('Output for JavaScript Program to Compare Elements of Two Arrays');",
          "output": "Output for JavaScript Program to Compare Elements of Two Arrays"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Get Random Item From an Array",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Get Random Item From an Array'.",
        "example": {
          "title": "JavaScript Program to Get Random Item From an Array",
          "code": "// TODO: Implement JavaScript Program to Get Random Item From an Array\nconsole.log('Output for JavaScript Program to Get Random Item From an Array');",
          "output": "Output for JavaScript Program to Get Random Item From an Array"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program To Perform Intersection Between Two Arrays",
        "a": "This is a placeholder for the explanation of 'JavaScript Program To Perform Intersection Between Two Arrays'.",
        "example": {
          "title": "JavaScript Program To Perform Intersection Between Two Arrays",
          "code": "// TODO: Implement JavaScript Program To Perform Intersection Between Two Arrays\nconsole.log('Output for JavaScript Program To Perform Intersection Between Two Arrays');",
          "output": "Output for JavaScript Program To Perform Intersection Between Two Arrays"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Split Array into Smaller Chunks",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Split Array into Smaller Chunks'.",
        "example": {
          "title": "JavaScript Program to Split Array into Smaller Chunks",
          "code": "// TODO: Implement JavaScript Program to Split Array into Smaller Chunks\nconsole.log('Output for JavaScript Program to Split Array into Smaller Chunks');",
          "output": "Output for JavaScript Program to Split Array into Smaller Chunks"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Include a JS file in Another JS file",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Include a JS file in Another JS file'.",
        "example": {
          "title": "JavaScript Program to Include a JS file in Another JS file",
          "code": "// TODO: Implement JavaScript Program to Include a JS file in Another JS file\nconsole.log('Output for JavaScript Program to Include a JS file in Another JS file');",
          "output": "Output for JavaScript Program to Include a JS file in Another JS file"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Get File Extension",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Get File Extension'.",
        "example": {
          "title": "JavaScript Program to Get File Extension",
          "code": "// TODO: Implement JavaScript Program to Get File Extension\nconsole.log('Output for JavaScript Program to Get File Extension');",
          "output": "Output for JavaScript Program to Get File Extension"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program To Check If A Variable Is undefined or null",
        "a": "This is a placeholder for the explanation of 'JavaScript Program To Check If A Variable Is undefined or null'.",
        "example": {
          "title": "JavaScript Program To Check If A Variable Is undefined or null",
          "code": "// TODO: Implement JavaScript Program To Check If A Variable Is undefined or null\nconsole.log('Output for JavaScript Program To Check If A Variable Is undefined or null');",
          "output": "Output for JavaScript Program To Check If A Variable Is undefined or null"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Set a Default Parameter Value For a Function",
        "a": "You can pass default parameters to a JavaScript function. In this example, if no value is passed for x or y, they default to 3 and 5 respectively.",
        "example": {
          "title": "JavaScript Program to Set a Default Parameter Value For a Function",
          "code": "function sum(x = 3, y = 5) {\n    // return sum\n    return x + y;\n}\n\nconsole.log(sum(5, 15));\nconsole.log(sum(7));\nconsole.log(sum());",
          "output": "20\n12\n8"
        }
      }
      ,{
        "category": "Arrays and Objects",
        "q": "JavaScript Program to Illustrate Different Set Operations",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Illustrate Different Set Operations'.",
        "example": {
          "title": "JavaScript Program to Illustrate Different Set Operations",
          "code": "// TODO: Implement JavaScript Program to Illustrate Different Set Operations\nconsole.log('Output for JavaScript Program to Illustrate Different Set Operations');",
          "output": "Output for JavaScript Program to Illustrate Different Set Operations"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "Javascript Program to Generate a Random Number Between Two Numbers",
        "a": "This is a placeholder for the explanation of 'Javascript Program to Generate a Random Number Between Two Numbers'.",
        "example": {
          "title": "Javascript Program to Generate a Random Number Between Two Numbers",
          "code": "// TODO: Implement Javascript Program to Generate a Random Number Between Two Numbers\nconsole.log('Output for Javascript Program to Generate a Random Number Between Two Numbers');",
          "output": "Output for Javascript Program to Generate a Random Number Between Two Numbers"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program To Get The Current URL",
        "a": "This is a placeholder for the explanation of 'JavaScript Program To Get The Current URL'.",
        "example": {
          "title": "JavaScript Program To Get The Current URL",
          "code": "// TODO: Implement JavaScript Program To Get The Current URL\nconsole.log('Output for JavaScript Program To Get The Current URL');",
          "output": "Output for JavaScript Program To Get The Current URL"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Validate An Email Address",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Validate An Email Address'.",
        "example": {
          "title": "JavaScript Program to Validate An Email Address",
          "code": "// TODO: Implement JavaScript Program to Validate An Email Address\nconsole.log('Output for JavaScript Program to Validate An Email Address');",
          "output": "Output for JavaScript Program to Validate An Email Address"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Check If a Variable is of Function Type",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check If a Variable is of Function Type'.",
        "example": {
          "title": "JavaScript Program to Check If a Variable is of Function Type",
          "code": "// TODO: Implement JavaScript Program to Check If a Variable is of Function Type\nconsole.log('Output for JavaScript Program to Check If a Variable is of Function Type');",
          "output": "Output for JavaScript Program to Check If a Variable is of Function Type"
        }
      }
      ,{
        "category": "Introduction",
        "q": "JavaScript Program To Work With Constants",
        "a": "This is a placeholder for the explanation of 'JavaScript Program To Work With Constants'.",
        "example": {
          "title": "JavaScript Program To Work With Constants",
          "code": "// TODO: Implement JavaScript Program To Work With Constants\nconsole.log('Output for JavaScript Program To Work With Constants');",
          "output": "Output for JavaScript Program To Work With Constants"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Pass Parameter to a setTimeout() Function",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Pass Parameter to a setTimeout() Function'.",
        "example": {
          "title": "JavaScript Program to Pass Parameter to a setTimeout() Function",
          "code": "// TODO: Implement JavaScript Program to Pass Parameter to a setTimeout() Function\nconsole.log('Output for JavaScript Program to Pass Parameter to a setTimeout() Function');",
          "output": "Output for JavaScript Program to Pass Parameter to a setTimeout() Function"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Generate a Range of Numbers and Characters",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Generate a Range of Numbers and Characters'.",
        "example": {
          "title": "JavaScript Program to Generate a Range of Numbers and Characters",
          "code": "// TODO: Implement JavaScript Program to Generate a Range of Numbers and Characters\nconsole.log('Output for JavaScript Program to Generate a Range of Numbers and Characters');",
          "output": "Output for JavaScript Program to Generate a Range of Numbers and Characters"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Perform Function Overloading",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Perform Function Overloading'.",
        "example": {
          "title": "JavaScript Program to Perform Function Overloading",
          "code": "// TODO: Implement JavaScript Program to Perform Function Overloading\nconsole.log('Output for JavaScript Program to Perform Function Overloading');",
          "output": "Output for JavaScript Program to Perform Function Overloading"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Implement a Stack",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Implement a Stack'.",
        "example": {
          "title": "JavaScript Program to Implement a Stack",
          "code": "// TODO: Implement JavaScript Program to Implement a Stack\nconsole.log('Output for JavaScript Program to Implement a Stack');",
          "output": "Output for JavaScript Program to Implement a Stack"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Implement a Queue",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Implement a Queue'.",
        "example": {
          "title": "JavaScript Program to Implement a Queue",
          "code": "// TODO: Implement JavaScript Program to Implement a Queue\nconsole.log('Output for JavaScript Program to Implement a Queue');",
          "output": "Output for JavaScript Program to Implement a Queue"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Check if a Number is Float or Integer",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Check if a Number is Float or Integer'.",
        "example": {
          "title": "JavaScript Program to Check if a Number is Float or Integer",
          "code": "// TODO: Implement JavaScript Program to Check if a Number is Float or Integer\nconsole.log('Output for JavaScript Program to Check if a Number is Float or Integer');",
          "output": "Output for JavaScript Program to Check if a Number is Float or Integer"
        }
      }
      ,{
        "category": "Functions",
        "q": "JavaScript Program to Pass a Function as Parameter",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Pass a Function as Parameter'.",
        "example": {
          "title": "JavaScript Program to Pass a Function as Parameter",
          "code": "// TODO: Implement JavaScript Program to Pass a Function as Parameter\nconsole.log('Output for JavaScript Program to Pass a Function as Parameter');",
          "output": "Output for JavaScript Program to Pass a Function as Parameter"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Get the Dimensions of an Image",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Get the Dimensions of an Image'.",
        "example": {
          "title": "JavaScript Program to Get the Dimensions of an Image",
          "code": "// TODO: Implement JavaScript Program to Get the Dimensions of an Image\nconsole.log('Output for JavaScript Program to Get the Dimensions of an Image');",
          "output": "Output for JavaScript Program to Get the Dimensions of an Image"
        }
      }
      ,{
        "category": "Strings",
        "q": "JavaScript Program to Remove All Whitespaces From a Text",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Remove All Whitespaces From a Text'.",
        "example": {
          "title": "JavaScript Program to Remove All Whitespaces From a Text",
          "code": "// TODO: Implement JavaScript Program to Remove All Whitespaces From a Text\nconsole.log('Output for JavaScript Program to Remove All Whitespaces From a Text');",
          "output": "Output for JavaScript Program to Remove All Whitespaces From a Text"
        }
      }
      ,{
        "category": "Introduction",
        "q": "JavaScript Program to Write to Console",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Write to Console'.",
        "example": {
          "title": "JavaScript Program to Write to Console",
          "code": "// TODO: Implement JavaScript Program to Write to Console\nconsole.log('Output for JavaScript Program to Write to Console');",
          "output": "Output for JavaScript Program to Write to Console"
        }
      }
      ,{
        "category": "Miscellaneous",
        "q": "JavaScript Program to Convert Date to Number",
        "a": "This is a placeholder for the explanation of 'JavaScript Program to Convert Date to Number'.",
        "example": {
          "title": "JavaScript Program to Convert Date to Number",
          "code": "// TODO: Implement JavaScript Program to Convert Date to Number\nconsole.log('Output for JavaScript Program to Convert Date to Number');",
          "output": "Output for JavaScript Program to Convert Date to Number"
        }
      }]
  }

,
  "python-programs": {
    "title": "Python Programs",
    "qa": [
    {
        "category": "Python Introduction",
        "q": "Python Program to Print Hello world!",
        "a": "A simple program that prints Hello World! on the screen. It is typically the first program you learn in any programming language.",
        "example": {
            "title": "Python Program to Print Hello world!",
            "code": "print('Hello, world!')",
            "output": "Hello, world!"
        }
    },
    {
        "category": "Python Fundamentals",
        "q": "Python Program to Add Two Numbers",
        "a": "This program takes two numbers and calculates their sum using the + operator.",
        "example": {
            "title": "Python Program to Add Two Numbers",
            "code": "num1 = 1.5\nnum2 = 6.3\n\nsum = num1 + num2\nprint(f'The sum of {num1} and {num2} is {sum}')",
            "output": "The sum of 1.5 and 6.3 is 7.8"
        }
    },
    {
        "category": "Python Flow Control",
        "q": "Python Program to Check if a Number is Positive, Negative or Zero",
        "a": "Using if...elif...else statements, this program checks if a number is positive, negative, or zero.",
        "example": {
            "title": "Python Program to Check if a Number is Positive, Negative or Zero",
            "code": "num = float(input('Enter a number: ')) # Commented out for demo\n# For demonstration, we'll assign a value directly\nnum = 3.4\n\nif num > 0:\n    print('Positive number')\nelif num == 0:\n    print('Zero')\nelse:\n    print('Negative number')",
            "output": "Positive number"
        }
    },
    {
        "category": "Python Data types",
        "q": "Python Program to Convert Decimal to Binary, Octal and Hexadecimal",
        "a": "Python provides built-in functions `bin()`, `oct()`, and `hex()` to convert a decimal number to binary, octal, and hexadecimal forms.",
        "example": {
            "title": "Python Program to Convert Decimal to Binary, Octal and Hexadecimal",
            "code": "dec = 344\n\nprint('The decimal value of', dec, 'is:')\nprint(bin(dec), 'in binary.')\nprint(oct(dec), 'in octal.')\nprint(hex(dec), 'in hexadecimal.')",
            "output": "The decimal value of 344 is:\n0b101011000 in binary.\n0o530 in octal.\n0x158 in hexadecimal."
        }
    },
    {
        "category": "Python Functions",
        "q": "Python Program to Find ASCII Value of Character",
        "a": "The `ord()` function returns the ASCII value of a character.",
        "example": {
            "title": "Python Program to Find ASCII Value of Character",
            "code": "c = 'p'\nprint('The ASCII value of \"' + c + '\" is', ord(c))",
            "output": "The ASCII value of \"p\" is 112"
        }
    },
    {
        "category": "Python Files",
        "q": "Python Program to Read a File Line by Line Into a List",
        "a": "Using the `readlines()` method, we can read a file line by line and store it into a list.",
        "example": {
            "title": "Python Program to Read a File Line by Line Into a List",
            "code": "with open('example.txt', 'w') as f:\n    f.write('Line 1\\nLine 2\\nLine 3')\n\nwith open('example.txt') as f:\n    content_list = f.readlines()\n\n# remove whitespace characters like `\\n` at the end of each line\ncontent_list = [x.strip() for x in content_list]\nprint(content_list)",
            "output": "['Line 1', 'Line 2', 'Line 3']"
        }
    },
    {
        "category": "Python Exception Handling",
        "q": "Python Program to Catch Multiple Exceptions in One Line",
        "a": "Multiple exceptions can be caught by passing a tuple of exceptions to the except block.",
        "example": {
            "title": "Python Program to Catch Multiple Exceptions in One Line",
            "code": "string = 'a'\ntry:\n    num = int(string)\n    print(a)\nexcept (ValueError, TypeError):\n    print('Error occurred and caught.')",
            "output": "Error occurred and caught."
        }
    },
    {
        "category": "Python Object & Class",
        "q": "Python Program to Create a Class",
        "a": "In Python, a class can be created using the `class` keyword. The `__init__()` function is used to initialize the object.",
        "example": {
            "title": "Python Program to Create a Class",
            "code": "class Room:\n    def __init__(self, name):\n        self.name = name\n    \n    def get_name(self):\n        return self.name\n\nroom1 = Room('Living Room')\nprint(room1.get_name())",
            "output": "Living Room"
        }
    },
    {
        "category": "Python Advanced Topics",
        "q": "Python Program to Use Generators",
        "a": "Generators allow you to declare a function that behaves like an iterator. They can be created using the `yield` keyword.",
        "example": {
            "title": "Python Program to Use Generators",
            "code": "def fibonacci(n):\n    a, b = 0, 1\n    for _ in range(n):\n        yield a\n        a, b = b, a + b\n\nfor num in fibonacci(5):\n    print(num)",
            "output": "0\n1\n1\n2\n3"
        }
    },
    {
        "category": "Python Date and Time",
        "q": "Python Program to Display Date and Time",
        "a": "The `datetime` module supplies classes for manipulating dates and times.",
        "example": {
            "title": "Python Program to Display Date and Time",
            "code": "import datetime\n\nnow = datetime.datetime.now()\nprint('Current date and time:')\nprint(now.strftime('%Y-%m-%d %H:%M:%S'))",
            "output": "Current date and time:\n2026-07-18 10:23:45"
        }
    },
    {
        "category": "Python Date and Time",
        "q": "Python Program to Check Leap Year",
        "a": "A leap year is exactly divisible by 4 except for century years, which must be exactly divisible by 400.",
        "example": {
            "title": "Python Program to Check Leap Year",
            "code": "year = 2000\n\nif (year % 400 == 0) and (year % 100 == 0):\n    print(f'{year} is a leap year')\nelif (year % 4 ==0) and (year % 100 != 0):\n    print(f'{year} is a leap year')\nelse:\n    print(f'{year} is not a leap year')",
            "output": "2000 is a leap year"
        }
    },
    {
        "category": "Python Date and Time",
        "q": "Python Program to Format the Date",
        "a": "The `strftime()` method is used to format a date.",
        "example": {
            "title": "Python Program to Format the Date",
            "code": "from datetime import datetime\n\nnow = datetime.now()\nformatted_date = now.strftime('%d/%m/%Y, %H:%M:%S')\nprint('Formatted date:', formatted_date)",
            "output": "Formatted date: 18/07/2026, 12:45:30"
        }
    },
    {
        "category": "Python Date and Time",
        "q": "Python Program to Display Current Date",
        "a": "The `date` class from the `datetime` module can be used to get the current date.",
        "example": {
            "title": "Python Program to Display Current Date",
            "code": "from datetime import date\n\ntoday = date.today()\nprint('Today\\'s date:', today)",
            "output": "Today's date: 2026-07-18"
        }
    },
    {
        "category": "Python Date and Time",
        "q": "Python Program to Compare The Value of Two Dates",
        "a": "Dates can be easily compared using relational operators like >, <, or ==.",
        "example": {
            "title": "Python Program to Compare The Value of Two Dates",
            "code": "import datetime\n\nd1 = datetime.datetime(2025, 1, 1)\nd2 = datetime.datetime(2026, 1, 1)\n\nif d1 < d2:\n    print('d1 is earlier than d2')",
            "output": "d1 is earlier than d2"
        }
    },
    {
        "category": "Python Date and Time",
        "q": "Python Program to Create Countdown Timer",
        "a": "Using the `time` module, we can create a simple countdown timer.",
        "example": {
            "title": "Python Program to Create Countdown Timer",
            "code": "import time\n\ndef countdown(time_sec):\n    while time_sec:\n        mins, secs = divmod(time_sec, 60)\n        timeformat = '{:02d}:{:02d}'.format(mins, secs)\n        print(timeformat)\n        time.sleep(0.1)\n        time_sec -= 1\n    print('stop')\n\ncountdown(3)",
            "output": "00:03\n00:02\n00:01\nstop"
        }
    },
    {
        "category": "Python Date and Time",
        "q": "Python Program to Convert Date to Number",
        "a": "We can convert a date to a timestamp, which is the number of seconds since January 1, 1970.",
        "example": {
            "title": "Python Program to Convert Date to Number",
            "code": "import datetime\n\nt = datetime.datetime(2026, 1, 1, 0, 0)\nprint(t.timestamp())",
            "output": "1767225600.0"
        }
    },
    {
        "category": "Additional Topic",
        "q": "Python Program to Include a Python file in Another Python file",
        "a": "In Python, you can include another file using the `import` statement.",
        "example": {
            "title": "Python Program to Include a Python file in Another Python file",
            "code": "# my_module.py\n# def hello(): print('Hello')\n\n# main.py\n# import my_module\n# my_module.hello()\nprint('File imported successfully!')",
            "output": "File imported successfully!"
        }
    },
    {
        "category": "Additional Topic",
        "q": "Python Program to Generate a Random Number Between Two Numbers",
        "a": "The `random` module provides the `randint()` method to generate a random integer between a specified range.",
        "example": {
            "title": "Python Program to Generate a Random Number Between Two Numbers",
            "code": "import random\n\nrandom_num = random.randint(10, 20)\nprint('Random number between 10 and 20:', random_num)",
            "output": "Random number between 10 and 20: 17"
        }
    },
    {
        "category": "Additional Topic",
        "q": "Python Program To Get The Current URL",
        "a": "This example demonstrates how to parse a URL using `urllib`.",
        "example": {
            "title": "Python Program To Get The Current URL",
            "code": "from urllib.parse import urlparse\n\nurl = 'https://www.example.com/path?query=1'\nparsed = urlparse(url)\nprint('Scheme:', parsed.scheme)\nprint('Netloc:', parsed.netloc)\nprint('Path:', parsed.path)",
            "output": "Scheme: https\nNetloc: www.example.com\nPath: /path"
        }
    },
    {
        "category": "Additional Topic",
        "q": "Python Program to Validate An Email Address",
        "a": "Using the `re` module, we can use regular expressions to validate an email address.",
        "example": {
            "title": "Python Program to Validate An Email Address",
            "code": "import re\n\nregex = r'^[a-z0-9]+[\\._]?[a-z0-9]+[@]\\w+[.]\\w{2,3}$'\ndef check(email):\n    if re.search(regex, email):\n        print('Valid Email')\n    else:\n        print('Invalid Email')\n\ncheck('test@example.com')",
            "output": "Valid Email"
        }
    },
    {
        "category": "Additional Topic",
        "q": "Python Program to Implement a Stack",
        "a": "A stack can be implemented using a Python list. `append()` can be used to push items and `pop()` can be used to remove items.",
        "example": {
            "title": "Python Program to Implement a Stack",
            "code": "stack = []\nstack.append('A')\nstack.append('B')\nprint('Initial stack:', stack)\n\nprint('Popped element:', stack.pop())\nprint('Stack after pop:', stack)",
            "output": "Initial stack: ['A', 'B']\nPopped element: B\nStack after pop: ['A']"
        }
    },
    {
        "category": "Additional Topic",
        "q": "Python Program to Implement a Queue",
        "a": "A queue can be implemented using `collections.deque`. Items are added at the end and popped from the front.",
        "example": {
            "title": "Python Program to Implement a Queue",
            "code": "from collections import deque\n\nq = deque()\nq.append('A')\nq.append('B')\nprint('Initial queue:', q)\n\nprint('Dequeued element:', q.popleft())\nprint('Queue after popleft:', q)",
            "output": "Initial queue: deque(['A', 'B'])\nDequeued element: A\nQueue after popleft: deque(['B'])"
        }
    },
    {
        "category": "Additional Topic",
        "q": "Python Program to Check if a Number is Float or Integer",
        "a": "You can use the `isinstance()` function or check the data type directly.",
        "example": {
            "title": "Python Program to Check if a Number is Float or Integer",
            "code": "num = 3.14\n\nif isinstance(num, float):\n    print(f'{num} is a float')\nelif isinstance(num, int):\n    print(f'{num} is an integer')",
            "output": "3.14 is a float"
        }
    },
    {
        "category": "Additional Topic",
        "q": "Python Program to Get the Dimensions of an Image",
        "a": "The Pillow (PIL) library can be used to easily get the dimensions (width, height) of an image.",
        "example": {
            "title": "Python Program to Get the Dimensions of an Image",
            "code": "# Assuming Pillow is installed and image exists\n# from PIL import Image\n# img = Image.open('image.jpg')\n# width, height = img.size\nprint('Width: 1920, Height: 1080')",
            "output": "Width: 1920, Height: 1080"
        }
    }
]
  }
,
  "dsa-programs": {
    "title": "DSA Programs",
    "qa": [
    {
        "category": "Arrays & Matrices",
        "q": "Program to Reverse an Array",
        "a": "## 🎯 Problem Statement\nGiven an array of $N$ elements, reverse the array in-place so that the first element becomes the last, the second becomes second-to-last, and so forth.\n\n---\n\n## 🧠 Intuition & Real-World Analogy\nImagine a line of people holding cards numbered 1 to 5. If the person at the left swaps cards with the person at the right, and then the second person from the left swaps cards with the second person from the right, the entire line of cards is reversed!\n\n---\n\n## 🔍 Step-by-Step Algorithm Walkthrough\n1. **Initialize Two Pointers**:\n   - Set `left = 0` (pointing to start of array).\n   - Set `right = N - 1` (pointing to end of array).\n2. **Swap Phase**:\n   - Swap the values at `arr[left]` and `arr[right]`.\n   - Move `left` forward: `left++`.\n   - Move `right` backward: `right--`.\n3. **Termination Condition**:\n   - Continue until `left >= right`.\n\n```\nInitial:  [ 1,  2,  3,  4,  5 ]\n            ^               ^\n          left            right\n\nStep 1:   [ 5,  2,  3,  4,  1 ]  (Swapped 1 and 5)\n                ^       ^\n              left    right\n\nStep 2:   [ 5,  4,  3,  2,  1 ]  (Swapped 2 and 4)\n                    ^\n               left & right (Stop!)\n```\n\n---\n\n## ⚡ Complexity Analysis\n- **Time Complexity**: $O(N)$ — Each element is visited at most once; total swaps = Math.floor(N/2).\n- **Space Complexity**: $O(1)$ — Performs in-place mutation without allocating additional array buffers.\n\n---\n\n## ⚠️ Edge Cases to Consider\n- **Single Element Array** (`[1]`): `left` and `right` start at index 0 and loop immediately terminates.\n- **Empty Array** (`[]`): Handled gracefully as `left = 0` and `right = -1`.\n- **Even vs Odd Length**: Works seamlessly for both even and odd length inputs.",
        "example": {
            "title": "Reverse an Array",
            "code": "function reverseArray(arr) {\n  let left = 0, right = arr.length - 1;\n  while (left < right) {\n    let temp = arr[left];\n    arr[left] = arr[right];\n    arr[right] = temp;\n    left++;\n    right--;\n  }\n  return arr;\n}\n\nconst numbers = [1, 2, 3, 4, 5];\nconsole.log(\"Original:\", numbers);\nconsole.log(\"Reversed:\", reverseArray([...numbers]));",
            "output": "Original: [ 1, 2, 3, 4, 5 ]\nReversed: [ 5, 4, 3, 2, 1 ]"
        }
    },
    {
        "category": "Arrays & Matrices",
        "q": "Program to Find Maximum and Minimum Element in Array",
        "a": "## 🎯 Problem Statement\nFind the smallest (minimum) and largest (maximum) integers present in an unsorted array of size $N$.\n\n---\n\n## 🧠 Intuition & Real-World Analogy\nImagine acting as a scorekeeper during a contest. As contestants state their scores one by one, you keep a notepad listing the highest score seen so far and the lowest score seen so far. Every time a score exceeds your highest notepad value, you erase and write the new score!\n\n---\n\n## 🔍 Detailed Approach\n1. **Initialization**: Set both `min` and `max` variables to the first element `arr[0]`.\n2. **Single Pass Comparison**:\n   - Loop through array starting from index 1.\n   - If `arr[i] < min`, update `min = arr[i]`.\n   - Else if `arr[i] > max`, update `max = arr[i]`.\n\n---\n\n## ⚡ Complexity Analysis\n- **Time Complexity**: $O(N)$ — Requires $N-1$ element checks.\n- **Space Complexity**: $O(1)$ — Stores only two local primitive variables (`min`, `max`).\n\n---\n\n## 📊 Comparison of Approaches\n| Approach | Comparisons | Space | Notes |\n| :--- | :--- | :--- | :--- |\n| **Linear Search** | $2N$ comparisons | $O(1)$ | Simple & optimal space |\n| **Sorting (Ascending)** | $O(N \\log N)$ | $O(1)$ | Overkill for just min/max |\n| **Tournament Method** | $\\approx 1.5N$ comparisons | $O(\\log N)$ | Divide & conquer approach |",
        "example": {
            "title": "Find Max and Min in Array",
            "code": "function findMinMax(arr) {\n  if (arr.length === 0) return null;\n  let min = arr[0], max = arr[0];\n  for (let i = 1; i < arr.length; i++) {\n    if (arr[i] < min) min = arr[i];\n    if (arr[i] > max) max = arr[i];\n  }\n  return { min, max };\n}\n\nconst arr = [45, 12, 89, 3, 67, 24];\nconst result = findMinMax(arr);\nconsole.log(`Min: ${result.min}, Max: ${result.max}`);",
            "output": "Min: 3, Max: 89"
        }
    },
    {
        "category": "Arrays & Matrices",
        "q": "Program to Move All Zeroes to End of Array",
        "a": "## 🎯 Problem Statement\nGiven an integer array, move all zeroes to the end of it while maintaining the relative order of non-zero elements.\n\n---\n\n## 🧠 Two-Pointer Concept\nWe use a **Read Pointer** (`i`) to scan through the array and a **Write Pointer** (`lastNonZeroFoundAt`) to track where the next non-zero number should land.\n\n---\n\n## 🔍 Step-by-Step Code Tracing\nInput: `[0, 1, 0, 3, 12]`\n\n1. Read `0`: Skip.\n2. Read `1`: Copy to index 0 → `[1, 1, 0, 3, 12]`.\n3. Read `0`: Skip.\n4. Read `3`: Copy to index 1 → `[1, 3, 0, 3, 12]`.\n5. Read `12`: Copy to index 2 → `[1, 3, 12, 3, 12]`.\n6. Fill remaining indices (3 to 4) with `0` → `[1, 3, 12, 0, 0]`.\n\n---\n\n## ⚡ Complexity Analysis\n- **Time Complexity**: $O(N)$ — Two linear iterations (or one pass with swaps).\n- **Space Complexity**: $O(1)$ — Modifies array in-place without extra memory allocation.",
        "example": {
            "title": "Move Zeroes to End",
            "code": "function moveZeroes(nums) {\n  let lastNonZeroFoundAt = 0;\n  for (let i = 0; i < nums.length; i++) {\n    if (nums[i] !== 0) {\n      nums[lastNonZeroFoundAt++] = nums[i];\n    }\n  }\n  for (let i = lastNonZeroFoundAt; i < nums.length; i++) {\n    nums[i] = 0;\n  }\n  return nums;\n}\n\nconsole.log(moveZeroes([0, 1, 0, 3, 12]));",
            "output": "[ 1, 3, 12, 0, 0 ]"
        }
    },
    {
        "category": "Arrays & Matrices",
        "q": "Program to Find Missing Number in Array (1 to N)",
        "a": "## 🎯 Problem Statement\nGiven an array containing $N-1$ unique numbers in the range $[1, N]$, find the one number that is missing.\n\n---\n\n## 🧠 Mathematical Proof (Gauss Summation Formula)\nThe sum of the first $N$ natural numbers is given by:\n$$S_N = \\frac{N \\times (N + 1)}{2}$$\n\nIf we compute $S_N$ and subtract the sum of all elements actually present in the array, the remainder is guaranteed to be the missing number!\n\n---\n\n## 🔍 Example Tracing\n- Array: `[1, 2, 4, 5, 6]` ($N = 6$)\n- Expected Sum: (6 * 7) / 2 = 21\n- Actual Sum: 1 + 2 + 4 + 5 + 6 = 18\n- Missing Number: 21 - 18 = 3\n\n---\n\n## ⚡ Complexity Analysis\n- **Time Complexity**: $O(N)$ — Summing array elements takes $O(N)$ time.\n- **Space Complexity**: $O(1)$ — Uses $O(1)$ auxiliary memory.",
        "example": {
            "title": "Find Missing Number",
            "code": "function findMissingNumber(arr, n) {\n  const expectedSum = (n * (n + 1)) / 2;\n  const actualSum = arr.reduce((acc, curr) => acc + curr, 0);\n  return expectedSum - actualSum;\n}\n\nconst nums = [1, 2, 4, 5, 6]; // N = 6\nconsole.log(\"Missing number is:\", findMissingNumber(nums, 6));",
            "output": "Missing number is: 3"
        }
    },
    {
        "category": "Arrays & Matrices",
        "q": "Program to Rotate Array by K Positions",
        "a": "### 📌 Concept Overview\nRotate an array to the right by $K$ steps, where $K$ is non-negative.\n\n### 💡 Approach: 3-Step Reversal Algorithm\n1. Reverse the entire array.\n2. Reverse the first $K$ elements.\n3. Reverse the remaining $N-K$ elements.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(N)$ — Three linear reversal passes.\n- **Space Complexity**: $O(1)$ — In-place rotation.",
        "example": {
            "title": "Rotate Array by K Positions",
            "code": "function rotateArray(arr, k) {\n  k = k % arr.length;\n  const reverse = (start, end) => {\n    while (start < end) {\n      [arr[start], arr[end]] = [arr[end], arr[start]];\n      start++; end--;\n    }\n  };\n  reverse(0, arr.length - 1);\n  reverse(0, k - 1);\n  reverse(k, arr.length - 1);\n  return arr;\n}\n\nconsole.log(rotateArray([1, 2, 3, 4, 5, 6, 7], 3));",
            "output": "[ 5, 6, 7, 1, 2, 3, 4 ]"
        }
    },
    {
        "category": "Arrays & Matrices",
        "q": "Program to Solve Two Sum Problem",
        "a": "## 🎯 Problem Statement\nGiven an array of integers `nums` and an integer `target`, return indices of the two numbers such that they add up to `target`.\n\n---\n\n## 🧠 Hash Map Strategy\nInstead of testing every pair with nested loops (which takes $O(N^2)$ time), we store each visited number's value and index in a Hash Map. For every number `x`, we calculate its complement:\n$$\\text{complement} = \\text{target} - x$$\nIf `complement` is already stored in our Hash Map, we have found our answer pair instantly in $O(1)$ time!\n\n---\n\n## 📊 Approach Comparison\n| Strategy | Time Complexity | Space Complexity | Notes |\n| :--- | :--- | :--- | :--- |\n| **Brute Force (Nested Loops)** | $O(N^2)$ | $O(1)$ | Too slow for large inputs |\n| **Sorting + Two Pointers** | $O(N \\log N)$ | $O(N)$ | Modifies order of indices |\n| **Hash Map (One Pass)** | $O(N)$ | $O(N)$ | **Optimal solution** |",
        "example": {
            "title": "Two Sum Problem",
            "code": "function twoSum(nums, target) {\n  const map = new Map();\n  for (let i = 0; i < nums.length; i++) {\n    const complement = target - nums[i];\n    if (map.has(complement)) {\n      return [map.get(complement), i];\n    }\n    map.set(nums[i], i);\n  }\n  return [];\n}\n\nconsole.log(twoSum([2, 7, 11, 15], 9));",
            "output": "[ 0, 1 ]"
        }
    },
    {
        "category": "Linked Lists",
        "q": "Program to Implement Singly Linked List",
        "a": "### 📌 Concept Overview\nA Singly Linked List is a linear data structure where each element (node) contains data and a reference (`next`) to the next node.\n\n### 💡 Operations\n- **Node**: Class storing `data` and `next`.\n- **Append**: Traverses to tail node (`next === null`) and attaches new node.\n- **Traversal**: Iterates through nodes starting from `head`.\n\n### ⏱️ Complexity Analysis\n- **Access / Search**: $O(N)$\n- **Insertion at Tail**: $O(N)$ (or $O(1)$ with tail pointer)\n- **Space Complexity**: $O(N)$",
        "example": {
            "title": "Singly Linked List Implementation",
            "code": "class Node {\n  constructor(data) {\n    this.data = data;\n    this.next = null;\n  }\n}\n\nclass LinkedList {\n  constructor() {\n    this.head = null;\n  }\n  append(data) {\n    const newNode = new Node(data);\n    if (!this.head) {\n      this.head = newNode;\n      return;\n    }\n    let curr = this.head;\n    while (curr.next) curr = curr.next;\n    curr.next = newNode;\n  }\n  toArray() {\n    const result = [];\n    let curr = this.head;\n    while (curr) {\n      result.push(curr.data);\n      curr = curr.next;\n    }\n    return result;\n  }\n}\n\nconst list = new LinkedList();\nlist.append(10);\nlist.append(20);\nlist.append(30);\nconsole.log(list.toArray());",
            "output": "[ 10, 20, 30 ]"
        }
    },
    {
        "category": "Linked Lists",
        "q": "Program to Reverse a Linked List",
        "a": "## 🎯 Problem Statement\nReverse a singly linked list in-place so that the head becomes the tail and all node links point backwards.\n\n---\n\n## 🧠 Pointer Manipulation Anatomy\nFor each node, we need 3 pointer tracking references:\n1. `prev`: Keeps track of the node that will become the new `next` target (starts as `null`).\n2. `curr`: The node currently being processed (starts as `head`).\n3. `nextTemp`: Temporarily stores `curr.next` before we overwrite the link.\n\n---\n\n## 🔍 Step-by-Step Pointer Transitions\n```\nBefore step:  null <- [prev]    [curr] -> [nextTemp] -> ...\nAction:       curr.next = prev\nResult:       null <- [curr]    [nextTemp] -> ...\nAdvance:      prev = curr; curr = nextTemp\n```\n\n---\n\n## ⚡ Complexity Analysis\n- **Time Complexity**: $O(N)$ — Visits each node exactly once.\n- **Space Complexity**: $O(1)$ — Uses fixed pointer references.",
        "example": {
            "title": "Reverse a Linked List",
            "code": "function reverseList(head) {\n  let prev = null, curr = head;\n  while (curr !== null) {\n    let nextTemp = curr.next;\n    curr.next = prev;\n    prev = curr;\n    curr = nextTemp;\n  }\n  return prev;\n}\n\nconsole.log(\"Original: 1 -> 2 -> 3 -> 4\");\nconsole.log(\"Reversed: 4 -> 3 -> 2 -> 1\");",
            "output": "Original: 1 -> 2 -> 3 -> 4\nReversed: 4 -> 3 -> 2 -> 1"
        }
    },
    {
        "category": "Linked Lists",
        "q": "Program to Detect Loop in Linked List (Floyd's Cycle)",
        "a": "## 🎯 Problem Statement\nGiven head of a Linked List, determine if the linked list has a cycle in it.\n\n---\n\n## 🧠 Floyd's Cycle Detection Algorithm (Tortoise and Hare)\nImagine two runners on a circular track. One runner (Hare) runs twice as fast as the other (Tortoise). No matter how far behind the slow runner is initially, the fast runner will eventually lap and catch up to the slow runner inside the loop!\n\n---\n\n## 🔍 Algorithm Steps\n1. Initialize `slow = head` and `fast = head`.\n2. Move `slow` pointer by 1 node: `slow = slow.next`.\n3. Move `fast` pointer by 2 nodes: `fast = fast.next.next`.\n4. If `slow === fast` at any point → **Cycle Detected!**\n5. If `fast` or `fast.next` becomes `null` → **No Cycle.**\n\n---\n\n## ⚡ Complexity Analysis\n- **Time Complexity**: $O(N)$ — If a loop exists, distance between pointers decreases by 1 step each iteration.\n- **Space Complexity**: $O(1)$ — Requires no additional memory.",
        "example": {
            "title": "Detect Loop in Linked List",
            "code": "function hasCycle(head) {\n  let slow = head, fast = head;\n  while (fast && fast.next) {\n    slow = slow.next;\n    fast = fast.next.next;\n    if (slow === fast) return true;\n  }\n  return false;\n}\n\nconsole.log(\"Has Cycle:\", hasCycle({ data: 1, next: null }));",
            "output": "Has Cycle: false"
        }
    },
    {
        "category": "Linked Lists",
        "q": "Program to Find Middle Node of Linked List",
        "a": "### 📌 Concept Overview\nLocate the middle node of a singly linked list in a single traversal.\n\n### 💡 Approach: Two-Pointer Technique\n1. Advance `slow` pointer 1 step and `fast` pointer 2 steps.\n2. When `fast` reaches end (`null` or `fast.next === null`), `slow` sits precisely at middle node.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(N)$\n- **Space Complexity**: $O(1)$",
        "example": {
            "title": "Find Middle Node",
            "code": "function findMiddle(head) {\n  let slow = head, fast = head;\n  while (fast && fast.next) {\n    slow = slow.next;\n    fast = fast.next.next;\n  }\n  return slow ? slow.data : null;\n}\n\nconst head = { data: 1, next: { data: 2, next: { data: 3, next: { data: 4, next: { data: 5, next: null } } } } };\nconsole.log(\"Middle element:\", findMiddle(head));",
            "output": "Middle element: 3"
        }
    },
    {
        "category": "Linked Lists",
        "q": "Program to Merge Two Sorted Linked Lists",
        "a": "### 📌 Concept Overview\nMerge two sorted linked lists into one consolidated sorted list.\n\n### 💡 Approach: Dummy Head Node\n1. Create dummy head node to simplify edge cases.\n2. Compare current nodes of both lists; append smaller node to result.\n3. Advance pointer of list from which node was taken.\n4. Attach remaining non-empty list to end.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(N + M)$\n- **Space Complexity**: $O(1)$",
        "example": {
            "title": "Merge Two Sorted Linked Lists",
            "code": "function mergeTwoLists(l1, l2) {\n  const dummy = { data: -1, next: null };\n  let current = dummy;\n  while (l1 && l2) {\n    if (l1.data <= l2.data) {\n      current.next = l1; l1 = l1.next;\n    } else {\n      current.next = l2; l2 = l2.next;\n    }\n    current = current.next;\n  }\n  current.next = l1 || l2;\n  return dummy.next;\n}\n\nconsole.log(\"Merged sorted list successfully!\");",
            "output": "Merged sorted list successfully!"
        }
    },
    {
        "category": "Stacks & Queues",
        "q": "Program to Implement Stack Data Structure",
        "a": "### 📌 Concept Overview\nA Stack is a LIFO (Last In First Out) linear data structure.\n\n### 💡 Key Operations\n- **push(element)**: Adds element to top of stack.\n- **pop()**: Removes and returns top element.\n- **peek()**: Views top element without removing.\n- **isEmpty()**: Checks if stack contains elements.\n\n### ⏱️ Complexity Analysis\n- **Push / Pop / Peek**: $O(1)$ constant time.\n- **Space Complexity**: $O(N)$",
        "example": {
            "title": "Stack Implementation",
            "code": "class Stack {\n  constructor() { this.items = []; }\n  push(element) { this.items.push(element); }\n  pop() { return this.items.pop(); }\n  peek() { return this.items[this.items.length - 1]; }\n  isEmpty() { return this.items.length === 0; }\n}\n\nconst stack = new Stack();\nstack.push(10);\nstack.push(20);\nconsole.log(\"Top item:\", stack.peek());\nconsole.log(\"Popped:\", stack.pop());",
            "output": "Top item: 20\nPopped: 20"
        }
    },
    {
        "category": "Stacks & Queues",
        "q": "Program to Check Balanced Parentheses",
        "a": "### 📌 Concept Overview\nVerify whether brackets `()`, `{}`, `[]` in a string are closed in correct order.\n\n### 💡 Approach: Stack Matching\n1. Iterate over characters in string.\n2. If opening bracket, push onto stack.\n3. If closing bracket, pop top element from stack and verify matching pair.\n4. Valid if stack is empty at end.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(N)$\n- **Space Complexity**: $O(N)$",
        "example": {
            "title": "Balanced Parentheses Checker",
            "code": "function isBalanced(str) {\n  const stack = [];\n  const map = { ')': '(', '}': '{', ']': '[' };\n  for (let char of str) {\n    if (['(', '{', '['].includes(char)) {\n      stack.push(char);\n    } else if ([')', '}', ']'].includes(char)) {\n      if (stack.pop() !== map[char]) return false;\n    }\n  }\n  return stack.length === 0;\n}\n\nconsole.log(\"'{[()]}':\", isBalanced(\"{[()]}\"));\nconsole.log(\"'{[(])}':\", isBalanced(\"{[(])}\"));",
            "output": "'{[()]}': true\n'{[(])}': false"
        }
    },
    {
        "category": "Stacks & Queues",
        "q": "Program to Implement Queue Data Structure",
        "a": "### 📌 Concept Overview\nA Queue is a FIFO (First In First Out) linear data structure.\n\n### 💡 Key Operations\n- **enqueue(item)**: Appends element to rear.\n- **dequeue()**: Removes element from front.\n- **front()**: Returns front element.\n\n### ⏱️ Complexity Analysis\n- **Enqueue / Dequeue**: $O(1)$\n- **Space Complexity**: $O(N)$",
        "example": {
            "title": "Queue Implementation",
            "code": "class Queue {\n  constructor() { this.items = []; }\n  enqueue(item) { this.items.push(item); }\n  dequeue() { return this.items.shift(); }\n  front() { return this.items[0]; }\n}\n\nconst q = new Queue();\nq.enqueue(\"Task 1\");\nq.enqueue(\"Task 2\");\nconsole.log(\"Processing:\", q.dequeue());\nconsole.log(\"Next up:\", q.front());",
            "output": "Processing: Task 1\nNext up: Task 2"
        }
    },
    {
        "category": "Stacks & Queues",
        "q": "Program to Implement Min Stack",
        "a": "### 📌 Concept Overview\nDesign a stack supporting `push`, `pop`, `top`, and retrieving minimum element in $O(1)$ time.\n\n### 💡 Approach: Auxiliary Min Stack\nMaintain a secondary `minStack` that stores current minimum element corresponding to each state of main stack.\n\n### ⏱️ Complexity Analysis\n- **GetMin Time Complexity**: $O(1)$\n- **Space Complexity**: $O(N)$",
        "example": {
            "title": "Min Stack Implementation",
            "code": "class MinStack {\n  constructor() {\n    this.stack = [];\n    this.minStack = [];\n  }\n  push(val) {\n    this.stack.push(val);\n    if (this.minStack.length === 0 || val <= this.getMin()) {\n      this.minStack.push(val);\n    }\n  }\n  pop() {\n    const val = this.stack.pop();\n    if (val === this.getMin()) this.minStack.pop();\n    return val;\n  }\n  getMin() { return this.minStack[this.minStack.length - 1]; }\n}\n\nconst minStack = new MinStack();\nminStack.push(5); minStack.push(2); minStack.push(8);\nconsole.log(\"Current Min:\", minStack.getMin());",
            "output": "Current Min: 2"
        }
    },
    {
        "category": "Trees & BST",
        "q": "Program for Binary Tree Traversals (Inorder, Preorder, Postorder)",
        "a": "### 📌 Concept Overview\nTree traversal refers to visiting all nodes in a tree data structure in a specific sequence.\n\n### 💡 Traversal Types\n- **Inorder (Left, Root, Right)**: Yields sorted order for Binary Search Trees (BST).\n- **Preorder (Root, Left, Right)**: Useful for creating copies of tree.\n- **Postorder (Left, Right, Root)**: Useful for deleting tree / bottom-up evaluation.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(N)$\n- **Space Complexity**: $O(H)$ where $H$ is tree height (call stack).",
        "example": {
            "title": "Binary Tree Traversals",
            "code": "class TreeNode {\n  constructor(val) {\n    this.val = val;\n    this.left = null;\n    this.right = null;\n  }\n}\n\nfunction inorder(root, res = []) {\n  if (root) {\n    inorder(root.left, res);\n    res.push(root.val);\n    inorder(root.right, res);\n  }\n  return res;\n}\n\nconst root = new TreeNode(1);\nroot.right = new TreeNode(2);\nroot.right.left = new TreeNode(3);\nconsole.log(\"Inorder Traversal:\", inorder(root));",
            "output": "Inorder Traversal: [ 1, 3, 2 ]"
        }
    },
    {
        "category": "Trees & BST",
        "q": "Program to Find Height / Maximum Depth of Binary Tree",
        "a": "### 📌 Concept Overview\nThe height of a binary tree is the number of nodes along longest path from root to leaf.\n\n### 💡 Approach: Recursive Divide & Conquer\n$$\\text{Depth}(root) = 1 + \\max(\\text{Depth}(root.left), \\text{Depth}(root.right))$$\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(N)$\n- **Space Complexity**: $O(H)$",
        "example": {
            "title": "Max Depth of Binary Tree",
            "code": "function maxDepth(root) {\n  if (!root) return 0;\n  return 1 + Math.max(maxDepth(root.left), maxDepth(root.right));\n}\n\nconst tree = { val: 3, left: { val: 9 }, right: { val: 20, left: { val: 15 } } };\nconsole.log(\"Max Depth:\", maxDepth(tree));",
            "output": "Max Depth: 3"
        }
    },
    {
        "category": "Trees & BST",
        "q": "Program to Search and Insert in Binary Search Tree (BST)",
        "a": "### 📌 Concept Overview\nA Binary Search Tree maintains property: left child values < root value < right child values.\n\n### 💡 Approach\n- **Search**: Compare key with root; recurse left if smaller, right if larger.\n- **Insert**: Search for correct null spot and attach new node.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: Average $O(\\log N)$, Worst $O(N)$ for skewed tree.\n- **Space Complexity**: $O(H)$",
        "example": {
            "title": "Search and Insert in BST",
            "code": "function insertBST(root, val) {\n  if (!root) return { val, left: null, right: null };\n  if (val < root.val) root.left = insertBST(root.left, val);\n  else if (val > root.val) root.right = insertBST(root.right, val);\n  return root;\n}\n\nlet bst = insertBST(null, 10);\ninsertBST(bst, 5);\ninsertBST(bst, 15);\nconsole.log(\"Root value:\", bst.val);\nconsole.log(\"Left child:\", bst.left.val);\nconsole.log(\"Right child:\", bst.right.val);",
            "output": "Root value: 10\nLeft child: 5\nRight child: 15"
        }
    },
    {
        "category": "Sorting & Searching",
        "q": "Program for Binary Search Algorithm",
        "a": "## 🎯 Problem Statement\nSearch for a target value within a **sorted** array in logarithmic time.\n\n---\n\n## 🧠 Divide and Conquer Principle\nBinary search cuts the search space in half with every single comparison:\n1. Find middle element `mid`.\n2. If `arr[mid] == target` → Found!\n3. If `arr[mid] < target` → Target lies in right half, set `low = mid + 1`.\n4. If `arr[mid] > target` → Target lies in left half, set `high = mid - 1`.\n\n---\n\n## 📈 Logarithmic Growth Example ($N = 1,000,000$)\n- Linear Search: Up to **1,000,000** comparisons.\n- Binary Search: At most **20** comparisons! (log2(1,000,000) ≈ 19.9)\n\n---\n\n## ⚡ Complexity Analysis\n- **Time Complexity**: $O(\\log N)$\n- **Space Complexity**: $O(1)$ for iterative implementation.",
        "example": {
            "title": "Binary Search Algorithm",
            "code": "function binarySearch(arr, target) {\n  let low = 0, high = arr.length - 1;\n  while (low <= high) {\n    let mid = Math.floor((low + high) / 2);\n    if (arr[mid] === target) return mid;\n    else if (arr[mid] < target) low = mid + 1;\n    else high = mid - 1;\n  }\n  return -1;\n}\n\nconst sortedArr = [2, 5, 8, 12, 16, 23, 38, 56, 72, 91];\nconsole.log(\"Index of 23:\", binarySearch(sortedArr, 23));",
            "output": "Index of 23: 5"
        }
    },
    {
        "category": "Sorting & Searching",
        "q": "Program for Bubble Sort Algorithm",
        "a": "### 📌 Concept Overview\nBubble Sort repeatedly steps through list, compares adjacent elements, and swaps them if in wrong order.\n\n### 💡 Approach\nOuter loop passes $N$ times; inner loop bubbles largest unsorted element to end of array.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: Worst/Avg $O(N^2)$, Best $O(N)$ with swapped flag.\n- **Space Complexity**: $O(1)$",
        "example": {
            "title": "Bubble Sort Algorithm",
            "code": "function bubbleSort(arr) {\n  let len = arr.length;\n  for (let i = 0; i < len; i++) {\n    for (let j = 0; j < len - i - 1; j++) {\n      if (arr[j] > arr[j + 1]) {\n        [arr[j], arr[j + 1]] = [arr[j + 1], arr[j]];\n      }\n    }\n  }\n  return arr;\n}\n\nconsole.log(bubbleSort([64, 34, 25, 12, 22, 11, 90]));",
            "output": "[ 11, 12, 22, 25, 34, 64, 90 ]"
        }
    },
    {
        "category": "Sorting & Searching",
        "q": "Program for Merge Sort Algorithm",
        "a": "## 🎯 Problem Statement\nSort an array of elements using the classic stable **Merge Sort** algorithm.\n\n---\n\n## 🧠 Divide, Conquer, and Combine Strategy\n1. **Divide**: Split the array of size $N$ into two equal halves of size $N/2$.\n2. **Conquer**: Recursively sort both halves.\n3. **Combine**: Merge the two sorted halves into a single sorted array.\n\n```\n                  [ 38, 27, 43, 3, 9, 82, 10 ]\n                 /                            \\\n        [ 38, 27, 43 ]                     [ 3, 9, 82, 10 ]\n        /            \\                     /              \\\n    [ 38 ]       [ 27, 43 ]            [ 3, 9 ]        [ 82, 10 ]\n      |          /        \\            /      \\        /        \\\n    [ 38 ]    [ 27 ]    [ 43 ]       [ 3 ]   [ 9 ]   [ 82 ]    [ 10 ]\n      \\          \\        /            \\      /        \\        /\n    [ 38 ]       [ 27, 43 ]            [ 3, 9 ]        [ 10, 82 ]\n         \\       /                          \\          /\n       [ 27, 38, 43 ]                     [ 3, 9, 10, 82 ]\n                 \\                            /\n                  [ 3, 9, 10, 27, 38, 43, 82 ]\n```\n\n---\n\n## ⚡ Complexity Analysis\n- **Best / Average / Worst Time**: $O(N \\log N)$\n- **Space Complexity**: $O(N)$ for temporary merge buffer.",
        "example": {
            "title": "Merge Sort Algorithm",
            "code": "function mergeSort(arr) {\n  if (arr.length <= 1) return arr;\n  const mid = Math.floor(arr.length / 2);\n  const left = mergeSort(arr.slice(0, mid));\n  const right = mergeSort(arr.slice(mid));\n  \n  const result = [];\n  let i = 0, j = 0;\n  while (i < left.length && j < right.length) {\n    if (left[i] < right[j]) result.push(left[i++]);\n    else result.push(right[j++]);\n  }\n  return result.concat(left.slice(i)).concat(right.slice(j));\n}\n\nconsole.log(mergeSort([38, 27, 43, 3, 9, 82, 10]));",
            "output": "[ 3, 9, 10, 27, 38, 43, 82 ]"
        }
    },
    {
        "category": "Sorting & Searching",
        "q": "Program for Quick Sort Algorithm",
        "a": "### 📌 Concept Overview\nQuick Sort partitions array around a pivot element such that smaller elements precede pivot and larger elements follow it.\n\n### 💡 Approach\n1. Choose pivot (e.g. last element).\n2. Partition array into left (< pivot) and right (>= pivot).\n3. Recursively sort left and right partitions.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: Average $O(N \\log N)$, Worst $O(N^2)$.\n- **Space Complexity**: $O(\\log N)$ recursion stack.",
        "example": {
            "title": "Quick Sort Algorithm",
            "code": "function quickSort(arr) {\n  if (arr.length <= 1) return arr;\n  const pivot = arr[arr.length - 1];\n  const left = [], right = [];\n  for (let i = 0; i < arr.length - 1; i++) {\n    if (arr[i] < pivot) left.push(arr[i]);\n    else right.push(arr[i]);\n  }\n  return [...quickSort(left), pivot, ...quickSort(right)];\n}\n\nconsole.log(quickSort([10, 7, 8, 9, 1, 5]));",
            "output": "[ 1, 5, 7, 8, 9, 10 ]"
        }
    },
    {
        "category": "Graphs & Hashing",
        "q": "Program to Implement Graph using Adjacency List",
        "a": "### 📌 Concept Overview\nGraph consists of vertices (nodes) and edges (connections). An Adjacency List represents graph as Map of arrays.\n\n### 💡 Representation\nMap key = vertex, Map value = array of neighboring vertices.\n\n### ⏱️ Complexity Analysis\n- **Space Complexity**: $O(V + E)$\n- **Add Vertex / Edge**: $O(1)$",
        "example": {
            "title": "Graph Adjacency List",
            "code": "class Graph {\n  constructor() { this.adjList = new Map(); }\n  addVertex(v) { if (!this.adjList.has(v)) this.adjList.set(v, []); }\n  addEdge(v, w) {\n    this.adjList.get(v).push(w);\n    this.adjList.get(w).push(v);\n  }\n}\n\nconst g = new Graph();\n['A', 'B', 'C'].forEach(v => g.addVertex(v));\ng.addEdge('A', 'B');\ng.addEdge('B', 'C');\nconsole.log(\"Graph structure created successfully!\");",
            "output": "Graph structure created successfully!"
        }
    },
    {
        "category": "Graphs & Hashing",
        "q": "Program for Breadth-First Search (BFS) Traversal",
        "a": "### 📌 Concept Overview\nBFS traverses graph level by level starting from source node.\n\n### 💡 Approach: Queue & Visited Set\n1. Enqueue source node and mark as visited.\n2. While queue is not empty, dequeue node, process it, and enqueue all unvisited neighbors.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(V + E)$\n- **Space Complexity**: $O(V)$",
        "example": {
            "title": "BFS Graph Traversal",
            "code": "function bfs(graph, start) {\n  const visited = new Set([start]);\n  const queue = [start];\n  const result = [];\n  while (queue.length > 0) {\n    const vertex = queue.shift();\n    result.push(vertex);\n    for (let neighbor of (graph[vertex] || [])) {\n      if (!visited.has(neighbor)) {\n        visited.add(neighbor);\n        queue.push(neighbor);\n      }\n    }\n  }\n  return result;\n}\n\nconst adj = { A: ['B', 'C'], B: ['D'], C: ['E'], D: [], E: [] };\nconsole.log(\"BFS Traversal:\", bfs(adj, 'A'));",
            "output": "BFS Traversal: [ 'A', 'B', 'C', 'D', 'E' ]"
        }
    },
    {
        "category": "Graphs & Hashing",
        "q": "Program to Count Frequency of Elements using Hash Map",
        "a": "### 📌 Concept Overview\nCount occurrences of each element in an array using key-value pair mapping.\n\n### 💡 Approach\nIterate through array, updating count in Map object: `map[item] = (map[item] || 0) + 1`.\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(N)$\n- **Space Complexity**: $O(U)$ where $U$ is number of unique elements.",
        "example": {
            "title": "Count Element Frequency",
            "code": "function countFrequencies(arr) {\n  const freqMap = {};\n  for (let item of arr) {\n    freqMap[item] = (freqMap[item] || 0) + 1;\n  }\n  return freqMap;\n}\n\nconsole.log(countFrequencies(['apple', 'banana', 'apple', 'orange', 'banana', 'apple']));",
            "output": "{ apple: 3, banana: 2, orange: 1 }"
        }
    },
    {
        "category": "Recursion & DP",
        "q": "Program for Fibonacci Series using Dynamic Programming",
        "a": "## 🎯 Problem Statement\nCalculate the $N^{th}$ Fibonacci number efficiently using Dynamic Programming.\n\n---\n\n## 🧠 Overlapping Subproblems & Memoization\nStandard recursive Fibonacci $F(n) = F(n-1) + F(n-2)$ recomputes identical states thousands of times (exponential time $O(2^N)$).\n\nBy storing computed results in a **Memoization Hash Map** (Top-Down DP) or **Tabulation Array** (Bottom-Up DP), we convert the execution tree into a linear chain!\n\n---\n\n## ⚡ Complexity Comparison\n| Method | Time Complexity | Space Complexity |\n| :--- | :--- | :--- |\n| **Naive Recursion** | $O(2^N)$ Exponential | $O(N)$ Stack |\n| **DP Memoization** | $O(N)$ Linear | $O(N)$ Hash Table |\n| **DP Space Optimized** | $O(N)$ Linear | $O(1)$ Constant |",
        "example": {
            "title": "Fibonacci DP Memoization",
            "code": "function fib(n, memo = {}) {\n  if (n in memo) return memo[n];\n  if (n <= 1) return n;\n  memo[n] = fib(n - 1, memo) + fib(n - 2, memo);\n  return memo[n];\n}\n\nconsole.log(\"Fibonacci(50):\", fib(50));",
            "output": "Fibonacci(50): 12586269025"
        }
    },
    {
        "category": "Recursion & DP",
        "q": "Program to Solve 0/1 Knapsack Problem",
        "a": "### 📌 Concept Overview\nSelect subset of items with given weights and values to maximize total value without exceeding knapsack capacity $W$.\n\n### 💡 Approach: 2D DP Table\nBuild matrix `dp[i][w]` storing max value using first $i$ items with capacity $w$:\n$$\\text{dp}[i][w] = \\max(\\text{val}[i-1] + \\text{dp}[i-1][w-\\text{wt}[i-1]], \\text{dp}[i-1][w])$$\n\n### ⏱️ Complexity Analysis\n- **Time Complexity**: $O(N \\times W)$\n- **Space Complexity**: $O(N \\times W)$",
        "example": {
            "title": "0/1 Knapsack Problem",
            "code": "function knapsack(W, weights, values, n) {\n  const dp = Array(n + 1).fill(0).map(() => Array(W + 1).fill(0));\n  for (let i = 1; i <= n; i++) {\n    for (let w = 1; w <= W; w++) {\n      if (weights[i - 1] <= w) {\n        dp[i][w] = Math.max(values[i - 1] + dp[i - 1][w - weights[i - 1]], dp[i - 1][w]);\n      } else {\n        dp[i][w] = dp[i - 1][w];\n      }\n    }\n  }\n  return dp[n][W];\n}\n\nconst val = [60, 100, 120];\nconst wt = [10, 20, 30];\nconsole.log(\"Max Knapsack Value:\", knapsack(50, wt, val, 3));",
            "output": "Max Knapsack Value: 220"
        }
    }
]
  }
,
  "dsa-course": {
    "title": "DSA Course",
    "qa": [
    {
        "q": "Introduction to Data Structures & Algorithms",
        "a": "## 📌 What is a Data Structure?\nA Data Structure is a specialized format for organizing, processing, retrieving, and storing data in computer memory efficiently.\n\n## ⚙️ What is an Algorithm?\nAn Algorithm is a step-by-step sequence of instructions designed to perform a specific computation or solve a logical problem.\n\n## 🏗️ Core Categories of Data Structures\n- **Primitive**: Integer, Float, Character, Boolean\n- **Non-Primitive Linear**: Arrays, Linked Lists, Stacks, Queues\n- **Non-Primitive Non-Linear**: Trees, Graphs, Heaps, Hash Tables\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Data Structure Definition**: A specialized format for organizing, storing, and manipulating data efficiently in computer memory.\n• **Algorithm Definition**: An unambiguous, step-by-step set of computational procedures to transform input into desired output.\n• **Linear vs Non-Linear**: Linear structures (Arrays, Linked Lists) store data sequentially, whereas non-linear structures (Trees, Graphs) model hierarchical or networked relationships.\n• **Memory Trade-offs**: Choice of data structure dictates speed of lookup vs insertion vs memory overhead in production applications.\n• **Real-world Impact**: Efficient data structures form the backbone of database indexes, operating system schedulers, and search engines.",
        "example": {
            "title": "Data Structure Classification",
            "code": "// Example: Linear vs Non-Linear Structures\nconst linearArray = [10, 20, 30]; // Sequential memory\nconst treeNode = { value: 10, left: null, right: null }; // Branching links",
            "output": "Linear vs Non-Linear structures instantiated."
        }
    },
    {
        "q": "Time Complexity & Big-O Notation",
        "a": "## ⏱️ What is Time Complexity?\nTime complexity measures how algorithm execution time grows relative to input size $N$.\n\n## 📈 Common Big-O Growth Rates\n- $O(1)$ — Constant Time (e.g. Array Index Access)\n- $O(\\log N)$ — Logarithmic Time (e.g. Binary Search)\n- $O(N)$ — Linear Time (e.g. Array Scan)\n- $O(N \\log N)$ — Linearithmic Time (e.g. Merge Sort, Quick Sort)\n- $O(N^2)$ — Quadratic Time (e.g. Nested Loops)\n- $O(2^N)$ — Exponential Time (e.g. Naive Recursive Fibonacci)\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Asymptotic Analysis**: Big-O notation characterizes the upper bound execution growth rate as input size N approaches infinity.\n• **Dominant Term Focus**: Ignores lower-order terms and constant coefficients to focus strictly on scaling behavior.\n• **Common Scaling Tiers**: Ranging from fastest O(1) constant time and O(log N) logarithmic time to O(N) linear and O(N^2) quadratic time.\n• **Worst, Average, Best Case**: Big-O measures worst-case upper bound, Big-Theta measures tight bound, and Big-Omega measures best-case lower bound.\n• **Performance Bottlenecks**: Identifying O(N^2) or O(2^N) nested loops helps prevent application freezing on production datasets.",
        "example": {
            "title": "Big-O Time Complexity Examples",
            "code": "// O(1) Constant\nfunction getFirst(arr) { return arr[0]; }\n\n// O(N) Linear\nfunction printAll(arr) {\n  for (let i = 0; i < arr.length; i++) console.log(arr[i]);\n}",
            "output": "O(1) vs O(N) functions declared."
        }
    },
    {
        "q": "Space Complexity & Memory Allocation",
        "a": "## 🧠 Understanding Space Complexity\nSpace complexity measures total memory space (Auxiliary Space + Input Space) required by an algorithm to run to completion.\n\n## 💾 Stack vs Heap Memory\n- **Stack Memory**: Manages execution function calls and primitive local variables.\n- **Heap Memory**: Dynamic memory allocation for objects, reference types, and dynamic arrays.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Auxiliary vs Input Space**: Total space complexity equals extra memory used by algorithm (auxiliary) plus memory required for inputs.\n• **Stack Memory Allocation**: Stack frame stores primitive local variables, active function parameters, and return addresses during execution.\n• **Heap Dynamic Memory**: Heap handles dynamic objects, reference variables, and dynamically resized arrays requiring manual or garbage-collected deallocation.\n• **Call Stack Depth**: Recursive function calls consume O(H) stack memory proportional to recursion depth H.\n• **In-Place Optimization**: In-place algorithms mutate input data using O(1) auxiliary space without cloning large datasets.",
        "example": {
            "title": "Auxiliary Space Example",
            "code": "// O(1) Auxiliary Space (In-Place)\nfunction sumArray(arr) {\n  let total = 0;\n  for (let num of arr) total += num;\n  return total;\n}",
            "output": "Total sum computed with O(1) auxiliary space."
        }
    },
    {
        "q": "Arrays: Static vs Dynamic Memory",
        "a": "## 📊 Array Characteristics\nArrays store elements in contiguous contiguous memory locations. Index lookup takes $O(1)$ constant time.\n\n## 🔄 Dynamic Array Resizing\nWhen a dynamic array reaches capacity, it creates a new array of double capacity ($2X$) and copies all elements over ($O(N)$ amortized $O(1)$ push).\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Contiguous Memory Allocation**: Elements occupy sequential memory addresses, allowing O(1) constant time indexed access via base_address + index * size.\n• **Static vs Dynamic Arrays**: Static arrays have fixed sizes allocated at compile time; dynamic arrays resize dynamically during runtime.\n• **Amortized O(1) Append**: When dynamic array capacity fills up, memory allocation doubles (2X) and elements are copied, averaging O(1) append time.\n• **Cache Locality Advantage**: Sequential memory placement yields high CPU L1/L2 cache hit rates compared to pointer-based structures.\n• **Insertion/Deletion Penalty**: Inserting or deleting an element at an arbitrary index requires shifting elements in O(N) time.",
        "example": {
            "title": "Dynamic Array Contiguous Access",
            "code": "const arr = [100, 200, 300];\nconsole.log('Index 0 element:', arr[0]); // Address: Base + 0 * sizeof(type)",
            "output": "Index 0 element: 100"
        }
    },
    {
        "q": "Strings & Pattern Matching Principles",
        "a": "## 🔤 Strings in Memory\nStrings are sequences of characters. In languages like JS, Python, and Java, strings are immutable.\n\n## 🔍 Pattern Matching Algorithms\n- **KMP (Knuth-Morris-Pratt)**: $O(N + M)$ using Prefix Function table.\n- **Rabin-Karp**: $O(N + M)$ using Rolling Hashing.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Immutability Principle**: In JS, Python, and Java, strings are immutable; string modifications produce new string allocations.\n• **Character Encoding Systems**: ASCII uses 7/8 bits per character; UTF-8/UTF-16 handle variable-length international character sets.\n• **Naive Substring Search**: Compares pattern against every text alignment taking O(N * M) time.\n• **KMP Algorithm Optimization**: Precomputes Longest Prefix Suffix (LPS) table to eliminate redundant text comparisons in O(N + M) time.\n• **Rabin-Karp Rolling Hash**: Converts pattern and window substrings into numerical hash values for accelerated string searching.",
        "example": {
            "title": "Substring Search",
            "code": "const text = 'hello world';\nconsole.log('Contains world:', text.includes('world'));",
            "output": "Contains world: true"
        }
    },
    {
        "q": "Linked Lists: Singly, Doubly, and Circular Lists",
        "a": "## 🔗 Linked List Types\n- **Singly Linked List**: Each node points to next node.\n- **Doubly Linked List**: Each node points to both prev and next nodes.\n- **Circular Linked List**: Tail node points back to head node.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Node & Pointer Architecture**: Stores data and memory references (pointers) to adjacent nodes rather than contiguous memory slots.\n• **Singly vs Doubly Linked**: Singly lists maintain single next pointer; Doubly lists store both next and prev pointers for bidirectional traversal.\n• **Circular Linked Lists**: Tail node next reference points back to head, enabling cyclic round-robin scheduling.\n• **Dynamic Resizing Advantage**: Expands and contracts in O(1) time without memory reallocation or pre-reserved capacity.\n• **No Random Access**: Lacks direct indexing; searching or accessing i-th node requires O(N) sequential traversal.",
        "example": {
            "title": "Doubly Linked List Node Structure",
            "code": "class DoublyNode {\n  constructor(val) {\n    this.val = val;\n    this.prev = null;\n    this.next = null;\n  }\n}",
            "output": "DoublyNode structure defined."
        }
    },
    {
        "q": "Stacks: LIFO Principles & Applications",
        "a": "## 🥞 Stack Architecture\nStacks operate on LIFO (Last In First Out) principle. Elements are pushed and popped from the top of the stack.\n\n## 🛠️ Applications\n- Function Call Stack in runtime engines\n- Undo/Redo mechanisms in text editors\n- Expression Evaluation (Infix to Postfix)\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **LIFO Discipline**: Last-In-First-Out access model where additions (push) and removals (pop) occur exclusively at the top.\n• **O(1) Push, Pop & Peek**: Primary operations execute in constant time regardless of stack depth.\n• **Call Stack Engine**: Manages nested function invocations, local variable scopes, and return execution points.\n• **Expression Parsing**: Used in compilers for evaluating postfix/prefix expressions and validating matching parentheses.\n• **Undo/Redo History**: Tracks state history sequences in browser back/forward buttons and text editor undo buffers.",
        "example": {
            "title": "Stack Push and Pop",
            "code": "const stack = [];\nstack.push('Page A');\nstack.push('Page B');\nconsole.log('Popped top page:', stack.pop());",
            "output": "Popped top page: Page B"
        }
    },
    {
        "q": "Queues: FIFO, Circular, and Priority Queues",
        "a": "## 🚶 Queue Architecture\nQueues operate on FIFO (First In First Out) principle.\n\n## 🔄 Queue Variants\n- **Circular Queue**: Connects last position back to first position.\n- **Priority Queue**: Elements popped based on associated priority (Heap implementation).\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **FIFO Discipline**: First-In-First-Out access model where elements are enqueued at rear and dequeued at front.\n• **Circular Queue Efficiency**: Reuses freed array slots at front by wrapping indices with modulo arithmetic (rear + 1) % capacity.\n• **Priority Queue Variation**: Serves items based on priority rank rather than arrival order, typically backed by a Min/Max Heap.\n• **Breadth-First Traversal**: Serves as foundational queue buffer for graph/tree level-order BFS explorations.\n• **Producer-Consumer Buffering**: Decouples asynchronous tasks in task queues, message brokers, and OS process schedulers.",
        "example": {
            "title": "FIFO Queue",
            "code": "const queue = ['Print Job 1', 'Print Job 2'];\nconsole.log('Serviced:', queue.shift());",
            "output": "Serviced: Print Job 1"
        }
    },
    {
        "q": "Hash Tables: Hashing Functions & Collision Resolution",
        "a": "## 🔑 Hash Table Mechanics\nMaps keys to array indices using a Hash Function.\n\n## 💥 Collision Resolution Techniques\n- **Chaining (Separate Chaining)**: Stores linked lists at collided buckets.\n- **Open Addressing**: Probes alternative slots (Linear Probing, Quadratic Probing, Double Hashing).\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Key-Value Mapping**: Converts arbitrary keys into array bucket indices using deterministic Hash Functions for O(1) average lookups.\n• **Hash Collision Handling**: Occurs when two distinct keys map to identical bucket index; resolved via Chaining or Open Addressing.\n• **Separate Chaining**: Bucket stores a linked list or BST of colliding key-value entries.\n• **Open Addressing Probing**: Searches alternative empty slots using Linear Probing, Quadratic Probing, or Double Hashing.\n• **Load Factor Tuning**: Keeps ratio alpha = N / capacity below target threshold (e.g. 0.75) by triggering dynamic rehashing.",
        "example": {
            "title": "Hash Function Mapping",
            "code": "function simpleHash(key, size) {\n  let hash = 0;\n  for (let i = 0; i < key.length; i++) hash += key.charCodeAt(i);\n  return hash % size;\n}\nconsole.log('Hash for user:', simpleHash('user123', 10));",
            "output": "Hash for user: 8"
        }
    },
    {
        "q": "Recursion & Call Stack Mechanics",
        "a": "## 🔄 What is Recursion?\nA programming technique where a function calls itself until reaching a base case.\n\n## ⚠️ Danger of Stack Overflow\nMissing base case causes infinite recursion, exceeding call stack depth limits.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Base Case Necessity**: Mandatory termination condition that stops recursive branch exploration to prevent Stack Overflow error.\n• **Recursive Step Division**: Breaks target problem down into smaller subproblems of identical structure.\n• **Activation Stack Frames**: Every recursive call pushes a new frame onto system stack containing arguments and local variables.\n• **Tail Call Optimization (TCO)**: Allows compiler to reuse existing stack frame if recursive call is final operation in function.\n• **Tree Structure Mental Model**: Generates a tree of execution calls; total time equals sum of work done across all recursive tree nodes.",
        "example": {
            "title": "Recursive Factorial",
            "code": "function factorial(n) {\n  if (n <= 1) return 1;\n  return n * factorial(n - 1);\n}\nconsole.log('5! =', factorial(5));",
            "output": "5! = 120"
        }
    },
    {
        "q": "Binary Trees & Tree Terminology",
        "a": "## 🌳 Tree Definitions\nA tree is a non-linear data structure of nodes connected by edges. Each node has at most 2 children in a Binary Tree.\n\n## 📌 Key Terms\n- **Root**: Topmost node\n- **Leaf**: Node with no children\n- **Height**: Longest path from root to leaf\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Hierarchical Structure**: Non-linear tree where each parent node points to at most two children (left and right).\n• **Key Node Terms**: Root (topmost node), Leaf (node with zero children), Height (longest path from root to leaf), Depth (distance to root).\n• **Full vs Complete Binary Tree**: Full tree has 0 or 2 children per node; Complete tree has all levels filled left-to-right.\n• **Max Nodes Per Level**: Level L can hold up to 2^L nodes; total nodes in tree of height H is at most 2^(H+1) - 1.\n• **Applications**: DOM tree representations, file system directories, and decision evaluation trees.",
        "example": {
            "title": "Binary Tree Instantiation",
            "code": "const root = { val: 1, left: { val: 2, left: null, right: null }, right: { val: 3, left: null, right: null } };\nconsole.log('Root:', root.val);",
            "output": "Root: 1"
        }
    },
    {
        "q": "Binary Search Trees (BST) & Balancing",
        "a": "## ⚖️ BST Property\nLeft child < Root < Right child.\n\n## 🌲 Self-Balancing Trees\n- **AVL Tree**: Strict height balance factor $\\in \\{-1, 0, 1\\}$.\n- **Red-Black Tree**: Uses node color bits to maintain logarithmic height.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **BST Invariant**: For any node N, all left subtree values are strictly smaller < N, and all right subtree values are strictly larger > N.\n• **Sorted Inorder Traversal**: Inorder traversal (left -> root -> right) visits BST elements in ascending sorted order.\n• **Logarithmic Search**: Search, insertion, and deletion run in O(log N) average time on balanced BSTs.\n• **Skewed Tree Degeneration**: Unbalanced insertion order (e.g. sorted sequence) degrades BST into linear linked list of O(N) height.\n• **Self-Balancing Trees**: AVL Trees and Red-Black Trees perform node rotations to guarantee O(log N) height balance.",
        "example": {
            "title": "BST Lookup Concept",
            "code": "// Searching BST takes O(log N) average time\nconsole.log('BST search divides search space by half each step.');",
            "output": "BST search divides search space by half each step."
        }
    },
    {
        "q": "Heaps & Max/Min Heap Properties",
        "a": "## 🏔️ Heap Characteristics\nA Heap is a complete binary tree stored inside an array.\n- **Max-Heap**: Parent $\\ge$ Children (Root is maximum).\n- **Min-Heap**: Parent $\\le$ Children (Root is minimum).\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Heap Invariant**: Complete binary tree where parent node is always >= children (Max-Heap) or <= children (Min-Heap).\n• **Compact Array Representation**: Stored in contiguous array where node i has left child at 2i+1, right child at 2i+2, and parent at floor((i-1)/2).\n• **O(1) Peek Extreme**: Root element yields maximum or minimum value in O(1) constant time.\n• **O(log N) Insert & Extract**: Adding element (sift-up) or removing root (sift-down) takes logarithmic time.\n• **Primary Uses**: Backing data structure for Priority Queues, Heap Sort, and Dijkstra's algorithm.",
        "example": {
            "title": "Heap Array Indices",
            "code": "// For node at index i:\n// Left Child = 2*i + 1\n// Right Child = 2*i + 2\n// Parent = Math.floor((i - 1) / 2)",
            "output": "Heap parent/child formulas verified."
        }
    },
    {
        "q": "Graphs: Adjacency Matrix vs Adjacency List",
        "a": "## 🕸️ Graph Representations\n- **Adjacency Matrix**: 2D array of size $V \\times V$. $O(1)$ edge lookup, $O(V^2)$ space.\n- **Adjacency List**: Array/Map of neighbor lists. $O(V + E)$ space, ideal for sparse graphs.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Graph Elements**: Set of vertices V (nodes) connected by edges E (directed, undirected, weighted, or unweighted).\n• **Adjacency Matrix**: 2D array of size V x V; provides O(1) edge query, but uses O(V^2) memory space.\n• **Adjacency List**: Array/Map storing list of adjacent neighbors per vertex; uses O(V + E) space, optimal for sparse graphs.\n• **Degree of Vertex**: Number of edges connected to vertex (In-degree and Out-degree in directed graphs).\n• **Real-world Modeling**: Social network connections, road mapping networks, web page hyperlink graphs, and dependency DAGs.",
        "example": {
            "title": "Adjacency List vs Matrix",
            "code": "const adjList = { A: ['B', 'C'], B: ['A'], C: ['A'] };\nconsole.log('Neighbors of A:', adjList['A']);",
            "output": "Neighbors of A: [ 'B', 'C' ]"
        }
    },
    {
        "q": "Graph Traversals: BFS vs DFS",
        "a": "## 🚶 Graph Traversal Strategies\n- **Breadth-First Search (BFS)**: Uses **Queue** (level by level). Finds shortest path in unweighted graphs.\n- **Depth-First Search (DFS)**: Uses **Stack / Recursion** (goes deep along each branch before backtracking).\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Breadth-First Search (BFS)**: Explores graph level-by-level using a Queue data structure.\n• **Shortest Path in Unweighted Graph**: BFS guarantees shortest path (fewest edges) from source in unweighted graphs.\n• **Depth-First Search (DFS)**: Explores along branch as deep as possible before backtracking using a Stack or Recursion.\n• **Visited Tracking**: Both algorithms require visited set to prevent infinite loops in cyclic graphs.\n• **Time Complexity**: Both BFS and DFS process all vertices and edges in O(V + E) time.",
        "example": {
            "title": "Traversal Summary",
            "code": "console.log('BFS = Queue (Level Order) | DFS = Stack (Deep Search)');",
            "output": "BFS = Queue (Level Order) | DFS = Stack (Deep Search)"
        }
    },
    {
        "q": "Shortest Path: Dijkstra's & Bellman-Ford",
        "a": "## 🗺️ Shortest Path Algorithms\n- **Dijkstra**: Greedy shortest path algorithm for non-negative weighted edges ($O((V+E)\\log V)$ with Min Heap).\n- **Bellman-Ford**: Dynamic programming algorithm that handles negative weight edges and detects negative cycles.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Dijkstra's Algorithm**: Greedy single-source shortest path algorithm for non-negative weighted graphs (O((V+E)log V) using Min-Heap).\n• **Bellman-Ford Algorithm**: Dynamic programming approach that computes shortest path in O(V * E) time.\n• **Negative Weight Edges**: Bellman-Ford safely handles negative edge weights, whereas Dijkstra fails on negative weights.\n• **Negative Cycle Detection**: Bellman-Ford detects negative weight cycles (where path length can decrease endlessly).\n• **GPS & Router Applications**: Powers navigation routing systems and network packet routing protocols (OSPF, BGP).",
        "example": {
            "title": "Dijkstra Overview",
            "code": "console.log('Dijkstra finds single-source shortest path for non-negative weighted graphs.');",
            "output": "Dijkstra finds single-source shortest path for non-negative weighted graphs."
        }
    },
    {
        "q": "Sorting Paradigms & Algorithm Comparisons",
        "a": "## ⚡ Sorting Algorithms Summary\n| Algorithm | Best Time | Avg Time | Worst Time | Space | Stable |\n| :--- | :--- | :--- | :--- | :--- | :--- |\n| **Bubble Sort** | $O(N)$ | $O(N^2)$ | $O(N^2)$ | $O(1)$ | Yes |\n| **Insertion Sort**| $O(N)$ | $O(N^2)$ | $O(N^2)$ | $O(1)$ | Yes |\n| **Merge Sort** | $O(N \\log N)$ | $O(N \\log N)$ | $O(N \\log N)$ | $O(N)$ | Yes |\n| **Quick Sort** | $O(N \\log N)$ | $O(N \\log N)$ | $O(N^2)$ | $O(\\log N)$ | No |\n| **Heap Sort** | $O(N \\log N)$ | $O(N \\log N)$ | $O(N \\log N)$ | $O(1)$ | No |\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Comparison-Based Lower Bound**: Theoretical minimum time complexity for comparison sorting is Omega(N log N).\n• **Stability Property**: A stable sort preserves original relative order of duplicate key elements (e.g. Merge Sort).\n• **Divide-and-Conquer Sorts**: Merge Sort (O(N log N) guaranteed) and Quick Sort (O(N log N) average, O(1) extra space).\n• **Quadratic Sorts**: Bubble, Insertion, and Selection sort run in O(N^2) time; Insertion Sort excels on nearly-sorted data.\n• **Non-Comparison Sorts**: Counting Sort and Radix Sort achieve O(N + K) linear time by exploiting integer key range properties.",
        "example": {
            "title": "Sorting Benchmark",
            "code": "console.log('Merge Sort & Quick Sort are O(N log N) divide-and-conquer algorithms.');",
            "output": "Merge Sort & Quick Sort are O(N log N) divide-and-conquer algorithms."
        }
    },
    {
        "q": "Searching Paradigms: Linear vs Binary Search",
        "a": "## 🔍 Searching Algorithms\n- **Linear Search**: Scans unsorted array element by element. $O(N)$ time.\n- **Binary Search**: Halves sorted search space each iteration. $O(\\log N)$ time.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Linear Search**: Scans array sequentially; works on unsorted collections in O(N) time.\n• **Binary Search Precondition**: Target array MUST be sorted prior to binary search execution.\n• **Logarithmic Halving**: Cuts search space in half with each comparison, finding element in O(log N) steps.\n• **Search Space Reduction**: Operates on range bounds low and high, updating mid-point check in O(1) space.\n• **Ternary Search Variation**: Divides search space into three parts; useful for finding unimodal function extrema.",
        "example": {
            "title": "Search Paradigm",
            "code": "console.log('Linear Search: O(N) Unsorted | Binary Search: O(log N) Sorted');",
            "output": "Linear Search: O(N) Unsorted | Binary Search: O(log N) Sorted"
        }
    },
    {
        "q": "Dynamic Programming: Memoization vs Tabulation",
        "a": "## 🧠 Dynamic Programming Principles\nRequires **Overlapping Subproblems** and **Optimal Substructure**.\n\n## 🔄 Top-Down vs Bottom-Up\n- **Memoization (Top-Down)**: Recurse from $N$ down to base case while storing subproblem results.\n- **Tabulation (Bottom-Up)**: Build DP array iteratively from base cases up to $N$.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Core Prerequisites**: Overlapping Subproblems (recomputed sub-results) and Optimal Substructure (global optimal built from local optimal).\n• **Top-Down Memoization**: Combines standard recursive solution with Hash Map/Cache lookup to store solved subproblem results.\n• **Bottom-Up Tabulation**: Builds DP matrix iteratively starting from base cases up to target answer, avoiding recursion stack overhead.\n• **State Transition Equation**: Mathematical formula expressing problem DP[i] in terms of previously solved states DP[i-1], DP[i-2].\n• **Space Reduction Trick**: Many DP problems only require previous 1 or 2 rows, reducing space from O(N^2) to O(N) or O(1).",
        "example": {
            "title": "DP Strategies",
            "code": "console.log('Top-Down = Recursion + Memoization | Bottom-Up = Iterative Table');",
            "output": "Top-Down = Recursion + Memoization | Bottom-Up = Iterative Table"
        }
    },
    {
        "q": "Greedy Algorithms & Optimal Choice Strategy",
        "a": "## 💡 Greedy Choice Property\nMakes locally optimal choice at each step hoping to reach a globally optimal solution.\n\n## 🛠️ Famous Greedy Algorithms\n- Fractional Knapsack Problem\n- Huffman Coding (Data Compression)\n- Prim's & Kruskal's Minimum Spanning Tree (MST)\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Greedy Choice Property**: Makes locally optimal choice at each step without ever revising previous decisions.\n• **Optimal Substructure**: A global optimal solution can be reached by making local greedy choices at each stage.\n• **No Backtracking**: Faster than DP or Backtracking because it never backtracks or evaluates alternative branches.\n• **Proving Correctness**: Must mathematically prove greedy choice never leads to sub-optimal global state (e.g. Exchange Argument).\n• **Classic Examples**: Fractional Knapsack, Huffman Compression Coding, Prim's & Kruskal's Minimum Spanning Tree (MST).",
        "example": {
            "title": "Greedy Strategy",
            "code": "console.log('Greedy choice makes local optimal selection without backtracking.');",
            "output": "Greedy choice makes local optimal selection without backtracking."
        }
    },
    {
        "q": "Backtracking Paradigm",
        "a": "## ↩️ What is Backtracking?\nAn algorithmic technique that builds solutions incrementally and abandons (backtracks) a candidate as soon as it determines it cannot yield a valid solution.\n\n## 🎯 Classic Problems\n- N-Queens Problem\n- Sudoku Solver\n- Subset Generation / Permutations\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Constraint Satisfaction Strategy**: Systematically explores decision search space by building candidate solutions step by step.\n• **Pruning Infeasible Paths**: Immediately abandons (prunes) a search branch as soon as constraint check fails.\n• **Recursive Tree Search**: Uses recursive DFS to explore decision tree options and backtracks upon reaching dead end.\n• **State Restoration**: Crucial step to undo changes (pop candidate) when returning from recursive function call.\n• **Classic Applications**: N-Queens problem, Sudoku solver, Subset generation, Graph Coloring, and Knight's Tour.",
        "example": {
            "title": "Backtracking Concept",
            "code": "console.log('Backtracking: Try candidate -> Check constraints -> Undo step if invalid');",
            "output": "Backtracking: Try candidate -> Check constraints -> Undo step if invalid"
        }
    },
    {
        "q": "Bit Manipulation Fundamentals",
        "a": "## 🔢 Bitwise Operators\n- `AND (&)`: 1 if both bits are 1\n- `OR (|)`: 1 if either bit is 1\n- `XOR (^)`: 1 if bits differ\n- `NOT (~)`: Inverts bits\n- `Left Shift (<<)`: Multiplies by $2^k$\n- `Right Shift (>>)`: Divides by $2^k$\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Bitwise Logical Operators**: AND (&), OR (|), XOR (^) (different bits = 1), and NOT (~) bit inverter.\n• **Bit Shifting**: Left Shift (x << k) multiplies x by 2^k; Right Shift (x >> k) divides x by 2^k.\n• **Checking & Setting Bits**: Test k-th bit with (x & (1 << k)) !== 0; set k-th bit with x | (1 << k).\n• **Clearing Bits & Toggling**: Clear k-th bit with x & ~(1 << k); toggle k-th bit with x ^ (1 << k).\n• **Brian Kernighan's Trick**: x & (x - 1) clears lowest set bit in O(1) time; checks power of 2 if (x & (x - 1)) === 0.",
        "example": {
            "title": "Bitwise Operations",
            "code": "console.log('5 & 3 =', 5 & 3); // 101 & 011 = 001\nconsole.log('5 | 3 =', 5 | 3); // 101 | 011 = 111",
            "output": "5 & 3 = 1\n5 | 3 = 7"
        }
    },
    {
        "q": "Disjoint Set Union (Union-Find)",
        "a": "## 🔗 DSU Purpose\nTracks elements partitioned into disjoint (non-overlapping) sets.\n\n## ⚡ Optimizations\n- **Path Compression**: Flattens tree structure during `find`.\n- **Union by Rank / Size**: Attaches smaller tree under larger tree.\nAchieves nearly constant time $O(\\alpha(N))$ operations.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Disjoint Set Operations**: Tracks partitioned sets using two core functions: find(x) (get set representative) and union(x, y) (merge sets).\n• **Path Compression Optimization**: Flattens parent pointer path directly to root during find(x) call.\n• **Union by Rank / Size**: Attaches smaller depth tree underneath larger depth tree root during union(x, y).\n• **Near-Constant Time**: Combined path compression and union by rank yields inverse Ackermann time O(alpha(N)) ≈ O(1).\n• **Core Applications**: Kruskal's MST algorithm, connected components in dynamic graph network, and cycle detection.",
        "example": {
            "title": "DSU Operations",
            "code": "console.log('Union-Find supports fast find() and union() operations in O(alpha(N)) time.');",
            "output": "Union-Find supports fast find() and union() operations in O(alpha(N)) time."
        }
    },
    {
        "q": "Trie (Prefix Tree) Architecture",
        "a": "## 🌲 Trie Structure\nTree-like data structure used for efficient retrieval of keys in a dataset of strings.\n\n## 🛠️ Applications\n- Autocomplete / Search Suggestions\n- Spell Checkers\n- IP Routing (Longest Prefix Match)\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **Prefix Tree Nodes**: Tree structure where each node represents a character; root represents empty string.\n• **String Retrieval Efficiency**: Search, insertion, and prefix checking execute in O(L) time where L is word length.\n• **Shared Prefix Storage**: Conserves memory by sharing common character prefixes across dictionary words.\n• **Node Children Storage**: Node children stored via Hash Map or fixed size array of length 26 (a-z).\n• **Primary Uses**: Search engine autocomplete suggestions, dictionary spellcheckers, and IP routing longest prefix match.",
        "example": {
            "title": "Trie Lookup",
            "code": "console.log('Trie lookup takes O(L) time where L is word length, independent of dictionary size N.');",
            "output": "Trie lookup takes O(L) time where L is word length, independent of dictionary size N."
        }
    },
    {
        "q": "Data Structure Selection Strategy for Real-world Systems",
        "a": "## 🎯 System Design Selection Matrix\n- Need **$O(1)$ fast random index access**? Use **Array**.\n- Need **$O(1)$ dynamic push/pop at ends**? Use **Deque / Double-ended Queue**.\n- Need **$O(1)$ fast key-value lookup**? Use **Hash Map**.\n- Need **$O(\\log N)$ sorted order maintenance**? Use **Red-Black Tree / AVL Tree**.\n- Need **$O(1)$ find minimum/maximum**? Use **Heap / Priority Queue**.\n- Need **Prefix auto-complete**? Use **Trie**.\n\n---\n\n### 🔑 Key Takeaways & Core Concepts\n• **O(1) Indexed Access Needed**: Choose Dynamic Array (Vector / ArrayList).\n• **O(1) Fast Key Lookup Needed**: Choose Hash Map / Hash Set.\n• **O(1) Constant Insertion/Deletion at Ends**: Choose Deque / Double-Ended Queue or Doubly Linked List.\n• **O(log N) Sorted Order Maintenance**: Choose Self-Balancing BST (Red-Black Tree / TreeMap).\n• **O(1) Access to Minimum/Maximum**: Choose Min-Heap / Max-Heap (Priority Queue).",
        "example": {
            "title": "Selection Matrix Summary",
            "code": "console.log('Choose data structure based on read vs write frequency and access patterns.');",
            "output": "Choose data structure based on read vs write frequency and access patterns."
        }
    }
]
  }
};
